/* 사이트 공통 스크립트 — 원본은 _src/js/app.js, 빌드가 압축해 assets/js/app.js(.map) 로 낸다. (2026-09-23, 옛 layout.js 정리본 · 2026-09-24 라이브러리 교체)
 *   머리에는 jQuery 만 있고 나머지(부트스트랩 5·Swiper 14·SweetAlert2·GLightbox·toast·reveal·유튜브 배경·주소복사)는 vendor.min.js 로 </body> 앞에 실린다.
 *   지도는 map.js (지도를 쓰는 페이지만). 추천 카드 노출 집계는 recom-stat.js.
 *   여기 있는 것: 헤더·메뉴 · 모달(내용을 ajax 로 받는 것들) · 메인 슬라이더 · 서브 오른쪽 추천여행 흐름 · 스크롤 유틸 · 전화번호 자동 하이픈 · 쿠키 */

// ── 다국어 (2026-10-17 — 언어 페이지 /en/ 등만) ──────────────────────────────────────────────
//   머리(page/_head.sub.php)가 window.YZ_I18N = {lang, home, pv, t: {한국어: 번역}} 을 싣는다 — 한국어 사이트는 없음(글 그대로)
//   __('한국어', {이름: 값}) = 화면 고정 글(파트너센터 다국어 설정 [화면 글] — 빌드가 이 파일의 __('…') 를 모은다: 글은 따옴표 한 쌍 안 그대로, 이어 붙이지 말 것)
//   L10N = 날짜·요일·달·소요시간·금액 — extend/_i18n.php 의 i18n_md·i18n_mdw·i18n_mon·i18n_ym·i18n_dur·i18n_won 과 같은 틀(한국어는 지금 화면 글 그대로)
//   langPost(값) = 창구에 보낼 값에 lang(+ 미리보기 yz_pv) — 창구가 그 언어로 답한다
var I18N = window.YZ_I18N || { lang: 'ko', t: {} };
var W = window.YZ_W || { time: '출항', use: '승선', place: '승선위치', sched: '배시간표', biz: '유람선사', ticket: '승선권', roster: '승선명부', op: '운항', nosail: '결항', today: '오늘 출항', today_no: '금일출항불가', today_ok: '금일정상출항', cond: '해상 상황', cat: '유람선 관광' };   // 용어 사전(머리 _head.sub.php 가 window.YZ_W 로 — extend/_glossary.php words_js, 없으면 유람선 기본값 · 2026-10-23)
// 조사 자동 맞춤(2026-10-23 — extend/_glossary.php josa_jong·josa_pick 과 같은 규칙): 말의 마지막 글자 받침으로 을/를 · 이/가 · 은/는 · 과/와 · 으로/로(ㄹ 받침은 「로」)
//   한글 = 받침 · 숫자 = 읽는 소리(0·3·6 받침 · 1·7·8 ㄹ) · % = 없음 · 영문 대문자뿐 = 글자 이름(L·R ㄹ · M·N 받침) · 그 밖 낱말 끝 l = ㄹ · m·n = 받침 · 뒤 괄호·점은 건너뜀
function josaJong(w) {   // 0 받침 없음 · 8 ㄹ · 1 그 밖 받침
	var m = String(w).replace(/<[^>]*>/g, '').match(/(?:([가-힣])|([0-9A-Za-z%]+))[^가-힣0-9A-Za-z%]*$/);
	if (!m) return 0;
	if (m[1]) { var j = (m[1].charCodeAt(0) - 0xAC00) % 28; return j === 0 ? 0 : (j === 8 ? 8 : 1); }
	var t = m[2], e = t.slice(-1), a = t.replace(/[^A-Za-z]/g, '');
	if (e === '%') return 0;
	if (/[0-9]/.test(e)) return '178'.indexOf(e) >= 0 ? 8 : ('036'.indexOf(e) >= 0 ? 1 : 0);
	if (a !== '' && a.toUpperCase() === a) return 'LR'.indexOf(e) >= 0 ? 8 : ('MN'.indexOf(e) >= 0 ? 1 : 0);
	e = e.toLowerCase();
	return e === 'l' ? 8 : ('mn'.indexOf(e) >= 0 ? 1 : 0);
}
function josaPick(w, p) {   // 맞는 조사만
	var j = josaJong(w), pairs = { '을': '을를', '를': '을를', '이': '이가', '가': '이가', '은': '은는', '는': '은는', '과': '과와', '와': '과와' };
	if (p === '으로' || p === '로') return (j === 0 || j === 8) ? '로' : '으로';
	return Object.prototype.hasOwnProperty.call(pairs, p) ? pairs[p].charAt(j === 0 ? 1 : 0) : p;
}
function josa(w, p) { return w + josaPick(w, p); }
//   __() 는 자리 {이름} 바로 뒤 조사(뒤에 한글이 이어지지 않을 때)를 넣은 값에 맞춘다 — 번역 열쇠(한국어 글)는 그대로
function __(ko, v) {
	var s = (I18N.t && I18N.t[ko]) || ko;
	if (v) s = s.replace(/\{(\w+)\}((?:으로|로|을|를|이|가|은|는|과|와)(?![가-힣]))?/g, function (m, k, p) {
		if (!Object.prototype.hasOwnProperty.call(v, k)) return m;
		var x = String(v[k]);
		return x + (p ? josaPick(x, p) : '');
	});
	return s;
}
function langPost(o) {
	if (I18N.lang !== 'ko') { o.lang = I18N.lang; if (I18N.pv) o.yz_pv = 1; if (I18N.ipv) o.ipv = I18N.ipv; }   // ipv = 파트너센터 미리보기의 저장 전 번역 서명(langPreview)
	return o;
}

// ── 파트너센터 「설정 › 다국어 설정」 오른쪽 미리보기 칸 안(언어 페이지 ?yz_pv=1 — 2026-10-17) ──
//   칸(파트너센터 partner/i18n.php)은 고친 번역을 서명(ipv)해 지금 페이지 주소로 POST(iframe 이 다시 열림) — 서버가 그 값으로 그린다(extend/_i18n.php i18n_over)
//   여기서는: 지금 주소·스크롤 자리를 칸에 알림(다시 열 때 같은 페이지·같은 자리 — POST yz_y) · 새 서명을 받음(만료 2분 — 창구·이동에 실음)
//   · 칸 안에서 사이트 안 링크를 누르면 서명을 실어 POST 로 이동(고친 번역 그대로) — 서명이 없으면 주소에 yz_pv 만 이어 붙임
function langPreview() {
	if (!I18N.pv || window.parent === window) return;
	var P = window.parent, tid = 0;
	pvScrollLocal();
	function at() { P.postMessage({ yz: 'ipv-at', url: location.href.split('#')[0], y: Math.round(window.scrollY || 0) }, '*'); }   // 공개 정보만(주소·스크롤)
	if (I18N.y) window.addEventListener('load', function () { window.scrollTo(0, I18N.y); at(); });
	at();
	window.addEventListener('scroll', function () { clearTimeout(tid); tid = setTimeout(at, 200); }, { passive: true });
	window.addEventListener('message', function (e) {
		var d = e.data;
		if (e.source !== P || !d || typeof d !== 'object') return;
		if (d.yz === 'ipv-tok' && typeof d.t === 'string') I18N.ipv = d.t;
		if (d.yz === 'i18n-find') langFind(d, P);
	});
	if (/[?&]pvopen=ticket(&|$)/.test(location.search)) $(function () {   // 티켓예약 창을 연 채(파트너센터 [화면 글] 「티켓예약 창」 묶음 — 2026-10-17)
		var b = document.querySelector('.lang-header__book');
		if (b) setTimeout(function () { b.click(); }, 300);
	});
	document.addEventListener('click', function (e) {
		var a = e.target.closest('a[href]');
		if (!a || e.defaultPrevented || a.target === '_blank' || a.hasAttribute('data-bs-toggle') || e.ctrlKey || e.metaKey || e.shiftKey) return;
		var u = new URL(a.href, location.href);
		if (u.origin !== location.origin || (u.pathname === location.pathname && u.search === location.search && u.hash)) return;
		if (!u.searchParams.has('yz_pv')) u.searchParams.set('yz_pv', '1');
		e.preventDefault();
		if (!I18N.ipv) { location.href = u.href; return; }
		var f = document.createElement('form');
		f.method = 'post';
		f.action = u.href;
		f.innerHTML = '<input type="hidden" name="ipv">';
		f.firstChild.value = I18N.ipv;
		document.body.appendChild(f);
		f.submit();
	});
}
// 미리보기 칸 안 스크롤은 칸 안에서만(2026-10-17 대표 지적 「미리보기를 누르면 왼쪽 목록이 움직인다」)
//   브라우저의 scrollIntoView·focus 는 칸 밖(파트너센터 화면 · 칸 상자)까지 함께 굴린다(다른 주소의 iframe 도) → 이 페이지의 스크롤 칸 + 창만 직접 옮긴다
//   block start·center·end·nearest · scroll-margin · smooth 그대로 · 고정(fixed) 상자 안 요소는 창을 굴리지 않음
function pvScrollLocal() {
	function off(top, bot, h0, b, mt, mb, lo, hi) {   // 그 칸 안에서 옮길 거리(top·bot = 요소 · lo·hi = 칸 보이는 위·아래)
		if (b === 'center') return Math.round(top + h0 / 2 - (lo + hi) / 2);
		if (b === 'end') return Math.round(bot + mb - hi);
		if (b === 'nearest') { if (top - mt < lo) return Math.round(top - mt - lo); if (bot + mb > hi) return Math.round(Math.min(bot + mb - hi, top - mt - lo)); return 0; }
		return Math.round(top - mt - lo);
	}
	function go(el, o) {
		var b = typeof o === 'boolean' ? (o ? 'start' : 'end') : (o && o.block) || 'start', how = o && typeof o === 'object' && o.behavior === 'smooth' ? 'smooth' : 'auto';
		var cs = getComputedStyle(el), mt = parseFloat(cs.scrollMarginTop) || 0, mb = parseFloat(cs.scrollMarginBottom) || 0, r = el.getBoundingClientRect(), top = r.top, bot = r.bottom, fixed = false;
		for (var p = el.parentElement; p && p !== document.body && p !== document.documentElement; p = p.parentElement) {
			var ps = getComputedStyle(p);
			if (ps.position === 'fixed') fixed = true;
			if (!/(auto|scroll|overlay)/.test(ps.overflowY) || p.scrollHeight <= p.clientHeight + 1) continue;
			var pr = p.getBoundingClientRect(), lo = pr.top + (parseFloat(ps.borderTopWidth) || 0), dd = off(top, bot, r.height, b, mt, mb, lo, lo + p.clientHeight);
			dd = Math.max(-p.scrollTop, Math.min(dd, p.scrollHeight - p.clientHeight - p.scrollTop));
			if (dd) { p.scrollTo({ top: p.scrollTop + dd, behavior: how }); top -= dd; bot -= dd; }
		}
		if (fixed) return;
		var d = off(top, bot, r.height, b, mt, mb, 0, window.innerHeight);
		if (d) window.scrollTo({ top: window.scrollY + d, behavior: how });
	}
	Element.prototype.scrollIntoView = function (o) { go(this, o); };
	var F = HTMLElement.prototype.focus;
	HTMLElement.prototype.focus = function (o) {
		F.call(this, { preventScroll: true });
		if (!(o && o.preventScroll) && this.getClientRects().length) go(this, { block: 'nearest' });
	};
}
// 미리보기 칸 — 이 글이 어떻게 나오나(2026-10-17 대표 결정 「화면 열고 그 자리로」 — 홈페이지 관리 디자인 탭처럼: 그 자리로 내려 잠깐 주황 테, 「찾는 중」·「못 찾음」 안내 없음)
//   파트너센터 다국어 설정 줄 [미리보기]가 그 칸 화면을 열고 {yz:'i18n-find', texts:[번역 · 한국어 …], at:'#구역', co:상품, k} — 글자(·입력칸 안내·단추 이름)에서 찾아 가운데로 내리고 주황 테 2초 → 답 {yz:'i18n-found', n, k}
//   글은 요소의 이어 붙인 글로 비교(색·굵게로 나뉜 글도) · 접힌 칸·닫힌 창 안에만 있으면 펼침(주문서 약관 [보기] · 휴대폰 결제 창 등)
//   보이는 글만(2026-10-17 전수 조사 — 화면낭독기용 숨은 글·닫힌 고르기 칸 안 글은 보이는 글로 세지 않음) · 맞는 정도로 고름: 3 그 글 그대로 · 2 낱말로 · 1 다른 낱말 안 조각(1 만 있으면 못 찾음 — 엉뚱한 자리에 테를 두르지 않게)
//   고르기 칸의 항목(option)은 그 고르기 칸에 테 · 입력칸 안내(placeholder)·단추 글(value)도 보이는 글 · 화면낭독기 이름(aria-label·title·alt)은 마지막에, 보이는 요소일 때만
//   창·늦게 붙는 내용이 있어 못 찾으면 0.3초마다 다시 · 티켓예약 창(pvopen=ticket)은 글이 지금 단계에 없으면 다음 단계로 넘긴다(코스 → 날짜 → 시간 → 인원 — co 가 있으면 그 상품)
//   끝내 없으면(누르면 뜨는 안내창 글 등 — 파트너센터는 그런 줄에 단추를 두지 않는다) at 구역으로만 내리고 조용히 둔다
function langFind(d, P) {
	var ON = 'yz-pv-hl', tries = 0, adv = 0, texts = (d.texts || []).filter(function (t) { return typeof t === 'string' && t.length >= 2; });
	var ticket = /[?&]pvopen=ticket(&|$)/.test(location.search), maxTry = ticket ? 12 : 8;
	if (!document.getElementById('yz-pv-hl-css')) {
		var st = document.createElement('style');
		st.id = 'yz-pv-hl-css';
		st.textContent = '.' + ON + '{outline:2px solid #ff5a1f!important;outline-offset:2px!important;background-color:rgba(255,90,31,.08)!important;transition:outline-color .4s,background-color .4s}'
			+ '.' + ON + '.is-fade{outline-color:transparent!important;background-color:transparent!important}';
		document.head.appendChild(st);
	}
	clearTimeout(langFind.fade);
	var SKIP = /^(SCRIPT|STYLE|NOSCRIPT|TEMPLATE)$/, hidden = [], rev = 0;
	function norm(s) { return String(s || '').replace(/\s+/g, ' '); }
	function clear() { document.querySelectorAll('.' + ON).forEach(function (x) { x.classList.remove(ON, 'is-fade'); }); }
	function scope() {   // 찾을 곳 — 티켓예약 창 화면은 창이 다 열린 뒤 창 안만(뒤 언어 첫 화면의 같은 글을 잡지 않게)
		if (!ticket) return document.body;
		var m = document.querySelector('#mo-cart.show .modal-content'), b = m && m.querySelector('.bk-body');
		return b && b.firstElementChild ? m : null;
	}
	function txt(el) {   // 요소의 글(스크립트·스타일 빼고 이어 붙임) — 색·굵게로 나뉜 글도 한 줄로
		var s = '', w = document.createTreeWalker(el, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, { acceptNode: function (n) { return n.nodeType === 3 ? NodeFilter.FILTER_ACCEPT : (SKIP.test(n.nodeName) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_SKIP); } });
		while (w.nextNode()) s += w.currentNode.nodeValue;
		return norm(s);
	}
	function deep(el, t, out) {   // 그 글을 가진 가장 안쪽 요소들
		var inner = false;
		for (var i = 0; i < el.children.length; i++) { var k = el.children[i]; if (!SKIP.test(k.nodeName) && txt(k).indexOf(t) >= 0) { deep(k, t, out); inner = true; } }
		if (!inner) out.push(el);
	}
	function seen(el) {   // 화면에 보이는 요소 — 크기 없음 · 숨김(visibility) · 잘라 숨김(visually-hidden) · 크기 없는 칸 안은 아님
		if (!el.getClientRects().length) return false;
		var r = el.getBoundingClientRect();
		if (r.width < 3 || r.height < 3) return false;
		if (el.checkVisibility && !el.checkVisibility({ visibilityProperty: true })) return false;   // 투명(opacity)은 보지 않음 — 창이 열리며 잠깐 0 이다(그때 숨은 글로 보고 다음 단계로 넘겨 버렸다)
		for (var p = el; p && p !== document.documentElement; p = p.parentElement) {
			var cs = getComputedStyle(p);
			if (cs.clip && cs.clip !== 'auto') return false;
			if (cs.clipPath && /inset\(50%/.test(cs.clipPath)) return false;
			if (p !== el && (cs.overflow === 'hidden' || cs.overflow === 'clip')) { var q = p.getBoundingClientRect(); if (q.width < 3 || q.height < 3) return false; }
		}
		return true;
	}
	function own(el) { var s = ''; for (var i = 0; i < el.childNodes.length; i++) if (el.childNodes[i].nodeType === 3) s += el.childNodes[i].nodeValue; return norm(s).trim(); }
	var CJK = /[぀-ヿ㐀-鿿豈-﫿]/, LET;
	try { LET = new RegExp('\\p{L}', 'u'); } catch (e) { LET = /[A-Za-zÀ-ɏЀ-ӿ가-힣]/; }
	function qual(el, t) {   // 3 그 글 그대로 · 2 낱말로(긴 글 · 한자·가나 글은 그대로) · 1 다른 낱말 안 조각
		var s = txt(el).trim(), o = own(el), i, ok = false;
		if (s === t || o === t) return 3;
		if (t.length >= 12 || CJK.test(t)) return 2;
		[s, o].some(function (h) {
			for (i = h.indexOf(t); i >= 0; i = h.indexOf(t, i + 1)) {
				if (!(i > 0 && LET.test(h.charAt(i - 1))) && !(i + t.length < h.length && LET.test(h.charAt(i + t.length)))) { ok = true; return true; }
			}
			return false;
		});
		return ok ? 2 : 1;
	}
	function look() {
		clear();
		var root = scope(), hits = [], best = 0, sr = [];
		hidden = [];
		if (!root) return 0;
		texts.some(function (t) {
			var found = [];
			if (txt(root).indexOf(t) >= 0) deep(root, t, found);
			found.forEach(function (el) {
				var tg = el.tagName === 'OPTION' || el.tagName === 'OPTGROUP' ? (el.closest('select') || el) : el;
				if (!seen(tg)) { hidden.push(tg); return; }
				var q = tg === el ? qual(el, t) : 2;
				if (q > best) { best = q; hits = []; }
				if (q === best && hits.indexOf(tg) < 0) hits.push(tg);
			});
			root.querySelectorAll('[placeholder], input[type=submit], input[type=button], [aria-label], [title], [alt]').forEach(function (el) {
				var a = ['placeholder', 'value'].some(function (k) { return norm(el.getAttribute(k)).indexOf(t) >= 0; }), b = !a && ['aria-label', 'title', 'alt'].some(function (k) { return norm(el.getAttribute(k)).indexOf(t) >= 0; });
				if (!(a || b) || !seen(el)) return;
				if (b) { sr.push(el); return; }
				if (best < 2) { best = 2; hits = []; }
				if (best === 2 && hits.indexOf(el) < 0) hits.push(el);
			});
			return best >= 2;
		});
		if (best < 2) hits = [];
		if (!hits.length && sr.length && !hidden.length) hits = sr.slice(0, 3);   // 화면낭독기 이름뿐 — 보이는 그 요소(단추 등)에
		if (!hits.length) return 0;
		hits.forEach(function (el) { el.classList.add(ON); });
		hits[0].scrollIntoView({ block: 'center' });
		langFind.fade = setTimeout(function () {   // 2초 뒤 흐려지며 사라짐
			document.querySelectorAll('.' + ON).forEach(function (x) { x.classList.add('is-fade'); });
			langFind.fade = setTimeout(clear, 450);
		}, 2000);
		return hits.length;
	}
	function reveal() {   // 접힌 칸 안에만 있는 글 — 그 칸을 펼치는 단추(aria-controls · 주문서 약관 [보기] 등)·<details> 를 열기(연 것이 있으면 true)
		if (rev >= 3) return false;
		for (var i = 0; i < hidden.length; i++) {
			for (var p = hidden[i]; p && p !== document.body; p = p.parentElement) {
				if (p.tagName === 'DETAILS' && !p.open) { p.open = true; rev++; return true; }
				if (p.classList.contains('modal') && !p.classList.contains('show') && window.bootstrap && !document.querySelector('.modal.show')) {   // 닫힌 창(휴대폰 주문서 결제 창 등)
					bootstrap.Modal.getOrCreateInstance(p).show(); rev++; return true;
				}
				if (p.hidden && p.id) {
					var b = document.querySelector('[aria-controls="' + (window.CSS && CSS.escape ? CSS.escape(p.id) : p.id) + '"]');
					if (b) { b.click(); rev++; return true; }
				}
			}
		}
		return false;
	}
	var tried = [];   // 티켓예약 창에서 골라 본 날 — 그날 열린 시간이 없으면(오늘 회차가 모두 마감 등) 다음 예약일로
	function advance() {   // 티켓예약 창 — 다음 단계로 한 걸음(누른 것이 있으면 true)
		var m = ticket && document.querySelector('#mo-cart.show .bk-body');
		if (!m || !m.firstElementChild || adv >= 12) return false;
		var b = (d.co && m.querySelector('[data-pick-co="' + d.co + '"]')) || m.querySelector('[data-pick-co]')   // ① 코스 목록 — 그 상품(없으면 코스 전체)
			|| (d.co && m.querySelector('.bk-co[data-co="' + d.co + '"]:not(.is-on)'));   // ② 칩 줄 — 그 상품으로
		if (!b && m.querySelector('.bk-day')) {   // ② 달력 — 아직 안 골라 본 예약일(이 달에 없으면 다음 달)
			b = [].filter.call(m.querySelectorAll('.bk-day.is-week[data-date], .bk-day.is-end[data-date], .bk-day.is-season[data-date]'), function (x) { return tried.indexOf(x.getAttribute('data-date')) < 0; })[0];
			if (b) tried.push(b.getAttribute('data-date'));
			else b = m.querySelector('.bk-cal__nav.is-next:not([disabled])');
		}
		if (!b && m.querySelector('.sch-time')) {   // ③ 열린 첫 시간 → ④ 인원(요금은 창이 불러옴) · 열린 시간이 없으면 날짜로 돌아가 다음 날
			b = m.querySelector('.sch-time[data-gt]:not(.is-off)') || document.querySelector('#mo-cart.show [data-go="1"]');
		}
		if (!b) return false;
		adv++;
		b.click();
		return true;
	}
	(function again() {
		var n = look();
		if (n) { P.postMessage({ yz: 'i18n-found', n: n, k: d.k }, '*'); return; }
		if (reveal()) { setTimeout(again, 250); return; }
		if (advance()) { tries = 0; setTimeout(again, 350); return; }
		if (++tries > maxTry) {
			if (d.at) { var a = document.querySelector(d.at); if (a) a.scrollIntoView({ block: 'start' }); }
			P.postMessage({ yz: 'i18n-found', n: 0, k: d.k }, '*');
			return;
		}
		setTimeout(again, 300);
	})();
}
var L10N = (function () {   // PHP extend/_i18n.php 의 i18n_* 와 같은 틀(2026-10-17 — zh-tw·uz·ru · id 더함)
	var L = I18N.lang, NB = '\u00a0';   // NB = 줄바꿈 안 되는 빈칸(러시아어·우즈베크어 숫자 사이)
	var MON = {
		en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
		ru: ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'],
		uz: ['yanvar', 'fevral', 'mart', 'aprel', 'may', 'iyun', 'iyul', 'avgust', 'sentabr', 'oktabr', 'noyabr', 'dekabr'],
		id: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'] };
	var RU_GEN = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
	var W = { ko: ['일', '월', '화', '수', '목', '금', '토'], en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], zh: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
		'zh-tw': ['週日', '週一', '週二', '週三', '週四', '週五', '週六'], ja: ['日', '月', '火', '水', '木', '金', '土'], vi: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'], id: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
		uz: ['Ya', 'Du', 'Se', 'Ch', 'Pa', 'Ju', 'Sh'], ru: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'] };
	var dows = W[L] || W.ko, CJK = L === 'zh' || L === 'zh-tw' || L === 'ja';
	function comma(n, sep) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep || ','); }
	function sp(a, b) { return (a + (a && b ? ' ' : '') + b).trim(); }
	function ucf(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
	function md(d) {   // 10월 20일 · Oct 20 · 10月20日 · 20/10 · 20 Okt · 20-oktabr · 20 октября
		var m = d.getMonth() + 1, j = d.getDate();
		if (L === 'en') return MON.en[m - 1].slice(0, 3) + ' ' + j;
		if (CJK) return m + '月' + j + '日';
		if (L === 'vi') return j + '/' + m;
		if (L === 'id') return j + ' ' + MON.id[m - 1].slice(0, 3);
		if (L === 'uz') return j + '-' + MON.uz[m - 1];
		if (L === 'ru') return j + NB + RU_GEN[m - 1];
		return m + '월 ' + j + '일';
	}
	function mon(m) {
		if (MON[L]) return MON[L][m - 1];
		if (CJK) return m + '月';
		if (L === 'vi') return 'tháng ' + m;
		return m + '월';
	}
	return {
		dows: dows,
		calDows: (L === 'zh' || L === 'zh-tw') ? ['日', '一', '二', '三', '四', '五', '六'] : L === 'en' ? ['S', 'M', 'T', 'W', 'T', 'F', 'S'] : dows,
		md: md,
		mdw: function (d) { var w = dows[d.getDay()]; return (L === 'en' || L === 'vi' || L === 'id' || L === 'uz' || L === 'ru') ? w + ', ' + md(d) : md(d) + ' (' + w + ')'; },
		mon: mon,
		ym: function (y, m) {
			if (L === 'en' || L === 'id') return mon(m) + ' ' + y;
			if (L === 'uz' || L === 'ru') return ucf(mon(m)) + ' ' + y;
			if (CJK) return y + '年' + m + '月';
			if (L === 'vi') return 'Tháng ' + m + '/' + y;
			return y + '년 ' + m + '월';
		},
		dur: function (min) {
			var h = Math.floor(min / 60), n = min % 60;
			if (L === 'en') return 'approx. ' + sp(h ? h + ' h' : '', n ? n + ' min' : '');
			if (L === 'zh') return '约' + (h ? h + '小时' : '') + (n ? n + '分钟' : '');
			if (L === 'zh-tw') return '約' + (h ? h + '小時' : '') + (n ? n + '分鐘' : '');
			if (L === 'ja') return '約' + (h ? h + '時間' : '') + (n ? n + '分' : '');
			if (L === 'vi') return 'khoảng ' + sp(h ? h + ' giờ' : '', n ? n + ' phút' : '');
			if (L === 'id') return 'sekitar ' + sp(h ? h + ' jam' : '', n ? n + ' menit' : '');
			if (L === 'uz') return 'taxminan ' + sp(h ? h + ' soat' : '', n ? n + ' daqiqa' : '');
			if (L === 'ru') return 'около ' + sp(h ? h + NB + 'ч' : '', n ? n + NB + 'мин' : '');
			return '약 ' + (h ? h + '시간' : '') + (h && n ? ' ' : '') + (n ? n + '분' : '');
		},
		won: function (n) {
			if (L === 'en') return 'KRW ' + comma(n);
			if (L === 'zh') return comma(n) + '韩元';
			if (L === 'zh-tw') return comma(n) + '韓元';
			if (L === 'ja') return comma(n) + 'ウォン';
			if (L === 'vi') return comma(n, '.') + ' KRW';
			if (L === 'id') return 'KRW ' + comma(n, '.');
			if (L === 'uz' || L === 'ru') return comma(n, NB) + NB + 'KRW';
			return comma(n) + '원';
		}
	};
})();

$(function () {
	init();
	logoFit();

	// 「맨 위로」 — 700px 넘게 내렸을 때만. 숨었을 때는 보이지도 눌리지도 않게(2026-10-02: 투명하게만 숨겨 휴대폰 메인 비주얼 소리 단추 자리에서 누름을 가져갔다)
	floatBtns();   // 떠 있는 「티켓예약」 + 맨 위로(2026-10-08 대표 지시 · 10-11 할인상품검색 → 티켓예약)
	deskNote();   // 휴대폰인데 데스크톱 버전으로 보면 안내(2026-10-12)
	designLive();   // 파트너센터 디자인 탭 「현재 사이트」 칸 안에서만(2026-10-14)
	vendorLive();   // 파트너센터 가맹점 수정 오른쪽 미리보기 칸 안에서만(2026-10-15 — page/vendor-preview.php)
	sideRecommend();   // 서브 페이지 오른쪽 추천여행 흐름 — PC 위로 · 휴대폰 왼쪽으로(2026-10-14)
	langPreview();   // 파트너센터 다국어 설정 미리보기 칸 안에서만(2026-10-17)
});

// ── 서브 페이지 오른쪽 추천여행 — 벤토 흐름 (2026-10-14 대표 지시 · 마크업·배치 page/_recommend_section.php · 모양 _src/css/recommend-section.css) ──
//   PC(1200 이상) = 위로 · 1199 이하(휴대폰·태블릿 — 1x1 3줄 격자) = 왼쪽으로, 초당 30px, 끝없이 — 메인 추천여행 흐르는 줄(page/main/_common/_core.js flows)과 같은 방식:
//   원본 묶음(카드 전부 한 번)을 「칸 길이 + 관성으로 미끄러질 수 있는 거리」보다 길어질 만큼 이어 붙인 「한 바퀴」(shift)를 두 번, 자리(pos)는 늘 0 ≤ pos < shift 로 접는다
//   휴대폰 한 바퀴 = 카드 수가 3의 배수가 되게 묶음을 1·3 번(3줄 격자에서 같은 모습이 되풀이되게) · Web Animations(transform 만)라 페이지가 바빠도 안 끊김
//   마우스를 올려도 흐름(대표 지시) · 누르면(손가락을 대면) 멈춤 · 흐르는 방향으로 6px 넘게 끌면 따라옴(그 누름은 열지 않음) · 놓으면 관성 · 놓고 1.5초 뒤 다시 흐름
//   휴대폰에서 세로로 밀면 페이지 스크롤(touch-action: pan-y) · 끌지 않고 누르면 링크 그대로 — 추천여행 상세 창(coursePanel)
//   상세 창·창(모달)이 열려 있을 때 · 화면 밖 · 다른 탭 · 키보드 초점이면 쉼 · 움직임 줄이기 설정이면 흐르지 않고 칸 안 스크롤(.is-static)
//   복사본 묶음 = 화면용(aria-hidden · 링크 Tab 제외 · 노출 집계 표지 data-vd·data-it 뗌)
function sideRecommend() {
	var root = document.querySelector('[data-rsb]');
	if (!root) return;
	var view = root.querySelector('.rsb__view'), track = root.querySelector('.rsb__track');
	var first = track && track.querySelector('.rsb__block');
	if (!first || !first.children.length) return;
	var PC = window.matchMedia('(min-width: 1200px)');
	var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	var GAP = 8, SPEED = 30, RESUME = 1500;
	var FRICTION = 3, MAX_V = 4000, MAX_GLIDE = 1900;
	var EASE = 'cubic-bezier(0.23, 1, 0.32, 1)', EASE_K = 4.35;
	if (REDUCE || !track.animate) { root.classList.add('is-static'); return; }

	var vert = true, shift = 0, pos = 0, anim = null, glide = null;   // vert = 위로(PC) / 왼쪽으로(휴대폰)
	function tf(p) { return vert ? 'translate3d(0,' + (-p) + 'px,0)' : 'translate3d(' + (-p) + 'px,0,0)'; }
	function setPos(p) { pos = shift > 0 ? ((p % shift) + shift) % shift : p; track.style.transform = tf(pos); }
	function cur() {   // 지금 화면의 transform 값(애니메이션 중이면 그 순간 값)
		var m = getComputedStyle(track).transform;
		if (!m || m === 'none') return 0;
		var v = m.slice(m.indexOf('(') + 1, -1).split(',');
		var i3 = m.indexOf('matrix3d') === 0;
		return parseFloat(vert ? (i3 ? v[13] : v[5]) : (i3 ? v[12] : v[4])) || 0;
	}
	function freeze() {
		if (!anim && !glide) return;
		var c = cur();
		if (anim) { anim.cancel(); anim = null; }
		if (glide) { glide.cancel(); glide = null; }
		setPos(-c);
	}

	var held = false, drag = null, seen = true, focus = false, over = false, heldT = null;
	function sync() {
		var run = shift > 0 && seen && !held && !drag && !glide && !focus && !over && !document.hidden;
		if (run && !anim) {
			var d = shift / SPEED * 1000;
			anim = track.animate([{ transform: tf(0) }, { transform: tf(shift) }], { duration: d, iterations: Infinity, easing: 'linear' });
			anim.currentTime = pos / shift * d;   // 멈췄던 자리부터
		} else if (!run && anim) freeze();
	}
	function holdLater() { clearTimeout(heldT); heldT = setTimeout(function () { held = false; sync(); }, RESUME); }

	// 누름·끌기 — 흐르는 방향 좌표(at)로
	var moved = false, raf = 0;
	function at(e) { return vert ? e.clientY : e.clientX; }
	function render() { raf = 0; if (drag && drag.on) setPos(drag.pos - (drag.c - drag.s)); }
	view.addEventListener('dragstart', function (e) { e.preventDefault(); });   // 사진·링크를 끌어 옮기는 브라우저 기본 동작을 막는다
	view.addEventListener('pointerdown', function (e) {
		if (!shift || (e.pointerType === 'mouse' && e.button !== 0)) return;
		clearTimeout(heldT);
		held = true;
		drag = { id: e.pointerId, s0: at(e), s: 0, c: at(e), pos: 0, on: false, pts: [] };
		moved = !!glide;   // 미끄러지던 것을 눌러 세운 것은 「멈춤」 — 열지 않음
		freeze();
		sync();
	});
	view.addEventListener('pointermove', function (e) {
		if (!drag || e.pointerId !== drag.id) return;
		if (!drag.on) {
			if (Math.abs(at(e) - drag.s0) < 6) return;
			drag.on = true;
			moved = true;
			drag.s = at(e);   // 6px 넘은 지점을 시작점으로 — 처음에 튀지 않게
			drag.pos = pos;
			root.classList.add('is-drag');
			try { view.setPointerCapture(e.pointerId); } catch (err) {}
		}
		drag.c = at(e);
		var now = performance.now();
		drag.pts.push([now, drag.c]);
		while (drag.pts.length > 2 && now - drag.pts[0][0] > 100) drag.pts.shift();   // 마지막 0.1초 — 놓을 때 빠르기
		if (!raf) raf = requestAnimationFrame(render);
	});
	function glideTo(v) {   // 관성 — v = 놓은 빠르기(px/초, + 는 흐르는 쪽)
		var av = Math.min(Math.abs(v), MAX_V);
		var T = Math.max(0.3, Math.min(2, Math.log(av / 10) / FRICTION));
		var D = Math.min(av * T / EASE_K, MAX_GLIDE) * (v > 0 ? 1 : -1);
		var p0 = pos;
		if (p0 + D < 0) p0 += shift;   // 거꾸로 미끄러질 길 — 한 바퀴 뒤 같은 모습에서 출발
		var p1 = p0 + D;
		var g = glide = track.animate([{ transform: tf(p0) }, { transform: tf(p1) }], { duration: T * 1000, easing: EASE, fill: 'forwards' });
		g.onfinish = function () { if (glide !== g) return; glide = null; g.cancel(); setPos(p1); sync(); };
	}
	function endDrag(e, fling) {
		if (!drag || e.pointerId !== drag.id) return;
		var d = drag, pts = d.pts, now = performance.now(), v = 0;
		drag = null;
		root.classList.remove('is-drag');
		if (raf) { cancelAnimationFrame(raf); raf = 0; }
		if (d.on) setPos(d.pos - (d.c - d.s));
		if (fling && d.on && pts.length > 1 && now - pts[pts.length - 1][0] < 80) {   // 끌다가 멈춘 채 놓으면 관성 없음
			var dt = (pts[pts.length - 1][0] - pts[0][0]) / 1000;
			if (dt > 0) v = -(pts[pts.length - 1][1] - pts[0][1]) / dt;
		}
		holdLater();   // 놓고 1.5초 뒤 다시 흐름(대표 결정)
		if (Math.abs(v) >= 40) glideTo(v); else sync();
	}
	view.addEventListener('pointerup', function (e) { endDrag(e, true); });
	view.addEventListener('pointercancel', function (e) { endDrag(e, false); });   // 휴대폰 세로 스크롤로 넘어감 등
	view.addEventListener('click', function (e) {   // 끌고 난 뒤의 클릭은 상세로 가지 않는다(상세 창 처리 coursePanel 보다 먼저)
		if (!moved) return;
		moved = false;
		e.preventDefault();
		e.stopPropagation();
	}, true);
	view.addEventListener('focusin', function (e) {   // 키보드 초점만 — 마우스로 누른 뒤 남는 초점으로 멈춰 있지 않게
		try { focus = e.target.matches(':focus-visible'); } catch (err) { focus = false; }
		sync();
	});
	view.addEventListener('focusout', function (e) { focus = !!(e.relatedTarget && view.contains(e.relatedTarget)); sync(); });
	document.addEventListener('visibilitychange', sync);
	['show.bs.offcanvas', 'show.bs.modal'].forEach(function (n) { document.addEventListener(n, function () { over = true; sync(); }); });   // 상세 창·창이 열리면 쉼
	['hidden.bs.offcanvas', 'hidden.bs.modal'].forEach(function (n) { document.addEventListener(n, function () { over = !!document.querySelector('.offcanvas.show, .modal.show'); sync(); }); });

	function cloneBlock() {
		var c = first.cloneNode(true);
		c.setAttribute('aria-hidden', 'true');
		c.querySelectorAll('[data-vd]').forEach(function (n) { n.removeAttribute('data-vd'); n.removeAttribute('data-it'); });
		c.querySelectorAll('a').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
		return c;
	}
	var sig = '';
	function build() {
		freeze();
		track.querySelectorAll('.rsb__block[aria-hidden]').forEach(function (n) { n.remove(); });
		track.style.transform = '';
		vert = PC.matches;
		var n = first.children.length, lap, per, len;
		if (vert) {   // 한 바퀴 = 원본 묶음 높이(+ 사이 8)
			lap = first.offsetHeight + GAP;
			per = 1;
			len = view.clientHeight;
		} else {   // 3줄 격자 — 카드 수가 3의 배수가 되게 묶음 1·3 번, 줄 폭 = 1x1 + 8
			per = n % 3 ? 3 : 1;
			lap = n * per / 3 * (first.firstElementChild.offsetWidth + GAP);
			len = view.clientWidth;
		}
		if (!lap) { shift = 0; return; }
		var k = Math.max(1, Math.ceil((len + MAX_GLIDE) / lap));   // 한 바퀴를 k 번 → 그 길이를 두 번
		for (var i = 1; i < k * per * 2; i++) track.appendChild(cloneBlock());
		shift = k * lap;
		sig = vert + '|' + lap;
		setPos(pos);
		sync();
	}
	build();
	if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { seen = es[es.length - 1].isIntersecting; sync(); }).observe(view);
	var lastW = window.innerWidth, lastH = window.innerHeight, rt = null;
	window.addEventListener('resize', function () {
		if (window.innerWidth === lastW && (!PC.matches || window.innerHeight === lastH)) return;   // 휴대폰 주소창이 오르내릴 때(높이만 바뀜)는 그대로
		lastW = window.innerWidth;
		lastH = window.innerHeight;
		clearTimeout(rt);
		rt = setTimeout(function () { pos = 0; build(); }, 200);
	});
	window.addEventListener('load', function () {   // 크기가 바뀌었으면(늦은 글꼴 등) 다시
		var lap = PC.matches ? first.offsetHeight + GAP : first.children.length * (first.children.length % 3 ? 3 : 1) / 3 * (first.firstElementChild.offsetWidth + GAP);
		if (PC.matches + '|' + lap !== sig) build();
	});
}

// ── 디자인 실시간 미리보기 (2026-10-14 대표 결정 — 파트너센터 「홈페이지 관리 > 디자인」 오른쪽 「현재 사이트」) ──
//   파트너센터 탭이 이 페이지를 칸(iframe, 주소 ?yz_pv=1)에 띄우고 postMessage 로 보낸다(보낸 곳 = 파트너센터 주소만 — 로컬 시험은 localhost):
//     {yz:'theme', t:디자인 값}  → page/ajax_theme.php 가 머리와 같은 계산으로 CSS → <style id="site-theme"> 를 바꿈(저장 전 값 — 손님 화면은 그대로)
//     {yz:'hl', v:'--ty-title-ls'} → 그 글자 스타일(또는 --메뉴-요소-ls)을 쓰는 글자에 주황 테 + 화면에 없으면 첫 글자로 내림 · 답 {yz:'hl', n:개수}
//       찾는 법 = 그 자간 변수에 표지 값을 잠깐 넣고 계산된 자간이 그 값인 글자(가장 바깥만) — 빌드가 편 --ty 규칙은 늘 자간까지 쓴다(_src/build.mjs tyExpand)
//     {yz:'sec', sel:'.sec-course'} → 그 섹션으로 내리고 잠깐 테
//   칸 안에서 다른 페이지로 가도 이어서(같은 사이트 링크에 yz_pv=1) · ?yz_first=1 = 목록의 첫 상세로(코스상세·추천여행 상세·공지 보기 미리보기)
//   추천여행 노출 집계·메인팝업은 PHP 가 끈다(extend/_theme.php YZ_PV)
function designLive() {
	var q = location.search;
	if (window.parent === window || !/[?&]yz_pv=1(&|$)/.test(q)) return;
	var OK = /^(https:\/\/partner\.yozuum\.com|http:\/\/(localhost|127\.0\.0\.1)(:\d+)?)$/;
	var MARK = '3.37px', ON = 'yz-pv-hl', busy = false, pend = null, from = '*';
	document.documentElement.classList.add('is-yz-pv');
	if (/[?&]yz_first=1(&|$)/.test(q)) {   // 목록 → 첫 상세(카드가 늦게 붙는 목록은 조금 기다린다)
		var tries = 0, t = setInterval(function () {
			var a = document.querySelector('a.cl-card, .rc-item a[href], #notice a[href*="wr_id="]');
			if (a || ++tries > 30) { clearInterval(t); if (a) location.replace(pv(a.href)); }
		}, 100);
		return;
	}
	function pv(u) {   // 같은 사이트 주소에 yz_pv=1
		try { var x = new URL(u, location.href); if (x.origin !== location.origin) return u; x.searchParams.set('yz_pv', '1'); return x.href; } catch (e) { return u; }
	}
	document.addEventListener('click', function (e) {
		var a = e.target.closest && e.target.closest('a[href]');
		if (a && !e.defaultPrevented && a.target !== '_blank' && /^https?:/.test(a.href)) a.href = pv(a.href);
	}, true);
	var st = document.createElement('style');
	st.textContent = '.' + ON + '{outline:2px solid #ff5a1f!important;outline-offset:2px!important;}.is-yz-pv .' + ON + '.yz-pv-flash{outline-width:3px!important}';
	document.head.appendChild(st);
	function say(o) { try { window.parent.postMessage(o, from); } catch (e) {} }
	function themeCss(r) {
		var s = document.getElementById('site-theme');
		if (!s) { s = document.createElement('style'); s.id = 'site-theme'; document.head.appendChild(s); }
		s.textContent = (r && r.css) || '';
		if (r && r.links && !document.getElementById('yz-pv-pret')) {
			var m = /href="([^"]+)"/.exec(r.links);
			if (m) { var l = document.createElement('link'); l.id = 'yz-pv-pret'; l.rel = 'stylesheet'; l.href = m[1]; document.head.appendChild(l); }
		}
	}
	function send() {   // 한 번에 하나 — 그사이 온 값은 마지막 것만
		var t = pend;
		pend = null;
		busy = true;
		$.post('/page/ajax_theme.php', { t: JSON.stringify(t) }, null, 'json').done(themeCss).always(function () {
			busy = false;
			if (pend) send(); else hl(cur, false);   // 크기가 바뀌면 테 자리도 바뀐다
		});
	}
	var cur = null;
	function hl(v, scroll) {
		cur = v;
		document.querySelectorAll('.' + ON).forEach(function (e) { e.classList.remove(ON); });
		if (!v || !/^--[a-z0-9-]+-ls$/.test(v)) return 0;
		var mk = document.createElement('style');
		mk.textContent = ':root{' + v + ':' + MARK + '}';
		document.head.appendChild(mk);
		var hit = function (e) { return e && e.nodeType === 1 && getComputedStyle(e).letterSpacing === MARK; }, out = [];
		document.body.querySelectorAll('*').forEach(function (e) {
			if (hit(e) && !hit(e.parentElement) && e.getClientRects().length && getComputedStyle(e).visibility !== 'hidden') out.push(e);
		});
		mk.remove();
		out.forEach(function (e) { e.classList.add(ON); });
		if (scroll && out.length) {
			var vh = window.innerHeight, seen = out.some(function (e) { var r = e.getBoundingClientRect(); return r.top >= 0 && r.bottom <= vh && r.width > 0; });   // 다 보이는 것이 하나라도 있으면 그대로(끝에 걸친 것은 안 본 것으로)
			if (!seen) {
				var f = out.filter(function (e) { return e.getBoundingClientRect().width > 0; })[0] || out[0];
				var y = f.getBoundingClientRect().top + window.pageYOffset - vh / 3;
				window.scrollTo({ top: Math.max(0, y), behavior: 'auto' });
			}
		}
		return out.length;
	}
	window.addEventListener('message', function (e) {
		if (!OK.test(e.origin) || !e.data || typeof e.data !== 'object') return;
		from = e.origin;
		var d = e.data;
		if (d.yz === 'theme' && d.t && typeof d.t === 'object') { pend = d.t; if (!busy) send(); }
		else if (d.yz === 'hl') say({ yz: 'hl', v: d.v || '', n: hl(d.v || null, d.scroll !== false) });
		else if (d.yz === 'sec' && typeof d.sel === 'string' && /^[.#][a-z][a-z0-9_-]*$/i.test(d.sel)) {
			hl(null);
			var s = document.querySelector(d.sel);
			if (s) {
				window.scrollTo({ top: Math.max(0, s.getBoundingClientRect().top + window.pageYOffset - 140), behavior: 'auto' });
				s.classList.add(ON, 'yz-pv-flash');
				setTimeout(function () { s.classList.remove(ON, 'yz-pv-flash'); }, 1200);
			}
			say({ yz: 'sec', sel: d.sel, n: s ? 1 : 0 });
		}
	});
	say({ yz: 'ready', path: location.pathname + location.search.replace(/[?&]yz_pv=1/, '').replace(/^&/, '?'), title: document.title });
}

// ── 가맹점 수정 미리보기 (2026-10-15 대표 지시 — page/vendor-preview.php, 파트너센터 「설정 › 가맹점관리 › 가맹점 수정」 오른쪽 칸 안에서만) ──
//   파트너센터가 저장 전 값을 서명해 {yz:'vpv', t} 로 보내면 page/ajax_vendor_pv.php 가 그 구역을 실제 페이지와 같은 함수로 그리고, 여기서 [data-vpv] 를 바꾼다(푸터는 페이지 푸터째)
//   받는 곳은 파트너센터 주소만(designLive 와 같은 목록) · 한 번에 하나 — 그사이 온 값은 마지막 것만 · 칸 안 링크는 열지 않는다(미리보기라 다른 페이지로 가지 않게)
//   알림: {yz:'vpv-ready', part} 준비됨 · {yz:'vpv-ok', ok, msg} 그림 결과 · {yz:'vpv-h', h} 내용 높이(파트너센터가 칸 높이를 맞춘다)
//   상품 수정 미리보기(2026-10-15 — part cview 코스상세 · gview 추천여행 상세 · cnote 공지 자리): {yz:'vpv-pics', list} = 상품 사진 차례('k:저장된 번호' → 그린 사진 칸 [data-vpv-no] · data URL = 새 사진)로
//     사진 넘기기를 다시 짠다 · 그린 뒤 courseView(사진 넘기기·넓은 요금표)를 칸 안에서 다시 건다 · 「예약하기」 같은 창 단추는 열지 않는다
//     {yz:'vpv-only', k} = 보는 구역 묶음 — .col-cont 바로 아래 칸 가운데 [data-vpv-g] 가 k 인 것만 보인다(k 가 비면 모두 · 같은 날 대표 지시 「구역마다 그 내용만」)
function vendorLive() {
	var page = document.querySelector('[data-vpv-page]');
	if (!page || window.parent === window || !/[?&]yz_pv=1(&|$)/.test(location.search)) return;
	var OK = /^(https:\/\/partner\.yozuum\.com|http:\/\/(localhost|127\.0\.0\.1)(:\d+)?)$/;
	var part = page.getAttribute('data-vpv-page'), busy = false, pend = null, lastH = 0;
	var pic = null;   // 상점 수정 미리보기(2026-10-15) — 저장 전 사진 {yz:'vpv-pic'}: null = 그린 그대로(저장된 사진) · '' = 사진 없음 · data URL = 새로 고른 사진
	var pics = null, slides = {}, galLabel = '사진', cvOff = null, only = '';   // 상품 수정 미리보기 — 사진 차례 · 그린 사진 칸(번호 → HTML) · 사진 넘기기 걷기 · 보는 구역 묶음
	function applyOnly() {   // 보는 구역 묶음만 — 묶음 표지가 없는 칸(바로가기 줄·혜택알림·영업시간·이용위치)은 숨김
		var cc = page.querySelector('.col-cont');
		if (!cc) return;
		var first = true;
		[].forEach.call(cc.children, function (el) {
			var hide = !!only && el.getAttribute('data-vpv-g') !== only;
			el.style.display = hide ? 'none' : '';
			el.style.marginTop = (only && !hide && first) ? '0' : '';   // 보이는 첫 칸은 위 여백 없이(구역 사이 간격이 맨 위에 남지 않게)
			if (!hide) first = false;
		});
	}
	var IMG = /^data:image\/(jpeg|png|webp|gif);base64,[A-Za-z0-9+\/=]+$/;
	function keepSlides() {   // 막 그린 HTML 의 사진 칸 — 차례를 바꿀 때 그대로 다시 쓴다(채널 판 · srcset 그대로)
		slides = {};
		var g = page.querySelector('.cv-gallery');
		if (g) galLabel = g.getAttribute('aria-label') || galLabel;
		[].forEach.call(page.querySelectorAll('.cv-gallery .swiper-slide[data-vpv-no]'), function (s) { slides[s.getAttribute('data-vpv-no')] = s.outerHTML; });
	}
	function applyPics() {   // 사진 넘기기를 파트너센터 사진 차례로 — 없으면 빈 자리 안내
		if (pics === null) return;
		var old = page.querySelector('.cv-gallery') || page.querySelector('[data-vpv-gal]');
		if (!old) return;
		var ss = [];
		pics.forEach(function (v, i) {
			if (typeof v !== 'string') return;
			if (/^k:\d+$/.test(v)) { if (slides[v.slice(2)]) ss.push(slides[v.slice(2)]); }
			else if (v.length < 15000000 && IMG.test(v)) ss.push('<div class="swiper-slide"><img src="' + v + '" alt=""' + (i ? ' loading="lazy"' : '') + ' decoding="async"></div>');
		});
		var box = document.createElement('div');
		box.innerHTML = ss.length ? '<div class="cv-gallery swiper" aria-label="' + galLabel + '" data-vpv-g="basic"><div class="swiper-wrapper">' + ss.join('') + '</div>'
			+ (ss.length > 1 ? '<button type="button" class="cv-gallery__nav is-prev" aria-label="이전 사진"><i class="ic ic-chevron-left" aria-hidden="true"></i></button><button type="button" class="cv-gallery__nav is-next" aria-label="다음 사진"><i class="ic ic-chevron-right" aria-hidden="true"></i></button><p class="cv-gallery__count" aria-hidden="true"><b>1</b> / ' + ss.length + '</p>' : '') + '</div>'
			: '<p class="vpv-empty" data-vpv-g="basic" data-vpv-gal>사진이 없어 이 자리에 아무것도 나오지 않습니다.</p>';
		old.replaceWith(box.firstChild);
	}
	function liveCv() {   // 코스상세·추천여행 상세 — 사진 넘기기·넓은 요금표를 칸 안에서(페이지와 같은 courseView)
		if (cvOff) { cvOff(); cvOff = null; }
		if ((part === 'cview' || part === 'gview') && page.querySelector('.cv')) cvOff = courseView(page);
	}
	function applyPic() {   // 그린 카드의 사진 칸 [data-vpv-pic] 에 — 추천여행 카드는 배경 그림, 코스안내 카드는 img
		if (pic === null) return;
		[].forEach.call(page.querySelectorAll('[data-vpv-pic]'), function (el) {
			if (el.tagName === 'IMG') {   // 추천여행 카드 사진 = <img>(2026-10-18 D-5)
				el.removeAttribute('srcset');
				if (pic) { el.src = pic; el.hidden = false; } else el.hidden = true;
				return;
			}
			if (el.classList.contains('rc-img-bg')) { el.style.backgroundImage = pic ? 'url("' + pic + '")' : 'none'; return; }   // 사진 없는 카드 빈 칸(div)
			var img = el.querySelector('img');
			if (!pic) { if (img) img.remove(); return; }
			if (!img) { img = document.createElement('img'); img.alt = ''; el.appendChild(img); }
			img.removeAttribute('srcset');
			img.src = pic;
		});
	}
	function say(o) { try { window.parent.postMessage(o, '*'); } catch (e) {} }   // 비밀 없는 알림만(높이·결과)
	function height() {
		var w = document.querySelector('.wrap');
		return Math.ceil(w ? w.getBoundingClientRect().height : document.body.scrollHeight);
	}
	function tellH() { var h = height(); if (h !== lastH) { lastH = h; say({ yz: 'vpv-h', h: h }); } }
	function put(r) {
		if (!r || !r.ok) { say({ yz: 'vpv-ok', ok: 0, msg: (r && r.msg) || 'fail' }); return; }
		if (part === 'footer') {
			var old = document.querySelector('.wrap > footer'), box = document.createElement('div');
			box.innerHTML = r.html;
			var nf = box.querySelector('footer');
			if (old && nf) old.replaceWith(nf);
		} else {
			var slot = page.querySelector('[data-vpv]');
			if (cvOff) { cvOff(); cvOff = null; }
			if (slot) slot.innerHTML = r.html;
			applyPic();
			keepSlides();
			applyPics();
			applyOnly();
			liveCv();
		}
		say({ yz: 'vpv-ok', ok: 1 });
		tellH();
	}
	function send() {
		var t = pend;
		pend = null;
		busy = true;
		$.post('/page/ajax_vendor_pv.php', { t: t }, null, 'json').done(put).fail(function () { say({ yz: 'vpv-ok', ok: 0, msg: 'net' }); }).always(function () {
			busy = false;
			if (pend) send();
		});
	}
	document.addEventListener('click', function (e) {
		var a = e.target.closest && e.target.closest('a[href]');
		if (a) { e.preventDefault(); return; }
		if (e.target.closest && e.target.closest('[data-bs-toggle], .addr-copy')) { e.preventDefault(); e.stopPropagation(); return; }   // 「예약하기」 같은 창 단추·주소 복사는 열지 않는다(상품 수정 미리보기)
		var more = e.target.closest && e.target.closest('.od-more');   // 쿠폰북 「자세히보기」 — 주문서와 같게 펼침
		if (more) {
			var box = document.getElementById(more.getAttribute('aria-controls')), open = more.getAttribute('aria-expanded') !== 'true';
			if (box) box.hidden = !open;
			more.setAttribute('aria-expanded', open ? 'true' : 'false');
			more.textContent = open ? '접기' : '자세히보기';
			tellH();
		}
	}, true);
	window.addEventListener('message', function (e) {
		if (!OK.test(e.origin) || !e.data || typeof e.data !== 'object') return;
		if (e.data.yz === 'vpv-pics') {   // 상품 사진 차례 — 'k:번호'(그린 칸) · data:image(새 사진)만, 그 밖은 버린다
			if (!Array.isArray(e.data.list) || e.data.list.length > 60) return;
			pics = e.data.list;
			if (cvOff) { cvOff(); cvOff = null; }
			applyPics();
			applyOnly();
			liveCv();
			tellH();
			return;
		}
		if (e.data.yz === 'vpv-only') {   // 보는 구역 묶음 — 사진 넘기기는 보이는 뒤에 다시 건다(숨은 칸에서 건 넘기기는 폭이 0)
			only = typeof e.data.k === 'string' && /^[a-z]{0,12}$/.test(e.data.k) ? e.data.k : '';
			if (cvOff) { cvOff(); cvOff = null; }
			applyOnly();
			liveCv();
			tellH();
			return;
		}
		if (e.data.yz === 'vpv-pic') {   // 사진은 그림만(data:image) — 서명 자료 밖이라 그림이 아닌 값은 버린다
			var src = e.data.src;
			if (src === null || src === '' || (typeof src === 'string' && src.length < 15000000 && /^data:image\/(jpeg|png|webp|gif);base64,[A-Za-z0-9+\/=]+$/.test(src))) { pic = src; applyPic(); tellH(); }
			return;
		}
		if (e.data.yz !== 'vpv') return;
		if (typeof e.data.t !== 'string' || e.data.t === '' || e.data.t.length > 300000) return;
		pend = e.data.t;
		if (!busy) send();
	});
	if (window.ResizeObserver) new ResizeObserver(tellH).observe(document.body);
	window.addEventListener('load', tellH);
	say({ yz: 'vpv-ready', part: part });
	tellH();
}

// @ui:common — 화면 고정 글 묶음 표지(빌드가 이 줄부터 다음 표지까지의 __('…') 를 이 묶음으로 모은다 — 파트너센터 [화면 글] 탭 묶음)
// ── 휴대폰인데 PC 화면(브라우저 「데스크톱 버전」)으로 보고 있으면 맨 위에 안내(2026-10-12 대표 지시) ──
//   사이트는 반응형(화면 맞춤 viewport)이라 휴대폰 모양을 보내도, 데스크톱 버전 보기는 브라우저가 그 요청을 무시하고 약 980px 로 그린다 — 사이트가 바꿀 수 없어 끄는 법을 알린다
//   알아보기 = 손가락 화면 · 실제 화면 짧은 변 768 미만(휴대폰) · 그린 폭 900 이상 · 글자는 축소된 만큼 키움(--dn-s) · 닫으면 이 브라우저에서 다시 안 띄움
function deskNote() {
	var KEY = 'yz-desk-note';
	try { if (localStorage.getItem(KEY)) return; } catch (e) {}
	var touch = window.matchMedia('(pointer: coarse)').matches;   // 주로 손가락으로 쓰는 화면(터치 노트북은 마우스라 fine)
	if (!touch || Math.min(screen.width, screen.height) >= 768 || window.innerWidth < 900) return;
	var ua = navigator.userAgent, dots = '<i class="ic ic-more-v" role="img" aria-label="' + __('점 세 개') + '"></i>', how;
	if (/SamsungBrowser/i.test(ua)) how = __('오른쪽 하단의 {i} 메뉴의 모바일 사이트를 선택하시거나 데스크톱 버전을 끄시면', { i: dots });   // 대표님 문구(2026-10-12)
	else if (/Chrome|CriOS/i.test(ua) && !/Edg/i.test(ua)) how = __('오른쪽 상단의 {i} 메뉴에서 데스크톱 사이트 체크를 푸시면', { i: dots });
	else if (/Safari/i.test(ua) && /Macintosh|iPhone/i.test(ua)) how = __('주소창 왼쪽의 가가 메뉴에서 모바일 웹 사이트 요청을 누르시면');
	else how = __('브라우저 메뉴에서 데스크톱 버전을 끄시면');
	var box = document.createElement('div');
	box.className = 'desk-note';
	box.setAttribute('role', 'status');
	box.style.setProperty('--dn-s', Math.max(1, window.innerWidth / screen.width).toFixed(2));
	box.innerHTML = '<p><b>' + __('현재 사용자의 브라우저는 PC 화면으로 보고 계세요!') + '</b><br>' + __('{how} 휴대폰에 맞는 화면으로 보실 수 있습니다.', { how: how }) + '</p><button type="button">' + __('닫기') + '</button>';
	box.querySelector('button').addEventListener('click', function () {
		box.remove();
		try { localStorage.setItem(KEY, '1'); } catch (e) {}
	});
	document.body.appendChild(box);
}

function init() {
	header();
	reserveBar();
	barPage();   // 휴대폰 대메뉴 페이지 이름표 → 서브메뉴 펼치기(2026-10-07)
	reserveCal();
	langMenu();
	swiper();
	modals();
	orderPage();   // 주문서 — 예약 정보 입력 · 결제(2026-10-10, page/order.php 에만)
	myorderPage();   // 예약 내역(2026-10-10, page/myorder.php 에만)
	langDone();   // 언어 예약 내역 — 취소 · 안내사항 접기(2026-10-17, page/lang-done.php 에만)
	courseList();   // 코스안내 목록 — 분류 글 · 예약 가능 토글(2026-10-12, page/course.php 에만)
	courseView();   // 코스상세 — 사진 슬라이드 · 바로가기 줄(2026-10-12, page/course-view.php 에만)
	coursePanel();   // 코스안내 목록 카드 → 코스상세 창(2026-10-13, page/course.php 에만)
	findForms();   // 예약조회 — 헤더 창(모든 페이지) · 문자 링크 조회 화면(2026-10-10)

	// 모달을 열면 주소에 #id 를 남겨 뒤로가기로 닫히게 한다 — 기록 값(history.state)은 그대로 둔다(코스상세 창 표지 cvp 를 지키게, 2026-10-13)
	$('.modal').on('shown.bs.modal', function () {
		history.pushState(history.state, '', '#' + this.id);
		this.yzHash = true;
	});
	$('.modal').on('hide.bs.modal', function () {   // 이 창이 남긴 기록일 때만 되돌린다(2026-10-13 — 옛: 사이트 안에서 왔을 때(referrer)만이라 바로 들어온 손님은 #창 기록이 남았다)
		if (this.yzHash && location.hash === '#' + this.id) window.history.back();
		this.yzHash = false;
	});
	$(window).on('popstate', function () {
		$('.modal').modal('hide');
	});
	$('.modal').not('.od-sheet').on('hidden.bs.modal', function () {   // 열 때마다 내용을 받아 오는 창만 비운다 — 주문서 결제 창(#odSheet)은 페이지의 결제 칸을 옮겨 넣은 것이라 비우면 칸이 사라졌다(2026-10-12 대표님 발견 — 닫은 뒤 다시 열면 빈 창)
		$(this).find('.modal-content').html('');
	});
	sheetDrag();
}

// ── 내용을 ajax 로 받는 모달들 (마크업은 page/_modal.php) ──────────────
function modals() {
	function load($modal, url, data) {
		$.post(url, data, function (html) {
			$modal.find('.modal-content').html(html);
		});
	}
	$('#mo-map').on('show.bs.modal', function () {
		var ed = $('#daum-map');
		load($(this), '/page/ajax_myorder.php', langPost({ w: ed.data('w'), addr: ed.data('addr') }));
	});
	$('#mo-login').on('show.bs.modal', function (e) {
		load($(this), '/page/ajax_login.php', { w: $(e.relatedTarget).data('w') });
	});
	// 티켓예매 창(2026-10-09 새로) — 배시간표 시간(id = 날짜 · gt = 회차) · 코스상세 「예약하기」(coid) · 휴대폰 메뉴 「티켓예약」(아무것도 없음)
	$('#mo-cart').on('show.bs.modal', function (e) {
		var $m = $(this), ed = $(e.relatedTarget);
		$m.find('.modal-content').html('<div class="bk-loading" role="status">' + __('불러오는 중…') + '</div>');
		$.post('/page/ajax_cart.php', langPost({ w: 's0', id: ed.data('id'), coid: ed.data('coid'), gt: ed.data('gt'), date: ed.data('date'), qty: ed.data('qty') }), function (html) {   // 언어 페이지 = lang(창구가 다국어 판매 코스·번역으로)   // date = 코스안내 검색 날짜(코스상세 ?date= — 2026-10-09)
			$m.find('.modal-content').html(html);
			booking($m[0]);
		});
	});
	$('#mo-policy').on('show.bs.modal', function (e) {
		load($(this), '/page/ajax_policy.php', langPost({ w: $(e.relatedTarget).data('w') }));
	});
	// 이전 방침 보기 (2026-09-28) — 개인정보처리방침 창 안에서 판을 고르면 그 판으로 다시 연다
	$(document).on('change', '#mo-policy .policy-ver', function () {
		load($('#mo-policy'), '/page/ajax_policy.php', { w: 'p1', ver: $(this).val() });
	});

	// 사업자정보확인 · 새 창 링크 — 공정위 조회는 숫자만 받는다(회사 정보 사업자번호 897-81-03259 의 하이픈을 뗌, 2026-10-16 대표 지시)
	$('.biz').on('click', function (e) {
		e.preventDefault();
		var no = String($(this).attr('data-id') || '').replace(/\D/g, '');
		window.open('https://www.ftc.go.kr/bizCommPop.do?wrkr_no=' + no, 'bizCommPop', 'width=750, height=700;');
	});
	$(document).on('click', '.full-window', function (e) {
		e.preventDefault();
		window.open($(this).attr('href'), 'fullWindow', 'height=' + screen.height + ',width=' + screen.width + ',width=940,fullscreen=yes');
	});
}

// ── 입력 안내 (2026-10-09 대표 지시 — 화면 아래 잠깐 떴다 사라지는 토스트 대신) ─────────────────────
//   fieldMsg(칸, 글) — 그 칸 바로 아래 빨간 글 + 칸 빨간 테두리(.is-invalid). 칸을 고치면(입력·바꿈) 사라진다. 입력칸 묶음(.input-group)이면 묶음 아래, 체크칸이면 그 줄 아래
//   formMsg(폼, 글) — 폼 결과 안내(일치하는 예약 없음 등 — 칸 하나의 잘못이 아닌 것): 제출 단추 바로 위 상자(.form-msg). 빈 글이면 지움
//   쓰는 곳: 예약조회 창(page/ajax_login.php) · 문자 링크 예약조회(myorder-login.php) · 질문과 답변 글쓰기·비밀번호 확인(ajax_bbs.php) · 예약 정보 입력(order.php)
//   글은 고정 문구(서버 결과도 고정 문구)라 HTML 로 넣는다(<br> 줄바꿈)
var fmSeq = 0;
function msgClear(form) {
	if (!form) return;
	form.querySelectorAll('.field-msg, .form-msg').forEach(function (m) { m.remove(); });
	form.querySelectorAll('.is-invalid[data-fm]').forEach(function (f) { f.classList.remove('is-invalid'); f.removeAttribute('aria-invalid'); f.removeAttribute('aria-describedby'); f.removeAttribute('data-fm'); });
}
function fieldMsg(el, msg) {
	el = el && el.jquery ? el[0] : el;
	if (!el) return;
	msgClear(el.form || el.closest('form'));
	var at = el.closest('[data-fm-at]') || (el.type === 'checkbox' ? (el.closest('.form-check') || el) : (el.closest('.input-group') || el));   // data-fm-at = 그 묶음 아래에(주문서 휴대폰 인증 한 줄 · 환불계좌 · 약관 — 2026-10-10)
	var m = document.createElement('div');
	m.className = 'field-msg';
	m.id = 'fm' + (++fmSeq);
	m.setAttribute('role', 'alert');
	m.innerHTML = msg;
	at.insertAdjacentElement('afterend', m);
	el.classList.add('is-invalid');
	el.setAttribute('aria-invalid', 'true');
	el.setAttribute('aria-describedby', m.id);
	el.setAttribute('data-fm', m.id);
}
function formMsg(form, msg) {
	form = form && form.jquery ? form[0] : form;
	if (!form) return;
	msgClear(form);
	if (!msg) return;
	var btn = form.querySelector('[type=submit], [type=sumbit]'), m = document.createElement('div');   // 질문과 답변 창 단추는 옛 오타 type="sumbit"
	m.className = 'form-msg';
	m.setAttribute('role', 'alert');
	m.innerHTML = msg;
	if (btn) btn.parentNode.insertBefore(m, btn.parentNode.querySelector('button') || btn);
	else form.appendChild(m);
	m.scrollIntoView({ block: 'nearest' });
}
window.fieldMsg = fieldMsg;
window.formMsg = formMsg;
function fieldFixed(e) {   // 안내가 붙은 칸을 고치면 그 안내를 지운다
	var f = e.target, id = f && f.getAttribute && f.getAttribute('data-fm');
	if (!id) return;
	var m = document.getElementById(id);
	if (m) m.remove();
	f.classList.remove('is-invalid');
	f.removeAttribute('aria-invalid');
	f.removeAttribute('aria-describedby');
	f.removeAttribute('data-fm');
}
document.addEventListener('input', fieldFixed, true);
document.addEventListener('change', fieldFixed, true);

// @ui:order
// ── 주문서 — 예약 정보 입력 · 결제 (page/order.php — 2026-10-10 새로, 기획서 주문서_새페이지_기획_2026-10-10.md) ──────────
//   휴대폰 인증 = ajax_order.php(sh 보내기 · sc 확인 — 인증된 번호는 서버 세션, 결제 요청 창구가 그 번호와 입력 번호를 다시 본다)
//     인증번호 칸은 처음부터 보이고 잠김(2026-10-10 대표 지시) → 인증요청 → 열림 + 2:00 · 30초 뒤 「다시 받기」 · 번호를 고치면 다시 잠김 · 확인되면 「인증되었습니다」 + [번호 바꾸기]
//   이메일 = 아이디 @ 도메인 드롭다운(「직접 입력」이면 도메인 칸) → 숨은 칸 email 에 합침(2026-10-10 대표 지시) — 자동 채우기로 전체 주소가 아이디 칸에 오면 나눠 넣음
//   약관 = 모두 동의 ↔ 항목 셋(셋 다 켜야 agree=1 — 창구 그대로) · [보기]·[접기] = 항목 아래 페이지 안에 펼침(필독사항 및 환불약관은 처음부터 열림, 동의하면 접힘 — 2026-10-10 대표 지시, 처음 판의 창은 없앰)
//   결제 수단 = 가상계좌면 입금 정보 칸(다른 수단이면 그 칸을 막아 보내지 않음) · [변경] = 예약 창을 그 회차 ④ 인원(고른 인원 채움)으로 — 입력한 이름·이메일·휴대폰은 다시 열린 이 화면에 되살림
//   오른쪽 결제 칸(1200 이상) = 따라다님 — 칸이 화면보다 길면 아래 끝까지 보인 뒤 붙는다(top 을 여기서 정함)
//   결제하기 → 빠진 칸은 그 칸 아래 빨간 글(fieldMsg) · ajax_pay_req.php 가 돌려준 결제 폼(PC 이니시스 레이어 · 휴대폰 이니시스 페이지 · ARS)을 그대로 넣는다
//   언어 주문서(2026-10-17 다국어 3단계 — /en/order.php 등): 휴대폰 = 나라 번호 hp_cc + 번호(인증 없음) · 이메일 꼭 + 확인(email2) · 카드만 · 글 = __() — 아래 LANG 갈래(인증·이메일 고르기·가상계좌 칸이 없다)
function orderPage() {
	var form = document.getElementById('od-form');
	if (!form) return;
	var LANG = I18N.lang !== 'ko';
	var hp = form.elements.hp, code = form.elements.code;
	var authBox = form.querySelector('.od-auth'), send = form.querySelector('.od-auth__send'), change = form.querySelector('.od-auth__change');
	var codeRow = form.querySelector('.od-auth__code'), check = form.querySelector('.od-auth__check'), ok = form.querySelector('.od-auth__ok'), timerEl = form.querySelector('.od-timer');
	var reHp = /^01[016789]-?\d{3,4}-?\d{4}$/;
	var TIME = 120, RESEND = 30, left = 0, tick = null;
	function digits(v) { return String(v || '').replace(/\D/g, ''); }
	function pad(n) { return (n < 10 ? '0' : '') + n; }
	function bad(el, msg) {
		fieldMsg(el, msg);
		el.focus({ preventScroll: true });
		el.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
		return false;
	}

	// 휴대폰 인증
	function stopTimer() { clearInterval(tick); tick = null; timerEl.textContent = ''; }
	// 인증번호는 손으로 넣고 [확인]을 눌러 확인한다(2026-10-22 tpl571 대표 지시 — 10-12 의 WebOTP 자동 채우기·네 자리 자동 확인은 뺌: 문자 두 통이 겹칠 때 다른 번호로 확인이 나가 헷갈렸다)
	function closeCode(label) {   // 인증번호 칸 잠그기 — 번호를 고쳤거나 시간이 지났을 때(칸은 보인 채 — 2026-10-10)
		stopTimer();
		code.value = '';
		code.disabled = true;
		check.disabled = true;
		send.disabled = false;
		send.textContent = label || '인증요청';
	}
	function setAuth(on) {
		form.elements.auth.value = on ? 1 : 0;
		authBox.classList.toggle('is-ok', on);
		hp.readOnly = on;
		send.hidden = on;
		change.hidden = !on;
		ok.hidden = !on;
		closeCode();
		codeRow.hidden = on;   // 인증되면 인증번호 칸을 접고, 번호를 바꾸면 잠긴 채 다시 보임
	}
	function startTimer() {
		stopTimer();
		left = TIME;
		timerEl.textContent = '02:00';
		send.disabled = true;
		send.textContent = '다시 받기';
		tick = setInterval(function () {
			left--;
			if (TIME - left >= RESEND) send.disabled = false;
			if (left <= 0) {
				closeCode();
				fieldMsg(hp, '인증 시간이 지났습니다. 인증번호를 다시 받아 주세요.');
				return;
			}
			timerEl.textContent = pad(Math.floor(left / 60)) + ':' + pad(left % 60);
		}, 1000);
	}
	if (send) send.addEventListener('click', function () {
		if (!reHp.test(hp.value)) return bad(hp, '휴대폰번호를 정확히 입력하세요.');
		send.disabled = true;
		$.post('/page/ajax_order.php', { w: 'sh', hp: hp.value }).done(function (r) {
			if ($.trim(r) === '100') {
				msgClear(form);
				form.elements.auth.value = 0;
				code.value = '';
				code.disabled = false;
				check.disabled = false;
				code.focus();
				startTimer();
			} else {
				send.disabled = false;
				r = $.trim(r);   // 'msg:안내' = 보내기 제한(2026-10-18 A-6 — 30초 · 10분 5번 · 번호 하루 10번 · IP 한 시간 20번, ajax_order.php sms_auth_limit)
				bad(hp, r.indexOf('msg:') === 0 ? r.slice(4) : '휴대폰번호를 정확히 입력하세요.');
			}
		}).fail(function () {
			send.disabled = false;
			bad(hp, '다시 시도해 주세요.');
		});
	});
	if (send) {
	hp.addEventListener('input', function () { if (!code.disabled) closeCode(); });   // 번호를 고치면 받은 인증번호는 그 번호 것이 아니다
	code.addEventListener('input', function () { code.value = digits(code.value).slice(0, 4); });   // 숫자 네 자리만 — 확인은 [확인] 단추·엔터(tpl571)
	code.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); check.click(); } });
	check.addEventListener('click', function () {
		if (!/^\d{4}$/.test(code.value)) return bad(code, '인증번호 4자리를 입력하세요.');
		check.disabled = true;
		$.post('/page/ajax_order.php', { w: 'sc', code: code.value }).done(function (r) {
			check.disabled = false;
			if ($.trim(r) === '100') { msgClear(form); setAuth(true); }
			else if (/^limit:\d+$/.test($.trim(r))) { msgClear(form); setAuth(true); bad(hp, __('이 상품은 한 번호로 {n}건까지 구매할 수 있습니다.', { n: $.trim(r).slice(6) })); }   // 같은 번호 누적 한도(2026-10-19 6단계) — 인증은 되고 번호 칸 아래 안내(결제하기는 서버가 막음)
			else bad(code, '인증번호를 정확히 입력하세요.');
		}).fail(function () {
			check.disabled = false;
			bad(code, '다시 시도해 주세요.');
		});
	});
	change.addEventListener('click', function () {
		setAuth(false);
		hp.focus();
		hp.select();
	});
	}
	// 언어 주문서 휴대폰 — 나라 번호 + 번호(서버 page/_lang_order.php i18n_hp_norm 과 같은 규칙: 번호 칸에 적은 나라 번호는 한 번만 · 한국은 01x 휴대폰 · 다른 나라는 앞 0 뺀 5~14자리)
	function hpOk() {
		var cc = form.elements.hp_cc ? form.elements.hp_cc.value : '', raw = $.trim(hp.value), d = digits(raw);
		if (d.indexOf('00' + cc) === 0) d = d.slice(2 + cc.length);
		else if (raw.charAt(0) === '+' && d.indexOf(cc) === 0) d = d.slice(cc.length);
		if (cc === '82') { if (d && d.charAt(0) !== '0') d = '0' + d; return /^01[016789]\d{7,8}$/.test(d); }
		d = d.replace(/^0/, '');
		return d.length >= 5 && d.length <= 14;
	}

	// 이메일 — 아이디 @ 도메인
	var eId = form.querySelector('.od-email__id'), eSel = form.querySelector('.od-email__sel'), eDom = form.querySelector('.od-email__dom');
	function emailDom() { return eSel.value === '_' ? $.trim(eDom.value) : eSel.value; }
	function syncEmail() {
		if (!eId) return;   // 언어 주문서 — 이메일은 한 칸(email) 그대로
		var id = $.trim(eId.value), dm = emailDom();
		form.elements.email.value = id && dm ? id + '@' + dm : '';
	}
	function setEmail(v) {   // 전체 주소 → 아이디 · 도메인(목록에 없으면 직접 입력)
		var p = String(v || '').split('@'), dm = (p[1] || '').toLowerCase();
		eId.value = p[0];
		if (!dm) return syncEmail();
		var has = Array.prototype.some.call(eSel.options, function (o) { return o.value === dm; });
		eSel.value = has ? dm : '_';
		eDom.value = has ? '' : dm;
		eDom.hidden = has;
		syncEmail();
	}
	if (eId) {
		eId.addEventListener('input', function () { if (eId.value.indexOf('@') > -1) setEmail($.trim(eId.value)); else syncEmail(); });
		eSel.addEventListener('change', function () {
			eDom.hidden = eSel.value !== '_';
			if (!eDom.hidden) eDom.focus();
			syncEmail();
		});
		eDom.addEventListener('input', syncEmail);
	}

	// 약관
	var all = form.querySelector('.od-agree__all'), ones = Array.prototype.slice.call(form.querySelectorAll('.od-agree__one'));
	function syncAgree() {
		var n = ones.filter(function (c) { return c.checked; }).length;
		all.checked = n === ones.length;
		all.indeterminate = n > 0 && n < ones.length;
		form.elements.agree.value = n === ones.length ? '1' : '';
	}
	function termsOpen(btn, open) {   // 약관 글 펼치기·접기 — 항목 바로 아래 페이지 안(필독사항 및 환불약관은 처음부터 열림)
		var doc = document.getElementById(btn.getAttribute('aria-controls'));
		if (!doc) return;
		doc.hidden = !open;
		btn.setAttribute('aria-expanded', open ? 'true' : 'false');
		btn.firstElementChild.textContent = open ? __('접기') : __('보기');
	}
	function termsOf(c) { return c.closest('li').querySelector('.od-terms__view'); }
	all.addEventListener('change', function () {
		ones.forEach(function (c) { c.checked = all.checked; });   // 약관 글은 접지 않는다(2026-10-12 대표 지시 — 동의해도 펼친 채, 손님이 [접기]로만)
		syncAgree();
		ones.forEach(function (c) { fieldFixed({ target: c }); if (c.checked) { c.classList.remove('is-invalid'); c.removeAttribute('aria-invalid'); } });
		if (all.checked) fieldFixed({ target: all });
	});
	ones.forEach(function (c) {
		c.addEventListener('change', function () {
			if (c.checked) { c.classList.remove('is-invalid'); c.removeAttribute('aria-invalid'); }   // 고르면 그 칸 경고색을 푼다 — 약관 글은 접지 않는다(2026-10-12 대표 지시 — 「필수약관동의」도 접지 않음)
			syncAgree();
			if (form.elements.agree.value === '1') fieldFixed({ target: all });   // 다 고르면 「모두 동의」 칸 경고·안내도
		});
	});
	form.addEventListener('click', function (e) {
		var v = e.target.closest('.od-terms__view'), more = e.target.closest('.od-more');
		if (v) {
			termsOpen(v, v.getAttribute('aria-expanded') !== 'true');
			return;
		}
		if (more) {   // 쿠폰북 「자세히보기」
			var box = document.getElementById(more.getAttribute('aria-controls')), open = more.getAttribute('aria-expanded') !== 'true';
			box.hidden = !open;
			more.setAttribute('aria-expanded', open ? 'true' : 'false');
			more.textContent = open ? '접기' : '자세히보기';
		}
	});

	// 결제 수단 · 가상계좌 입금 정보
	var vb = form.querySelector('.od-vbank'), cashNo = form.elements.re_cash_number;
	function payNow() { var c = form.querySelector('input[name=paymethod]:checked'); return c ? c.value : 'Card'; }
	function syncCash(changed) {
		if (!cashNo) return;   // 언어 주문서 — 카드만(가상계좌 칸 없음)
		var on = payNow() === 'VBank', c = form.querySelector('input[name=re_cash_use]:checked'), v = c ? c.value : '';
		cashNo.hidden = !v;
		cashNo.disabled = !on || !v;
		cashNo.placeholder = v === '사업자지출증빙' ? '사업자등록번호' : '휴대폰번호';
		if (changed) cashNo.value = v === '개인소득공제' ? digits(hp.value) : '';   // 옛 화면과 같게 — 소득공제는 휴대폰 번호로 채움
		if (changed && v) seeIt(cashNo);   // 나타난 번호 칸이 보이게(결제 창 안 — 2026-10-12 대표 지시)
	}
	function seeIt(el) {   // 새로 나타난 칸을 화면(결제 창이면 창 본문) 안으로 — 그만큼만 부드럽게
		setTimeout(function () { el.scrollIntoView({ block: 'nearest', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }, 30);
	}
	function syncPay() {
		if (!vb) { place(); return; }
		var on = payNow() === 'VBank';
		vb.hidden = !on;
		vb.querySelectorAll('input, select').forEach(function (x) { x.disabled = !on; });
		syncCash(false);
		place();
		if (on && vb.closest('.od-sheet')) seeIt(vb.querySelector('.od-cash'));   // 가상계좌 — 펼쳐진 칸이 현금영수증(번호 칸 포함) 끝까지 창 안에 보이게(2026-10-12 대표 지시)
	}
	form.querySelectorAll('input[name=paymethod]').forEach(function (r) { r.addEventListener('change', syncPay); });
	form.querySelectorAll('input[name=re_cash_use]').forEach(function (r) { r.addEventListener('change', function () { syncCash(true); }); });

	// 오른쪽 결제 칸 따라다니기 — 칸이 화면보다 길면 결제하기가 화면 아래 20px 에 올 때 붙도록 top 을 위로
	var side = form.querySelector('.od-side'), sum = form.querySelector('.od-sum');
	function place() {
		if (!side) return;
		side.style.top = '';
		if (window.innerWidth < 1200) return;
		var top = parseFloat(getComputedStyle(side).top) || 0, h = sum.offsetHeight;
		if (top + h + 20 > window.innerHeight) side.style.top = (window.innerHeight - h - 20) + 'px';
	}
	if (window.ResizeObserver) new ResizeObserver(place).observe(sum);
	window.addEventListener('resize', place);

	// [변경] — 예약 창을 그 회차 · ④ 인원(고른 인원)으로. 예약하기를 누르면 같은 장바구니를 고쳐 이 화면을 다시 연다
	var KEY = 'od-draft';
	form.querySelector('.od-edit').addEventListener('click', function () {
		syncEmail();
		try { sessionStorage.setItem(KEY, JSON.stringify({ oid: form.getAttribute('data-oid'), name: form.elements.name.value, email: form.elements.email.value, email2: form.elements.email2 ? form.elements.email2.value : '', hp: hp.value, cc: form.elements.hp_cc ? form.elements.hp_cc.value : '' })); } catch (err) {}
		var c = $('.do-cart');
		c.data('id', this.getAttribute('data-id')).data('gt', this.getAttribute('data-gt')).data('qty', this.getAttribute('data-qty')).data('coid', '').data('date', '');
		c[0].click();
	});
	try {
		var d = JSON.parse(sessionStorage.getItem(KEY) || 'null');
		sessionStorage.removeItem(KEY);
		if (d && d.oid === form.getAttribute('data-oid')) {
			if (!form.elements.name.value) form.elements.name.value = d.name || '';
			if (LANG) {   // 언어 주문서 — 이메일 두 칸 · 나라 번호 · 번호
				if (!form.elements.email.value && d.email) form.elements.email.value = d.email;
				if (form.elements.email2 && !form.elements.email2.value && d.email2) form.elements.email2.value = d.email2;
				if (!hp.value && d.hp) { hp.value = d.hp; if (d.cc && form.elements.hp_cc) form.elements.hp_cc.value = d.cc; }
			} else if (!form.elements.email.value && d.email) setEmail(d.email);
			if (!LANG && !hp.value && d.hp) {
				hp.value = d.hp;
				if (digits(d.hp) && digits(d.hp) === digits(form.getAttribute('data-authed'))) setAuth(true);   // 인증해 둔 번호(서버 세션)면 인증된 채로
			}
		}
	} catch (err) {}

	// 결제하기 — 확인을 둘로: 위 입력·약관(checkTop — silent 면 안내 없이 참·거짓만) · 결제 수단(checkPay — 가상계좌 칸)
	function checkTop(silent) {
		function no(el, msg) { if (!silent) bad(el, msg); return false; }
		var f = form.elements, i, need;
		if (LANG) {   // 언어 주문서 — 이름 · 휴대폰(나라 번호) · 이메일 꼭 + 확인
			if ($.trim(f.name.value).length < 2) return no(f.name, __('이름을 두 글자 이상 입력해 주세요.'));
			if (!hpOk()) return no(hp, __('휴대폰번호를 정확히 입력하세요.'));
			var em = $.trim(f.email.value);
			if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em) || em.length > 50) return no(f.email, __('이메일 주소를 정확히 입력해 주세요.'));
			if (em.toLowerCase() !== $.trim(f.email2.value).toLowerCase()) return no(f.email2, __('이메일 주소가 서로 다릅니다.'));
		} else {
		if ($.trim(f.name.value).length < 2) return no(f.name, '두 글자 이상 입력하세요.');
		if (!reHp.test(hp.value)) return no(hp, '휴대폰번호를 정확히 입력하세요.');
		if (f.auth.value !== '1') return no(hp, '휴대폰 인증을 해 주세요.');
		syncEmail();
		if ($.trim(eId.value) && !emailDom()) return no(eSel.value === '_' ? eDom : eSel, '이메일 도메인을 선택해 주세요.');
		if (!$.trim(eId.value) && emailDom()) return no(eId, '이메일 아이디를 입력해 주세요.');
		if (f.email.value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email.value)) return no(eSel.value === '_' ? eDom : eId, '이메일 주소를 정확히 입력해 주세요.');
		}
		need = form.querySelector('.ru-form');   // 승선명부(2026-10-10) — 비상연락처 하나(예약자 휴대폰과 다른 번호) · 이용객마다 성명·생년월일 YYMMDD·성별·주소 — 서버 reuser_post_rows() 와 같은 규칙
		if (need) {
			var emg = f.ru_emg, ps = need.querySelectorAll('.ru-person'), pp, pn, px, ed = digits(emg.value);
			if (!(LANG ? /^\d{7,15}$/ : /^0\d{8,10}$/).test(ed)) return no(emg, __('비상연락처를 정확히 입력해 주세요.'));
			if (ed === digits(hp.value) || (LANG && f.hp_cc && ed === f.hp_cc.value + digits(hp.value).replace(/^0/, ''))) return no(emg, __('비상연락처는 예약자 휴대폰과 다른 번호를 넣어 주세요.'));
			for (i = 0; i < ps.length; i++) {
				pp = ps[i];
				pn = { n: i + 1 };
				px = pp.querySelector('[name^="ru_name"]');
				if (!$.trim(px.value)) return no(px, __('이용객 {n} 성명을 입력해 주세요.', pn));
				px = pp.querySelector('[name^="ru_birth"]');
				if (!/^\d{6}$/.test(px.value)) return no(px, __('이용객 {n} 생년월일을 YYMMDD 6자리로 입력해 주세요.', pn));
				if (!pp.querySelector('[name^="ru_sex"]:checked')) return no(pp.querySelector('[name^="ru_sex"]'), __('이용객 {n} 성별을 골라 주세요.', pn));
				px = pp.querySelector('[name^="ru_addr"]');
				if (!$.trim(px.value)) return no(px, __('이용객 {n} 주소를 입력해 주세요.', pn));
			}
		}
		if (f.agree.value !== '1') {   // 안 고른 동의 칸(필수약관동의 포함)을 모두 경고색 · 안내 「약관에 동의해 주세요」는 「필수약관동의」 줄 안 글자 오른쪽·체크칸 왼쪽(2026-10-12 대표 지시)
			if (silent) return false;
			ones.forEach(function (c) { if (!c.checked) { c.classList.add('is-invalid'); c.setAttribute('aria-invalid', 'true'); } });
			bad(all, __('약관에 동의해 주세요'));
			var am = document.getElementById(all.getAttribute('data-fm'));
			if (am) all.insertAdjacentElement('beforebegin', am);   // fieldMsg 는 체크칸 뒤에 붙인다 — 앞으로 옮김
			return false;
		}
		return true;
	}
	function checkPay() {
		if (payNow() === 'VBank') {
			var bank = form.querySelectorAll('[name="arr_refund_bank[]"]');
			if (!bank[0].value) return bad(bank[0], '환불받을 은행을 선택해 주세요.');
			if (digits(bank[1].value).length < 6) return bad(bank[1], '계좌번호를 정확히 입력해 주세요.');
			if (!$.trim(bank[2].value)) return bad(bank[2], '예금주를 입력해 주세요.');
			if (!cashNo.disabled && digits(cashNo.value).length < 10) return bad(cashNo, cashNo.placeholder + '를 정확히 입력해 주세요.');
		}
		return true;
	}

	// 한 칸 화면(1199 이하) 결제 창(2026-10-12 대표 지시 — order.php #odSheet): 오른쪽 결제 칸(.od-sum)을 창 안으로 옮기고(PC 는 제자리)
	//   위 입력 + 약관 동의가 다 된 채 페이지 맨 끝까지 내려가면 창이 아래에서 올라온다(동의를 마치는 순간에는 열지 않음 · 약관 글은 저절로 접지 않음 — [접기]로만)(닿을 때 한 번 — 닫으면 약관 섹션 위로 갔다 다시 와야)
	//   아래 줄 [결제하기] = 위 입력·약관 확인 → 빠진 칸으로 스크롤 / 다 되었으면 창 · 창 안 [결제하기] = 결제(위 칸이 빠졌으면 창을 닫고 그 칸으로)
	var sheet = document.getElementById('odSheet'), sheetBody = sheet && sheet.querySelector('.modal-body'), sheetOn = false, arrived = false;
	var mqOne = window.matchMedia('(max-width: 1199px)');
	var agreeSec = form.querySelector('[aria-labelledby="odAgreeT"]');
	function sumHome() {
		if (!sheet) return;
		if (mqOne.matches) { if (sum.parentNode !== sheetBody) sheetBody.appendChild(sum); }
		else {
			if (sheetOn) $(sheet).modal('hide');
			if (sum.parentNode !== side) side.appendChild(sum);
			place();
		}
	}
	if (sheet) {
		$(sheet).on('shown.bs.modal', function () { sheetOn = true; }).on('hidden.bs.modal', function () { sheetOn = false; });
		mqOne.addEventListener('change', sumHome);
		sumHome();
	}
	function sheetShow() { if (sheet && !sheetOn) $(sheet).modal('show'); }
	function tryOpen() { if (arrived && !sheetOn && form.elements.agree.value === '1' && checkTop(true)) sheetShow(); }
	function fromEnd() { return document.documentElement.scrollHeight - (window.innerHeight + window.pageYOffset); }   // 페이지 맨 끝까지 남은 거리
	if (sheet && agreeSec) {
		window.addEventListener('scroll', function () {
			if (!mqOne.matches || sheetOn) return;
			var d = fromEnd();
			if (d <= 8 && !arrived) {   // 페이지 맨 끝에 닿음 — 입력·동의가 다 되었으면 창(2026-10-12 대표 지시 — 동의를 마치는 순간 열던 것은 뺌, 약관 글도 접지 않음)
				arrived = true;
				tryOpen();
			} else if (arrived && d > 80) arrived = false;   // 끝에서 80px 넘게 올라가면 풀린다(다시 끝에 오면 또)
		}, { passive: true });
	}

	$(form).on('submit', function (e) {
		e.preventDefault();
		msgClear(form);
		var one = sheet && mqOne.matches;
		if (one && !sheetOn) { if (checkTop(false)) sheetShow(); return; }   // 아래 줄 [결제하기] · 엔터
		if (!checkTop(true)) {
			if (one) $(sheet).one('hidden.bs.modal', function () { checkTop(false); }).modal('hide');
			else checkTop(false);
			return;
		}
		if (!checkPay()) return;
		var go = form.querySelectorAll('.od-go');
		go.forEach(function (b) { b.disabled = true; });
		$.post('/page/ajax_pay_req.php', $(form).serialize() + (LANG ? '&lang=' + encodeURIComponent(I18N.lang) : ''), function (html) {
			$('.pay-container').html(html);   // 결제 폼 + 그 폼을 여는 스크립트(PC 레이어 · 휴대폰 이동 · ARS) — 실패면 안내창 뒤 이 화면으로
		}).fail(function () {
			go.forEach(function (b) { b.disabled = false; });
			if (window.Swal) Swal.fire({ title: __('연결이 끊겼습니다. 다시 시도해 주세요.') }); else alert(__('연결이 끊겼습니다. 다시 시도해 주세요.'));   // 휴대폰은 결제 칸 단추가 숨어 있어 상자 대신 안내창
		});
	});
	// 휴대폰 결제창(이니시스 — 다른 주소로 넘어감)·ARS 에서 뒤로 오면 bfcache 가 떠날 때 모양 그대로 되살려 결제하기가 잠긴 채였다(2026-10-11, 예약 창과 같은 까닭) — PC 결제창 닫기는 ini_pay_close.php 가 #do-payment 를 켠다
	window.addEventListener('pageshow', function (e) {
		if (e.persisted) form.querySelectorAll('.od-go').forEach(function (b) { b.disabled = false; });
	});

	// 그사이 마감(2026-10-14 대표 지시 · 결정) — 안내창 뒤 [변경]과 같은 예약 창(그 날 ③ 시간 — 마감된 시간은 흐리게, 입력한 예약자 정보는 그대로)
	//   부르는 곳: 결제하기 응답(ajax_pay_req.php 가 결제 폼 대신 이 함수를 부르는 스크립트) · 열 때 이미 마감(order.php data-late) · 자동마감 시각 타이머(data-close-in)
	var LATE = __('예약하시려고 선택하신 시간의 예약이 종료되었습니다.'), lateOn = false;
	function odLate(msg) {
		if (lateOn) return;
		lateOn = true;
		form.querySelectorAll('.od-go').forEach(function (b) { b.disabled = false; });
		var show = function () {
			var done = function () { lateOn = false; form.querySelector('.od-edit').click(); };
			if (window.Swal) Swal.fire({ title: msg || LATE }).then(done); else { alert(msg || LATE); done(); }
		};
		if (sheet && sheetOn) $(sheet).one('hidden.bs.modal', show).modal('hide'); else show();
	}
	window.odLate = odLate;
	var lateNow = form.getAttribute('data-late');
	var closeIn = Number(form.getAttribute('data-close-in') || -1);
	if (lateNow) setTimeout(function () { odLate(lateNow); }, 300);
	else if (closeIn >= 0 && closeIn < 86400 * 2) {   // 자동마감 시각(출항 n분 전 · 회차 마감 시각)이 되면 바로 — 서버 조회 없이. 결제창을 연 동안(결제하기 잠김)은 띄우지 않는다(대표 결정 「결제창을 열었으면 받아 줌」)
		// ⚠ 이 블록의 변수는 lateXxx 로만 — var 는 함수 범위라 위 휴대폰 인증의 check(확인 단추)·tick(시계)과 겹쳐
		//   이용일이 이틀 안인 주문서에서 [확인] 단추가 켜지지 않았다(2026-10-22 tpl572 — 10-14 tpl486 부터)
		var lateDue = Date.now() + closeIn * 1000;
		var lateChk = function () {
			if (Date.now() < lateDue) return;
			var b = form.querySelector('.od-go');
			if (b && b.disabled) return;
			clearInterval(lateTick);
			odLate(LATE);
		};
		var lateTick = setInterval(lateChk, 5000);   // 휴대폰이 잠들었다 깨면 setTimeout 이 늦어 — 짧게 보고, 화면으로 돌아올 때도 본다
		document.addEventListener('visibilitychange', function () { if (!document.hidden) lateChk(); });
		setTimeout(lateChk, closeIn * 1000 + 200);
	}

	syncAgree();
	syncPay();
	place();
}

// ── 예약 내역 (page/myorder.php — 2026-10-10 새로, 기획서 예약조회_새페이지_기획_2026-10-10.md) ──────────
//   창 셋(결제내역 pg · 변경·취소 요청 qa · 승선명부 ui) = ajax_myorder.php 가 그린 내용을 넣는다(옛 페이지 안 스크립트를 옮김)
//   안내사항 [보기]·[접기] = 주문서 약관과 같은 펼침 · 결제내역 [영수증] = 새 창(print-pay.php — 결제 줄마다)
//   변경·취소 요청 = 종류를 고르면 안내(변경 = 기본 상자 · 취소 = 경고 상자)·글 칸 예시·(가상계좌 취소) 환불받을 계좌 → 빠진 칸은 그 칸 아래 빨간 글 → 취소는 한 번 더 묻고 보냄
// 코스안내 목록(page/course.php, 2026-10-12 새 화면) — 분류 글을 누르면 페이지를 다시 읽지 않고 그 자리에서 거른다 · 「예약 가능한 상품만 보기」 토글
//   주소(?cat= · ?avail=1)도 바꿔 새로 열어도 그대로 · 위 검색 바 분류도 같게(모양만 — 'yz:cat-sync', 달력·검색은 열지 않음) · 카드 주소의 cat 도 바꿔 상세의 검색 바가 그 분류
//   예약 가능 여부는 서버가 카드마다 data-avail(날짜를 골랐으면 그날, 아니면 앞으로 예약할 수 있는 회차가 하나라도)
function courseList() {
	var root = document.getElementById('courseList');
	if (!root) return;
	var tabs = root.querySelectorAll('.cl-tab'), sw = root.querySelector('.cl-avail input'), items = root.querySelectorAll('.cl-item');
	var empty = root.querySelector('.cl-empty'), count = root.querySelector('[data-cl-count]');
	var on = root.querySelector('.cl-tab.is-active'), cat = on ? on.getAttribute('data-cat') || '' : '';
	function apply() {
		var only = !!(sw && sw.checked), n = 0;
		items.forEach(function (li) {
			var ok = (!cat || (li.getAttribute('data-cat') || '').split(' ').some(function (c) { return c.indexOf(cat) === 0; })) && (!only || li.getAttribute('data-avail') === '1');   // 그 분류(하위 포함) — data-cat = 대표 분류 + 추가 분류(빈칸으로, 2026-10-17)
			li.hidden = !ok;
			if (ok) n++;
		});
		if (count) count.textContent = n;
		if (empty && items.length) empty.hidden = n > 0;   // 상품이 하나도 없는 목록이면 서버 글 그대로
	}
	function setUrl() {
		var u = new URL(location.href);
		if (cat) u.searchParams.set('cat', cat); else u.searchParams.delete('cat');
		if (sw && sw.checked) u.searchParams.set('avail', '1'); else u.searchParams.delete('avail');
		history.replaceState(history.state, '', u.pathname + u.search + u.hash);
		root.querySelectorAll('.cl-card').forEach(function (a) {
			var h = new URL(a.href);
			if (cat) h.searchParams.set('cat', cat); else h.searchParams.delete('cat');
			a.href = h.pathname + h.search;
		});
	}
	tabs.forEach(function (b) {
		b.addEventListener('click', function () {
			cat = b.getAttribute('data-cat') || '';
			tabs.forEach(function (t) { var a = t === b; t.classList.toggle('is-active', a); t.setAttribute('aria-pressed', a ? 'true' : 'false'); });
			apply();
			setUrl();
			var bar = document.querySelector('#reserveBar .reserve-toggle'), r = bar && bar.querySelector('input[name="cat"][value="' + cat + '"]');
			if (r) { r.checked = true; bar.dispatchEvent(new CustomEvent('yz:cat-sync')); }
		});
	});
	if (sw) sw.addEventListener('change', function () { apply(); setUrl(); });
}

// 코스상세(page/course-view.php, 2026-10-12 새로) — 사진 슬라이드(「1 / 9」 · 이전·다음 · 손가락 밀기) · 바로가기 줄(누르면 그 구역으로 · 지금 구역에 밑줄)
//   courseView() = 페이지(문서 · 창 스크롤) · courseView(창 본문, 창 본문) = 코스상세 창(2026-10-13 — 그 안만 · 스크롤은 창 본문). 돌려주는 함수 = 처리기·슬라이드 걷기(창을 닫거나 다른 코스를 열 때)
function courseView(root, box) {
	root = root || document;
	var subs = [], sw = null, stops = [];   // stops — 걷을 때 부를 것(주변 추천 자동 넘김 시계·관찰 — 2026-10-13)
	function on(t, type, fn, opt) { t.addEventListener(type, fn, opt); subs.push([t, type, fn, opt]); }
	function off() { subs.forEach(function (s) { s[0].removeEventListener(s[1], s[2], s[3]); }); subs = []; stops.forEach(function (f) { f(); }); stops = []; if (sw) { sw.destroy(true, true); sw = null; } }
	var gal = root.querySelector('.cv-gallery');
	if (gal && window.Swiper && gal.querySelectorAll('.swiper-slide').length > 1) {
		var cnt = gal.querySelector('.cv-gallery__count b');
		sw = new Swiper(gal, {
			loop: true,
			speed: 400,
			navigation: { prevEl: gal.querySelector('.cv-gallery__nav.is-prev'), nextEl: gal.querySelector('.cv-gallery__nav.is-next') },
			on: { slideChange: function (s) { if (cnt) cnt.textContent = s.realIndex + 1; } }
		});
	}
	[].forEach.call(root.querySelectorAll('.cv-scroll'), function (sc) {   // 휴대폰 넓은 요금표 — 끝까지 밀면 오른쪽 흐림을 뺌(2026-10-12)
		var w = sc.querySelector('.cv-table-wrap');
		if (!w) return;
		function end() {
			sc.classList.toggle('is-end', w.scrollLeft + w.clientWidth >= w.scrollWidth - 2);
			sc.classList.toggle('is-wide', w.scrollWidth > w.clientWidth + 2);   // 넘치면 손 모양(마우스 끌기)
		}
		on(w, 'scroll', end, { passive: true });
		on(window, 'resize', end);
		end();
		// 마우스로 끌어 넘기기(2026-10-13 대표 지시 — PC 상세 창 등에서 아래 막대로만 움직였다) — 손가락은 원래 밀리므로 마우스만 · 4px 넘게 움직여야 끌기
		on(w, 'pointerdown', function (e) {
			if (e.pointerType !== 'mouse' || e.button !== 0 || w.scrollWidth <= w.clientWidth + 2) return;
			var x0 = e.clientX, s0 = w.scrollLeft, moved = false;
			e.preventDefault();   // 글 고르기 시작을 막음
			function mv(ev) {
				var dx = ev.clientX - x0;
				if (!moved && Math.abs(dx) > 4) { moved = true; w.classList.add('is-drag'); }
				if (moved) w.scrollLeft = s0 - dx;
			}
			function up() {
				window.removeEventListener('pointermove', mv);
				window.removeEventListener('pointerup', up);
				window.removeEventListener('pointercancel', up);
				w.classList.remove('is-drag');
			}
			window.addEventListener('pointermove', mv);
			window.addEventListener('pointerup', up);
			window.addEventListener('pointercancel', up);
		});
	});
	// 추천여행 상세 아래 주변 추천 줄 — 페이지·창 모두
	//   흐름(2026-10-13 대표 지시 「한 칸씩 넘기지 말고 부드럽게 왼쪽으로」 — 같은 날 5초마다 한 장 → 이것): 초당 40px 로 왼쪽으로 계속 흐름
	//     끝없이: 카드 한 벌을 앞뒤로 한 번씩 더 그림(.is-clone — 화면낭독기·Tab 은 건너뜀) · 가운데 벌 안에서 움직이고, 벗어나면 같은 그림인 자리로 옮김(눈에 안 보임)
	//     흐르지 않음: 카드가 줄을 넘치지 않을 때(복사 없음) · 움직임 줄이기 설정(옛 방식 — 카드 붙임 · ‹ › 줄 폭만큼)
	//     멈춤: 마우스를 올려 두면 천천히 섬 · 끄는 동안·손가락을 대거나 밀린 것이 멈출 때까지·초점이 안에·화면 밖(30% 미만)·다른 탭은 바로 섬 → 0.6초 쉬었다 천천히 다시
	//   끌기: 마우스만(손가락은 원래 밀림) · 4px 넘게 움직여야 끌기 · 놓으면 끌던 빠르기로 미끄러지다 섬(카드 칸에 맞추지 않음 — 「놓으면 특정 자리로 바로 가서 끊긴다」) · 끈 뒤 생기는 누름 하나는 막음(카드가 열리지 않게)
	//   ‹ ›: 이전·다음 카드 시작으로 부드럽게 · 줄 세로 가운데 좌우(.rv-near__btn — 마우스를 올리면 보임, 단추 위도 「올림」이라 멈춤) · 카드가 넘치지 않으면 숨김(.is-fit)
	[].forEach.call(root.querySelectorAll('.rv-near__list'), function (list) {
		var box = list.closest('.rv-near__body') || list;   // 줄 + ‹ › — 마우스 올림·‹ › 누름을 보는 범위
		var SPEED = 0.04;   // px/ms — 초당 40px(2026-10-13 대표 결정)
		var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		[].forEach.call(list.querySelectorAll('.is-clone'), function (c) { c.remove(); });
		var orig = [].slice.call(list.children).filter(function (c) { return c.classList.contains('rc-item'); });
		var loop = false, W = 0, pos = 0, v = 0, glide = 0, raf = 0, last = 0, quiet = 0, settleT = 0, frac = 0;
		var drag = null, hover = false, focus = false, hold = false, seen = false;
		function now() { return window.performance ? performance.now() : Date.now(); }
		function gap() { return parseFloat(getComputedStyle(list).columnGap) || 0; }
		function step() { var c = orig[0]; return c ? c.getBoundingClientRect().width + gap() : 0; }
		function wide() { return list.scrollWidth > list.clientWidth + 2; }
		function go(left) { list.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' }); }
		function sub(x) {   // 소수 자리 — 줄 스크롤은 정수 픽셀로만 움직여(화면 배율 100%) 초당 40px 이면 한 장면씩 멈칫거린다 → 남는 소수만큼 카드를 살짝 밂(CSS --near-sub)
			x = Math.round(x * 100) / 100;
			if (x !== frac) { frac = x; list.style.setProperty('--near-sub', x + 'px'); }
		}
		function set(p) {   // 가운데 벌 [W, 2W) 안으로 — 앞뒤 벌은 같은 그림이라 옮겨도 보이지 않음
			while (p >= 2 * W) p -= W;
			while (p < W) p += W;
			pos = p;
			var ip = Math.floor(p);
			list.scrollLeft = ip;
			sub(ip - p);
		}
		function clones(want) {
			[].forEach.call(list.querySelectorAll('.is-clone'), function (c) { c.remove(); });
			if (!want) return;
			var head = document.createDocumentFragment(), tail = document.createDocumentFragment();
			orig.forEach(function (c) {
				[head, tail].forEach(function (f) {
					var k = c.cloneNode(true);
					k.classList.add('is-clone');
					k.setAttribute('aria-hidden', 'true');
					[].forEach.call(k.querySelectorAll('a, button, [tabindex]'), function (a) { a.setAttribute('tabindex', '-1'); });
					f.appendChild(k);
				});
			});
			list.insertBefore(head, orig[0]);
			list.appendChild(tail);
		}
		function measure() {   // 처음·줄 폭이 바뀔 때 — 한 벌이 줄을 넘치면 흐름(복사 있음), 아니면 그대로
			var st = step(), cw = list.clientWidth;
			var on1 = !reduce && orig.length > 1 && cw > 0 && orig.length * st - gap() > cw + 2;
			if (on1 !== loop) {
				loop = on1;
				list.classList.toggle('is-loop', loop);
				clones(loop);
				W = orig.length * st;
				if (loop) set(W);
				else list.scrollLeft = 0;
			} else if (loop) {
				var r = (pos - W) / W;   // 지난 폭에서의 자리 비율 그대로
				W = orig.length * st;
				set(W + r * W);
			}
			if (box !== list) box.classList.toggle('is-fit', !wide());
			wake();
		}
		function want(t) { return loop && seen && !hover && !focus && !hold && !drag && !glide && !document.hidden && t >= quiet; }
		function frame(t) {
			raf = 0;
			var dt = last ? Math.min(t - last, 50) : 16;
			last = t;
			if (glide) {   // 끌기를 놓은 뒤 미끄러짐 — 빠르기가 조금씩 줄어 섬
				set(pos + glide * dt);
				glide *= Math.pow(0.996, dt);
				if (Math.abs(glide) < 0.02) { glide = 0; quiet = t + 600; }
			} else {
				var to = want(t) ? SPEED : 0;
				v += (to - v) * (1 - Math.exp(-dt / (to ? 500 : 200)));   // 다시 흐를 때 0.5초·멈출 때 0.2초에 걸쳐 부드럽게
				if (!to && v < 0.003) v = 0;
				if (v) set(pos + v * dt);
			}
			if (loop && seen && !document.hidden) raf = requestAnimationFrame(frame);
			else last = 0;
		}
		function wake() { if (!raf && loop && seen && !document.hidden) { last = 0; raf = requestAnimationFrame(frame); } }
		function stop() { if (raf) cancelAnimationFrame(raf); raf = 0; last = 0; }
		function kill(e) { e.preventDefault(); e.stopPropagation(); window.removeEventListener('click', kill, true); }
		function mv(e) {
			if (!drag) return;
			var dx = e.clientX - drag.x;
			if (!drag.moved && Math.abs(dx) > 4) { drag.moved = true; list.classList.add('is-drag'); }
			if (!drag.moved) return;
			var t = now(), p = drag.s - dx;
			if (t > drag.t) drag.vs = 0.7 * ((drag.lx - e.clientX) / (t - drag.t)) + 0.3 * drag.vs;   // 끄는 빠르기(px/ms, 왼쪽으로 끌면 +)
			drag.lx = e.clientX;
			drag.t = t;
			if (loop) {
				if (p >= 2 * W) { drag.s -= W; p -= W; } else if (p < W) { drag.s += W; p += W; }   // 가운데 벌 안에서(같은 그림)
				pos = p;
				sub(0);
			}
			list.scrollLeft = p;
		}
		function up() {
			window.removeEventListener('pointermove', mv);
			window.removeEventListener('pointerup', up);
			window.removeEventListener('pointercancel', up);
			if (drag && drag.moved) {
				list.classList.remove('is-drag');
				if (loop) {
					var vs = now() - drag.t < 80 ? Math.max(-2.5, Math.min(2.5, drag.vs)) : 0;   // 놓기 직전에 멈춰 있었으면 미끄러지지 않음
					glide = Math.abs(vs) >= 0.05 ? vs : 0;
					quiet = now() + 600;
				} else {
					var st = step();
					if (st) go(Math.round(list.scrollLeft / st) * st);
				}
				window.addEventListener('click', kill, true);
				setTimeout(function () { window.removeEventListener('click', kill, true); }, 0);
			}
			drag = null;
			wake();
		}
		on(list, 'pointerdown', function (e) {
			if (e.pointerType !== 'mouse' || e.button !== 0 || !wide()) return;
			drag = { x: e.clientX, s: list.scrollLeft, moved: false, lx: e.clientX, t: now(), vs: 0 };
			v = 0;
			glide = 0;
			if (loop) pos = list.scrollLeft;
			window.addEventListener('pointermove', mv);
			window.addEventListener('pointerup', up);
			window.addEventListener('pointercancel', up);
		});
		on(list, 'dragstart', function (e) { e.preventDefault(); });   // 카드 그림·링크를 끌어 옮기기(브라우저 기본) 막음
		on(list, 'scroll', function () {   // 손가락·트랙패드·‹ › 로 움직임 — 내가 옮긴 것(반올림 차이)은 그냥
			if (!loop || drag || Math.abs(list.scrollLeft - pos) <= 1.5) return;
			pos = list.scrollLeft;
			sub(0);
			v = 0;
			glide = 0;
			quiet = Math.max(quiet, now() + 600);
			clearTimeout(settleT);
			settleT = setTimeout(function () { if (!hold && !drag) set(pos); }, 150);   // 멈춘 뒤 가운데 벌로(같은 그림)
		}, { passive: true });
		on(box, 'pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });   // 손가락 누름은 마우스 올림으로 치지 않음
		on(box, 'pointerleave', function (e) { if (e.pointerType === 'mouse') hover = false; });
		on(list, 'focusin', function (e) { focus = e.target.matches(':focus-visible'); if (focus) v = 0; });
		on(list, 'focusout', function () { focus = false; });
		function release() { hold = false; quiet = Math.max(quiet, now() + 600); }
		on(list, 'touchstart', function () { hold = true; v = 0; glide = 0; }, { passive: true });
		on(list, 'touchend', release, { passive: true });
		on(list, 'touchcancel', release, { passive: true });
		on(document, 'visibilitychange', function () { if (document.hidden) stop(); else wake(); });
		on(box, 'click', function (e) {   // ‹ › — 흐르는 줄은 여기서(카드 시작으로), 흐르지 않는 줄은 아래 공통 처리(줄 폭만큼)
			var b = e.target.closest('.rv-near__btn'), st = step();
			if (!b || !loop || !st) return;
			v = 0;
			glide = 0;
			set(pos);
			var k = pos / st;
			go(+b.getAttribute('data-near') < 0 ? (Math.ceil(k - 0.02) - 1) * st : (Math.floor(k + 0.02) + 1) * st);
			quiet = now() + 1500;
		});
		if ('IntersectionObserver' in window) {
			var io = new IntersectionObserver(function (es) { seen = es[0].isIntersecting; if (seen) wake(); else stop(); }, { threshold: 0.3 });
			io.observe(list);
			stops.push(function () { io.disconnect(); });
		} else seen = true;
		if ('ResizeObserver' in window) {   // 창이 열리며 폭이 생길 때도
			var ro = new ResizeObserver(function () { measure(); });
			ro.observe(list);
			stops.push(function () { ro.disconnect(); });
		} else on(window, 'resize', measure);
		measure();
		stops.push(function () { stop(); up(); clearTimeout(settleT); });
	});
	var nav = root.querySelector('.cv-nav');
	if (!nav) return off;
	var links = [].slice.call(nav.querySelectorAll('.cv-nav__item'));
	var secs = links.map(function (a) { return root.querySelector(a.getAttribute('href')); });
	function bottom() { return box ? box.scrollTop + box.clientHeight >= box.scrollHeight - 2 : window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 2; }
	function mark() {   // 지금 구역 = 바로가기 줄 아래 끝을 지난 마지막 구역(맨 아래에 닿으면 마지막)
		var line = nav.getBoundingClientRect().bottom + 80, cur = -1;   // 바로가기로 간 구역은 줄 아래 24 에 멈춘다(.cv-sec scroll-margin-top) · 첫 구역은 줄 아래 48(코스상세 — theme.css) — 줄이 위에 붙기 전부터 첫 구역이 켜지게, 다음 구역도 조금 미리(2026-10-13 대표 지시, 옛 여유 40)
		secs.forEach(function (s, i) { if (s && s.getBoundingClientRect().top <= line) cur = i; });
		if (bottom()) cur = secs.length - 1;
		links.forEach(function (a, i) {
			var hit = i === cur;
			a.classList.toggle('is-active', hit);
			if (hit) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current');
			if (hit && nav.scrollWidth > nav.clientWidth) nav.scrollTo({ left: a.offsetLeft - 16, behavior: 'smooth' });   // 휴대폰 — 지금 구역 글이 줄 안에 보이게
		});
	}
	var tick = false;
	on(box || window, 'scroll', function () { if (tick) return; tick = true; requestAnimationFrame(function () { tick = false; mark(); }); }, { passive: true });
	on(window, 'resize', mark);
	links.forEach(function (a, i) {
		on(a, 'click', function (e) {
			if (!secs[i]) return;
			e.preventDefault();
			secs[i].scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });   // 멈추는 자리 = theme.css .cv-sec scroll-margin-top
			history.replaceState(history.state, '', a.getAttribute('href'));
		});
	});
	mark();
	return off;
}

// 상세 창(2026-10-13 대표 결정): 부트스트랩 오프캔버스(page/_modal.php #cvPanel — 모든 페이지에 빈 틀) — PC·태블릿 오른쪽 서랍 720 · 휴대폰 전체 화면, 안 = 휴대폰 상세 모양
//   코스상세(page/ajax_course.php w=cv) — 여는 곳: 코스안내 목록 카드 · 첫 화면 코스안내 섹션(.sec-course — 레이아웃 A·B)의 상품 상세 링크 · 배시간표 「코스 자세히」
//   추천여행 상세(page/ajax_recommend_view.php w=rv) — 여는 곳: 추천여행 상세로 가는 모든 링크(recommend.php?tab=&wr_id= — 목록 · 첫 화면 추천여행·주변여행지 · 승선위치 주변여행지 · 서브 오른쪽 추천 · 상세 아래 주변 추천)
//   본문은 페이지와 같은 파일(_course_view_body.php · _recommend_view_body.php) · 머리 제목 = 본문 data-head(추천맛집 등, 없으면 「코스상세」)
//   주소 = 연 상세의 주소(pushState, 표지 history.state.cvp = 창 안에서 몇 번째 상세인지) — 새로고침·주소 복사·공유하면 상세 페이지
//     · 창 안에서 다른 상세(주변 추천 카드)를 누르면 같은 창에서 바뀜(cvp + 1) — 뒤로가기 = 앞에 보던 상세 · 「<」·닫기·바깥·Esc = 창을 닫고 연 페이지로(cvp 만큼 되돌림) · 앞으로가기 = 다시 열림
//   「예약하기」 등 단추(본문의 .cvp-go 를 창 아래 줄로 옮김) — 티켓예약 창(#mo-cart)이 서랍 위에(오프캔버스 1045 < 창 1050) · 닫으면 읽던 상세 그대로
//   Ctrl·Shift·가운데 누름은 그대로 새 탭·새 창(페이지) · 스크립트가 없으면 링크 그대로 페이지 · 슬라이더를 끌어 넘긴 누름은 Swiper·흐르는 줄이 먼저 막는다
function coursePanel() {
	var panel = document.getElementById('cvPanel');
	if (!panel || !window.bootstrap) return;
	var LINKS = '#courseList a.cl-card, .sec-course a[href*="course-view.php?cid="], .sch-co__more a[href*="course-view.php?cid="], a[href*="recommend.php?tab="][href*="wr_id="]';   // 첫 화면 상점 카드 중 상품이 없는 것은 코스안내 목록 주소라 그대로 페이지
	var oc = window.bootstrap.Offcanvas.getOrCreateInstance(panel);
	var body = panel.querySelector('.cvp-body'), foot = panel.querySelector('.cvp-foot'), head = panel.querySelector('.cvp-head__title');
	var title0 = document.title, head0 = head ? head.textContent : '', seq = 0, off = null, mapLoad = null, cur = '', lb = null;
	function shown() { return (panel.classList.contains('show') || panel.classList.contains('showing')) && !panel.classList.contains('hiding'); }
	function bare(href) { var u = new URL(href, location.href); u.hash = ''; return u.href; }
	function depth() { return (history.state && history.state.cvp) || 0; }
	function clear() {
		seq++;
		if (off) { off(); off = null; }
		if (lb) { try { lb.destroy(); } catch (e) {} lb = null; }
		body.innerHTML = '';
		foot.innerHTML = '';
		foot.hidden = true;
	}
	function load(href) {
		var u = new URL(href, location.href), rv = /\/recommend\.php$/.test(u.pathname), q = new URLSearchParams(), my;
		clear();
		my = seq;
		cur = bare(href);
		body.innerHTML = '<div class="bk-loading" role="status">불러오는 중…</div>';
		body.scrollTop = 0;
		if (rv) { q.set('tab', u.searchParams.get('tab') || ''); q.set('wr_id', u.searchParams.get('wr_id') || ''); q.set('w', 'rv'); }
		else { u.searchParams.forEach(function (v, k) { q.set(k, v); }); q.set('w', 'cv'); }
		fetch((rv ? '/page/ajax_recommend_view.php?' : '/page/ajax_course.php?') + q.toString(), { credentials: 'same-origin' })
			.then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
			.then(function (html) {
				if (my !== seq) return;   // 그사이 닫았거나 다른 상세를 열었다
				body.innerHTML = html;
				var cv = body.querySelector('.cvp'), go = body.querySelector('.cvp-go');
				if (go) { foot.appendChild(go); foot.hidden = false; }
				if (cv && cv.getAttribute('data-title')) document.title = cv.getAttribute('data-title');
				if (head) head.textContent = (cv && cv.getAttribute('data-head')) || head0;
				off = courseView(body, body);
				mapIn();
				if (window.rcStatScan) window.rcStatScan();   // 주변 추천 카드 노출 집계(assets/js/recom-stat.js — 실린 페이지에서만)
				if (window.GLightbox && body.querySelector('.glightbox')) lb = window.GLightbox({ selector: '#cvPanel .glightbox', touchNavigation: true, loop: true });   // 투어맵 크게
			})
			.catch(function () { if (my === seq) body.innerHTML = '<p class="cvp-msg">정보를 불러오지 못했습니다.<br>잠시 뒤 다시 시도해 주세요.</p>'; });
	}
	// 지도 — 카카오 지도 SDK(autoload=false) + map.js 는 처음 지도가 있는 상세를 열 때만 받는다(여는 페이지의 첫 받기는 그대로). 받으면 map.js 가 지금 창의 지도를 그린다
	function mapIn() {
		if (!body.querySelector('.dmap')) return;
		if (window.kakao && window.kakao.maps && window.kakao.maps.LatLng && window.smallMap) { window.smallMap(); return; }
		if (mapLoad) return;
		function js(src) { return new Promise(function (ok, no) { var s = document.createElement('script'); s.src = src; s.onload = ok; s.onerror = no; document.head.appendChild(s); }); }
		mapLoad = js(panel.getAttribute('data-map-sdk'))
			.then(function () { return new Promise(function (ok) { window.kakao.maps.load(ok); }); })
			.then(function () { return js(panel.getAttribute('data-map-js')); })
			.catch(function () { mapLoad = null; });
	}
	document.addEventListener('click', function (e) {
		var a = e.target.closest(LINKS);
		if (!a || e.defaultPrevented || e.button || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || a.target === '_blank') return;
		e.preventDefault();
		if (shown()) {   // 창 안(주변 추천 등) — 같은 창에서 바뀜
			if (bare(a.href) === cur) return;
			history.pushState({ cvp: depth() + 1 }, '', a.href);
			load(a.href);
			return;
		}
		history.pushState({ cvp: 1 }, '', a.href);
		load(a.href);
		oc.show();
	});
	panel.addEventListener('hide.bs.offcanvas', function () {   // 「<」·닫기·바깥·Esc — 창이 남긴 기록을 모두 되돌린다(뒤로가기로 닫힐 때는 이미 연 페이지 기록이라 그대로)
		var n = depth();
		if (n) history.go(-n);
	});
	panel.addEventListener('hidden.bs.offcanvas', function () {
		clear();
		cur = '';
		document.title = title0;
		if (head) head.textContent = head0;
	});
	window.addEventListener('popstate', function () {
		var n = depth();
		if (!n) { if (shown()) oc.hide(); return; }
		if (!shown()) { load(location.href); oc.show(); }   // 앞으로가기
		else if (bare(location.href) !== cur) load(location.href);   // 창 안에서 뒤로·앞으로 — 그 상세로(#창 기록만 바뀐 것은 그대로)
	});
	// 창 위에 뜬 창(티켓예약 · 큰 지도)을 닫은 뒤 — 부트스트랩 창과 오프캔버스는 키보드 초점 가두기를 함께 쓰지 못해(창이 열리며 서랍 것의 처리기를 떼어 가고
	//   서랍 것은 켜진 줄 알아 다시 켜지 않는다) 끄고 다시 켠다. 초점은 창을 연 단추로 돌아간 그대로
	$('.modal').on('hidden.bs.modal', function () {
		if (!shown() || !oc._focustrap) return;
		setTimeout(function () {
			var a = document.activeElement;
			try { oc._focustrap.deactivate(); oc._focustrap.activate(); } catch (err) { return; }
			if (a && a !== document.body && panel.contains(a)) a.focus();
		});
	});
}

// 추천여행 상세 아래 주변 추천 줄 ‹ › — 줄 폭만큼 옆으로(페이지·창 모두 — 2026-10-13, 옛 Swiper 대신 CSS 넘기기 줄) · 흐르는 줄(.is-loop)은 courseView 가 카드 시작으로
$(document).on('click', '.rv-near__btn', function () {
	var list = this.closest('.rv-near').querySelector('.rv-near__list');
	if (list && !list.classList.contains('is-loop')) list.scrollBy({ left: (+this.getAttribute('data-near') || 1) * list.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
});

function myorderPage() {
	var page = document.getElementById('mo-page');
	if (!page) return;
	['#mo-qa', '#mo-pay', '#mo-reuser'].forEach(function (id) {
		$(id).on('show.bs.modal', function (e) {
			var $m = $(this), ed = $(e.relatedTarget);
			$m.find('.modal-content').html('<div class="bk-loading" role="status">불러오는 중…</div>');
			$.post('/page/ajax_myorder.php', { w: ed.data('w'), id: ed.data('id'), qty: ed.data('qty') }, function (html) {
				$m.find('.modal-content').html(html);
			});
		});
	});
	page.addEventListener('click', function (e) {
		var v = e.target.closest('.od-terms__view'), doc = v && document.getElementById(v.getAttribute('aria-controls'));
		if (!doc) return;
		var open = v.getAttribute('aria-expanded') !== 'true';
		doc.hidden = !open;
		v.setAttribute('aria-expanded', open ? 'true' : 'false');
		v.firstElementChild.textContent = open ? '접기' : '보기';
	});

	// 결제내역 창 — 영수증(가운데 작은 새 창)
	$(document).on('click', '#mo-pay .print-pay', function () {
		var w = 462, h = 800;
		window.open('/page/print-pay.php?id=' + encodeURIComponent($(this).data('id')), 'print', 'scrollbars=no, resizable=no, height=' + h + ', width=' + w + ', left=' + (screen.width / 2 - w / 2) + ', top=' + (screen.height / 2 - h / 2));
	});

	// 예약 변경·취소 창(2026-10-19 트립 티켓 7단계 — page/ajax_myorder.php w=qa) — 탭(인원 취소 qc · 시간 변경 tc(회차형만) · 전체 취소 cu): 고른 판만 보이고 그 판의 칸만 보낸다
	//   인원 취소: 구분마다 −/+ 로 줄일 수 → 0.25초 모아 w=qx 로 계산(취소 인원·금액·수수료·환불) → 확인창 → w=qd · 시간 변경: 회차 하나 고름 → 확인창 → w=td · 전체 취소: 사유 (+ 가상계좌 환불계좌) → 확인창 → w=cu
	//   옛 「이용시간·인원 변경」 요청 폼(w=eu — 관리자가 손으로 처리)은 뺐다(날짜 변경은 안내 한 줄 「취소 후 다시 예약」)
	function kindOf(form) { var c = form.querySelector('input[name=k]:checked'); return c ? c.value : ''; }
	function panelOf(form) { var k = kindOf(form); return k ? form.querySelector('.mo-panel[data-k="' + k + '"]') : null; }
	function setPanel(form, k) {
		form.querySelectorAll('.mo-panel').forEach(function (p) {
			var on = p.getAttribute('data-k') === k;
			p.hidden = !on;
			p.querySelectorAll('input, select, textarea').forEach(function (x) { if (x.name) x.disabled = !on; });   // 안 보이는 판의 칸은 보내지 않는다
		});
	}
	var qxTimer = 0, qxSeq = 0;
	function qcCalc(form) {   // 인원 취소 계산 — 줄일 수가 바뀔 때마다(0.25초 모아서 · 늦게 온 앞 응답은 버림)
		var panel = form.querySelector('.mo-panel[data-k=qc]'), go = panel && panel.querySelector('.mo-qa-go'), calc = panel && panel.querySelector('.mo-qc__calc'), msg = panel && panel.querySelector('.mo-qc__msg');
		if (!go) return;
		var cut = [].map.call(panel.querySelectorAll('input[name="cut[]"]'), function (x) { return parseInt(x.value, 10) || 0; });
		go.disabled = true;
		clearTimeout(qxTimer);
		if (!cut.some(function (n) { return n > 0; })) { calc.hidden = true; msg.textContent = ''; return; }
		var seq = ++qxSeq;
		qxTimer = setTimeout(function () {
			$.post('/page/ajax_myorder.php', { w: 'qx', oid: form.getAttribute('data-oid'), cut: cut }, function (d) {
				if (seq !== qxSeq) return;
				if (d && d.ok) {
					['people', 'amount', 'fees', 'refund'].forEach(function (k) { calc.querySelector('[data-c=' + k + ']').textContent = d[k]; });
					calc.hidden = false; msg.textContent = ''; go.disabled = false;
				} else { calc.hidden = true; msg.textContent = d && d.msg ? d.msg : '연결이 끊겼습니다. 다시 시도해 주세요.'; }
			}, 'json').fail(function () { if (seq === qxSeq) { calc.hidden = true; msg.textContent = '연결이 끊겼습니다. 다시 시도해 주세요.'; } });
		}, 250);
	}
	$(document).on('change', '#mo-qa input[name=k]', function () {
		var form = this.form;
		setPanel(form, this.value);
		if (this.value === 'qc') qcCalc(form);
		fieldFixed({ target: form.querySelector('input[name=k]') });
	});
	$(document).on('click', '#mo-qa [data-qc]', function () {   // 남길 인원 −/+ (tpl575 — 칸은 예약 인원에서 줄인 뒤 남는 수, 줄인 수가 cut[] 로 간다. 옛: 취소 인원을 0 에서 올림)
		var row = this.closest('.mo-qc__row'), keep = row.querySelector('input[name="keep[]"]'), cut = row.querySelector('input[name="cut[]"]'), max = parseInt(keep.getAttribute('data-max'), 10) || 0;
		var v = Math.min(max, Math.max(0, (parseInt(keep.value, 10) || 0) + parseInt(this.getAttribute('data-qc'), 10)));
		keep.value = v;
		cut.value = max - v;
		row.querySelector('[data-qc="-1"]').disabled = v <= 0;
		row.querySelector('[data-qc="1"]').disabled = v >= max;
		var em = row.querySelector('.mo-qc__cut');
		if (em) { em.textContent = max - v > 0 ? ' · ' + (max - v) + '명 취소' : ''; em.hidden = max - v <= 0; }
		row.classList.toggle('is-cut', max - v > 0);
		qcCalc(this.form);
	});
	$(document).on('change', '#mo-qa input[name=qa_r]', function () {   // 전체 취소 사유 단추 — 「기타」만 글 칸(2026-10-20)
		var etc = this.form.querySelector('[name=qa_q]'), on = this.value === '기타';
		etc.hidden = !on;
		fieldFixed({ target: this.form.querySelector('input[name=qa_r]') });   // 안내는 첫 단추에 붙어 있다
		if (on) etc.focus();
	});
	$(document).on('change', '#mo-qa input[name=gt]', function () {   // 바꿀 시간 고름
		// 고른 다른 시간 = 대표색 테두리 · 지금 시간을 다시 고르면 대표색 2 테두리가 지금 시간으로 돌아오고 단추 꺼짐(2026-10-22 대표 지시)
		var form = this.form, cur = this.closest('.mo-tc__slot').classList.contains('is-cur');
		form.querySelectorAll('.mo-tc__slot').forEach(function (sl) { sl.classList.toggle('is-on', !cur && sl.querySelector('input').checked); });
		form.querySelector('.mo-tc').classList.toggle('is-picked', !cur);
		form.querySelector('.mo-panel[data-k=tc] .mo-qa-go').disabled = cur;
	});
	$(document).on('submit', '#mo-qa form', function (e) {
		e.preventDefault();
		var form = this, k = kindOf(form), panel = panelOf(form), oid = form.getAttribute('data-oid');
		function bad(el, msg) { fieldMsg(el, msg); el.focus(); return false; }
		function bankOk(name) {   // 가상계좌 환불계좌(인원 취소 qc_bank[] · 전체 취소 arr_refund_bank[])
			var bank = panel.querySelectorAll('[name="' + name + '"]:not(:disabled)');
			if (!bank.length) return true;
			if (!bank[0].value) return bad(bank[0], '환불받을 은행을 선택해 주세요.');
			if (String(bank[1].value).replace(/\D/g, '').length < 6) return bad(bank[1], '계좌번호를 정확히 입력해 주세요.');
			if (!$.trim(bank[2].value)) return bad(bank[2], '예금주를 입력해 주세요.');
			return true;
		}
		function send(w) {
			var go = panel.querySelector('.mo-qa-go');
			go.disabled = true;
			$.post('/page/ajax_myorder.php', $(panel).find(':input').serialize() + '&' + $.param({ w: w, oid: oid }), function (data) {
				var m = String(data.result || '').split('\n');   // 줄바꿈 앞 = 제목 · 뒤 = 설명(인원 취소 완료 + 카드사 안내 — 2026-10-22 tpl568)
				Swal.fire({ title: m[0], text: m.slice(1).join(' ') || undefined }).then(function () { location.reload(); });
			}, 'json').fail(function () {
				go.disabled = false;
				formMsg(form, '연결이 끊겼습니다. 다시 시도해 주세요.');
			});
		}
		if (!k || !panel) return bad(form.querySelector('input[name=k]'), '하실 일을 골라 주세요.');
		if (k === 'qc') {
			var calc = panel.querySelector('.mo-qc__calc');
			if (!calc || calc.hidden) return;   // 계산 전·거절 — 단추가 잠겨 있다
			if (calc.querySelector('[data-c=refund]').textContent !== '0원' && !bankOk('qc_bank[]')) return;   // 요금 없는 인원(유아 등)만 줄이면 환불할 돈이 없어 계좌 없이(2026-10-20)
			// 글 = 「취소 인원 · 환불 금액」 한 줄(2026-10-22 tpl580 대표 지시 — tpl579 의 둘째 줄 「취소된 인원은 다시 되돌릴 수 없습니다.」 뺌, 단추 아래 안내가 말한다)
			Swal.fire({ title: '인원을 취소할까요?', text: '취소 인원 ' + calc.querySelector('[data-c=people]').textContent + ' · 환불 금액 ' + calc.querySelector('[data-c=refund]').textContent, showCancelButton: true, confirmButtonText: '인원 취소', cancelButtonText: '닫기' })
				.then(function (r) { if (r.isConfirmed) send('qd'); });
			return;
		}
		if (k === 'tc') {
			var gt = panel.querySelector('input[name=gt]:checked');
			if (!gt || gt.closest('.mo-tc__slot').classList.contains('is-cur')) { formMsg(form, '바꿀 시간을 골라 주세요.'); return; }
			// 확인창 글 = 「변경 후 시간」만(「· 결제 금액은 그대로입니다.」 뺌 — 2026-10-22 대표 지시)
			Swal.fire({ title: '시간을 변경할까요?', text: '변경 후 ' + gt.closest('.mo-tc__slot').querySelector('.mo-tc__time').textContent, showCancelButton: true, confirmButtonText: '시간 변경', cancelButtonText: '닫기' })
				.then(function (r) { if (r.isConfirmed) send('td'); });
			return;
		}
		var why = panel.querySelector('input[name=qa_r]:checked'), q = panel.querySelector('[name=qa_q]');
		if (!why) return bad(panel.querySelector('input[name=qa_r]'), '취소 사유를 골라 주세요.');
		if (why.value === '기타' && !$.trim(q.value)) return bad(q, '취소 사유를 입력해 주세요.');
		if (!bankOk('arr_refund_bank[]')) return;
		Swal.fire({
			title: '정말 취소하시겠습니까?',
			// 안내 글을 줄마다(2026-10-20 대표 지시 — text 로 넣으면 줄바꿈이 빈칸으로 붙었다) · 글자만 이스케이프한 뒤 줄바꿈 → <br>
			html: panel.querySelector('.mo-qa-cancel .cancel-msg').innerText.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n+/g, '<br>'),
			showCancelButton: true,
		}).then(function (r) { if (r.isConfirmed) send('cu'); });
	});
}

// @ui:done
// ── 언어 예약 내역 (page/lang-done.php — 2026-10-17 대표 지시 「예약을 취소할 수 있도록」 · 결정 「안내 확인 후 바로 취소」) ──────────
//   [예약 취소] → 확인창(환불 금액) → page/ajax_lang_my.php w=lc(그 언어 — langPost) → 결과 안내창 → 새로 읽음(상태 카드가 취소로)
//   안내사항(필독사항·환불약관)은 펼친 채 — [접기]·[보기] 로만 바뀐다(예약 내역과 같은 단추)
function langDone() {
	var page = document.getElementById('dn-page');
	if (!page) return;
	page.addEventListener('click', function (e) {
		var v = e.target.closest('.od-terms__view'), doc = v && document.getElementById(v.getAttribute('aria-controls'));
		if (!doc) return;
		var open = v.getAttribute('aria-expanded') !== 'true';
		doc.hidden = !open;
		v.setAttribute('aria-expanded', open ? 'true' : 'false');
		v.firstElementChild.textContent = open ? __('접기') : __('보기');
	});
	var go = page.querySelector('.dn-cancel__go'), id = page.getAttribute('data-id');
	if (!go || !id) return;
	go.addEventListener('click', function () {
		Swal.fire({
			title: __('예약을 취소할까요?'),
			text: __('환불 금액') + ' : ' + go.getAttribute('data-refund'),
			showCancelButton: true,
			confirmButtonText: __('예약 취소'),
			cancelButtonText: __('닫기'),
		}).then(function (r) {
			if (!r.isConfirmed) return;
			go.disabled = true;
			$.post('/page/ajax_lang_my.php', langPost({ w: 'lc', id: id }), function (d) {
				Swal.fire({ title: d && d.msg ? d.msg : __('연결이 끊겼습니다. 다시 시도해 주세요.') }).then(function () { location.reload(); });
			}, 'json').fail(function () {
				go.disabled = false;
				Swal.fire({ title: __('연결이 끊겼습니다. 다시 시도해 주세요.') });
			});
		});
	});
	window.addEventListener('pageshow', function (e) { if (e.persisted) go.disabled = false; });   // 뒤로가기로 되살아난 페이지 — 잠긴 단추 풀기(2026-10-12 규칙)
}

// ── 예약조회 (2026-10-10 — 옛 창·화면 안 스크립트를 옮김) ─────────────────────────
//   헤더 「예약조회」 창(page/ajax_login.php w=f — 구매자명 · 휴대폰번호) → w=li 가 돌려준 조회결과 목록으로 창 안을 바꾼다
//   문자 링크 조회 화면(page/myorder-login.php — 예약번호 · 구매자명) → w=my 가 돌려준 암호 예약번호로 예약 내역
//   빠진 칸 = 그 칸 아래 빨간 글(fieldMsg) · 결과 안내(일치하는 예약 없음 · 3개월 지남) = 조회 단추 위 상자(formMsg)
function findForms() {
	var reHp = /^01[016789]-?\d{3,4}-?\d{4}$/;
	$(document).on('submit', 'form[name=form_login]', function (e) {
		e.preventDefault();
		var form = this, name = form.elements.lo_name, hp = form.elements.lo_hp;
		if ($.trim(name.value).length < 2) { fieldMsg(name, '두 글자 이상 입력하세요.'); name.focus(); return; }
		if (!reHp.test($.trim(hp.value))) { fieldMsg(hp, '휴대폰번호를 정확히 입력하세요.'); hp.focus(); return; }
		formMsg(form, '');
		$.post('/page/ajax_login.php', $(form).serialize(), function (data) {
			if (data == 99) formMsg(form, '일치하는 예약내역이 없습니다.<br>성함과 휴대폰번호를 다시 확인해 주세요.<br>예약하신 웹사이트가 다르면 그곳에서 조회해 주세요.');
			else if (data == 98) formMsg(form, '이용일부터 3개월이 지나면 예약을 조회할 수 없습니다.');
			else $(form).closest('.mo-login').html(data);
		});
	});
	$(document).on('submit', 'form[name=form_mylogin]', function (e) {
		e.preventDefault();
		var form = this, name = form.elements.my_name;
		if ($.trim(name.value).length < 2) { fieldMsg(name, '두 글자 이상 입력하세요.'); name.focus(); return; }
		formMsg(form, '');
		$.post('/page/ajax_login.php', $(form).serialize(), function (data) {
			if (data.code == 100) location.href = '/page/myorder.php?enc_id=' + data.result;
			else formMsg(form, data.result);
		}, 'json');
	});
}

// @ui:ticket
// ── 티켓예매 창 (2026-10-09 새로 — 대표 결정 「단계형」) ────────────────────────────────────────
//   ① 코스 → ② 날짜 → ③ 시간 → ④ 인원·확인(2026-10-09 대표 지시 — 처음엔 날짜·시간·인원 셋). ①② 는 한 화면: 위 코스 칩 한 줄(코스 전체 + 코스마다, 넘치면 옆으로 밀기) · 아래 달력(고른 코스의 운항일만)
//   머리 = 단계 표시(지난 단계를 누르면 돌아감) + 요약(코스 · 날짜 · 시간 — 누르면 그 단계) · 아래 고정 줄 = 총 n명 · 금액 · 예약하기
//   들어온 곳 — 배시간표 시간(날짜·회차) → ④ · 코스상세 「예약하기」(코스) → ① 그 코스가 켜진 채(바꿀 수 있음) · 거기에 검색 날짜(코스안내 검색 → 코스상세 ?date=)까지 → ③ 시간 · 휴대폰 메뉴 → ① 코스 전체
//   안쪽 단계 번호 st.step = 1 코스·날짜 화면 · 2 시간 · 3 인원(화면 단계 표시는 renderSteps 가 넷으로 바꿔 그린다)
//   자료는 page/ajax_cart.php w=s0 가 <script type="application/json" id="bk-data">(arr_schedule — 배시간표와 같은 규칙), 요금은 시간을 고를 때 w=s3, 예약하기 = w=up(서버가 금액을 다시 계산) → order.php
//   달력 날짜 칸 = 배시간표 날짜 칸 모양(2026-10-09 대표 지시 — 헤더 검색 달력도 같게): 둥근 칸 · 아래 색 줄 = 가격 구간 · 마감 = 회색 칸 + 「마감」 · 오픈 전 숫자에 줄 · 오늘 = 녹색 테두리 + 「오늘」 · 고른 날 = 대표색 칸
//     한 달씩(PC·휴대폰 — 2026-10-09 대표 지시, 처음엔 PC 두 달) · ‹ › 또는 손가락 좌우 밀기(휴대폰)로 옆으로 미끄러지며 넘김 · 예약이 열린 마지막 달 + 2 까지(배시간표 날짜 띠와 같게 — 오픈 전 달도 볼 수 있게)
//   알림은 모두 창 안(대표 결정 — 2026-10-09 토스트 없앰): 마감일·출항 없는 날·예약할 날 없는 코스 → 달력 아래 상자 · 오픈 전 → 범례 줄(배시간표와 같은 문장) / 마감 시간 → 그 코스 시간 아래 상자
//     / 코스 안내·당일·전날 취소수수료 → ④ 맨 위 상자 / 인원 한도·예약하기 실패 → 요금 목록 아래 상자(faresMsg)
//   서버 글자(상점명·상품명·마감 사유·요금 이름·코스 안내)는 서버가 HTML 로 만든 것(get_text · rich_html)을 그대로 넣는다
function booking(root) {
	var el = root.querySelector('#bk-data');
	if (!el) return;
	var D;
	try { D = JSON.parse(el.textContent); } catch (e) { return; }
	var body = root.querySelector('.bk-body'), stepsEl = root.querySelector('.bk-steps'), sumEl = root.querySelector('.bk-sum');
	var totalEl = root.querySelector('.bk-total'), go = root.querySelector('.bk-go');
	var CO = {};
	D.courses.forEach(function (c) { CO[c.id] = c; });
	var st = { step: 1, co: 0, date: '', gt: 0, ym: '', msg: '', at: 0, fare: null, qty: [], busy: false };   // co = 고른 코스(0 = 코스 전체) · msg = 창 안 안내 상자(.bk-msg) · at = ③ 시간에서 그 안내가 붙을 회차(그 코스 묶음 아래)
	// 예약 형태(2026-10-19 트립 티켓 5단계 — 설계안 4-2): time 회차형 = 코스 → 날짜 → 시간 → 인원 · date 날짜형 = 코스 → 날짜 → 인원(그날 한 줄 gt — 시간 단계 건너뜀) · open 기간형 = 코스 → 인원(회차 없음 — 요금은 w=s4 · 예약하기는 coid)
	function coType(id) { var c = CO[id]; return c && c.type ? c.type : 'time'; }
	function curType() { if (st.co > 0) return coType(st.co); var f = st.gt && st.step > 2 ? findSlot(st.gt) : null; return f ? coType(f.s[1]) : 'time'; }   // 코스 전체 = 고른 회차(인원 단계)의 코스 형태 — ③ 시간 목록에서는 앞서 고른 회차가 남아 있어도 회차형(renderSum 과 같은 기준)
	function isOpen() { return curType() === 'open'; }
	function isDay() { return curType() === 'date'; }
	function badgeOf(c) { return c.badge || ''; }   // 서버가 만든 형태 표시(아이콘 · 기간형 유효기간 — lib goods_type_badge_html, 2026-10-20)

	function pad(n) { return (n < 10 ? '0' : '') + n; }
	function ymd(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
	function pd(s) { var a = s.split('-'); return new Date(+a[0], a[1] - 1, +a[2]); }
	function addDays(s, n) { var d = pd(s); d.setDate(d.getDate() + n); return ymd(d); }
	function addMonth(ym, n) { var a = ym.split('-'); return ymd(new Date(+a[0], a[1] - 1 + n, 1)).slice(0, 7); }
	function label(s) { return L10N.mdw(pd(s)); }   // 10월 20일 (화) — 언어 페이지는 그 언어 모양(L10N)
	function won(n) { return L10N.won(n); }
	function dur(m) { return L10N.dur(m); }   // 소요시간 = 「약 2시간 30분」(2026-10-11 대표 지시 — 배시간표 sc_dur() 와 같게)
	function slotsOf(date) { var a = D.slots[date] || []; return st.co ? a.filter(function (s) { return s[1] === st.co; }) : a; }   // 회차 = [회차, 코스, 시각, 마감, 자동판매마감 분, 특가] — 고른 코스만
	function findSlot(gt) {
		for (var d in D.slots) for (var i = 0; i < D.slots[d].length; i++) if (D.slots[d][i][0] === gt) return { date: d, s: D.slots[d][i] };
		return null;
	}
	function state(date) {   // past 지난날 · soon 오픈 전 · closed 마감일 · open 예매 가능 · none 운항 없음
		if (date < D.today) return 'past';
		if (!D.last || date > D.last) return 'soon';
		if (D.days[date] && D.days[date].c) return 'closed';
		return slotsOf(date).length ? 'open' : 'none';
	}
	function noneMsg() {   // 예약기간 안인데 회차가 없는 날(2026-10-09 대표 지시 — 누르면 안내)
		return '<strong>' + __('해당 일은 {w} 계획이 없습니다.', { w: W.op }) + '</strong>' + (st.co ? __('다른 코스를 선택해 주세요.') : __('다른 날짜를 선택해 주세요.'));
	}
	// ③ 시간 안내 — 토스트(화면 아래 잠깐 떴다 사라짐) 대신 창 안 상자(2026-10-09 대표 지시): 누른 시간의 코스 묶음 아래, 그 회차가 목록에 없으면 날짜 제목 아래
	var OFF_MSG = '<strong>' + __('선택하신 시간은 온라인 예약이 종료되었습니다.') + '</strong>';
	var LATE_MSG = '<strong>' + __('예약하시려고 선택하신 시간의 예약이 종료되었습니다.') + '</strong>';   // 고른 채 들어온 시간이 그사이 마감(2026-10-14 대표 지시 — lib LATE_MSG 와 같은 글)
	function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
	function showMsg() {   // 다시 그린 뒤 안내 상자가 창 본문 밖이면 보이게(그만큼만 부드럽게 내림) — 휴대폰은 달력 아래 안내가 창 아래로 밀려 안 보였다(2026-10-09 대표 지적)
		var mb = body.querySelector('.bk-msg');
		if (!mb) return;
		if (!body.clientHeight) { setTimeout(showMsg, 120); return; }   // 창이 아직 안 보일 때(열리는 중 — 처음 안내)
		var end = mb.nextElementSibling && mb.nextElementSibling.classList.contains('sch-co__notice') ? mb.nextElementSibling : mb;   // 마감 시간 안내 — 아래 「출항시간 n분 전에 온라인 예약은 마감됩니다.」까지 보이게(2026-10-10 대표 지시)
		var top = mb.getBoundingClientRect().top < body.getBoundingClientRect().top;   // 상자가 위로 가려져 있으면 상자부터
		(top ? mb : end).scrollIntoView({ block: 'nearest', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
	}
	function firstOpen() {
		var ks = Object.keys(D.slots).sort();
		for (var i = 0; i < ks.length; i++) if (state(ks[i]) === 'open') return ks[i];
		return '';
	}
	var minYm = D.today.slice(0, 7);
	var maxYm = addMonth((D.last || D.today).slice(0, 7), 2);   // 예약이 열린 마지막 달 + 2 — 배시간표 날짜 띠 끝과 같게(넘겨도 멈춘 것처럼 보이지 않게)
	function clampYm(ym) {
		if (ym > maxYm) ym = maxYm;
		if (ym < minYm) ym = minYm;
		return ym;
	}

	// 들어온 곳 — 배시간표 시간이면 ④ 인원(그사이 마감됐으면 ③ 시간 + 안내) · 코스상세면 그 코스가 켜진 채 ①(검색 날짜까지 있으면 ③) · 메뉴면 ① 코스 전체
	if (D.fix) {
		if (CO[D.fix]) st.co = D.fix;
		else st.msg = '<strong>' + __('선택하신 코스는 지금 예약할 수 있는 날짜가 없습니다.') + '</strong>' + __('다른 코스를 선택해 주세요.');   // 코스상세에서 왔는데 그 코스 회차가 하나도 없음 — 코스 전체로 열고 달력 아래 안내
	}
	if (D.pick) {
		var p = findSlot(D.pick.gt);
		if (p && p.date === D.pick.date) {
			st.date = p.date;
			if (!p.s[3]) { st.co = p.s[1]; st.gt = p.s[0]; st.step = 3; } else { st.step = 2; st.msg = LATE_MSG; st.at = p.s[0]; }   // 그사이 마감 — ③ 시간, 그 코스 묶음 아래 안내
		} else if (state(D.pick.date) === 'open') {
			st.date = D.pick.date; st.step = 2;
			st.msg = LATE_MSG; st.at = 0;   // 그 회차가 목록에서 빠짐 — 날짜 제목 아래 안내
		}
	} else if (D.date && st.co) {   // 검색 날짜 + 코스 — 그 날 그 코스가 운항하면 ③ 시간, 마감일이면 ① 에 마감 안내
		var ds = state(D.date);
		if (ds === 'open') { st.date = D.date; st.step = 2; }
		else if (ds === 'closed') st.msg = '<strong>' + __('선택하신 날은 예약이 마감되었습니다.') + '</strong>' + (D.days[D.date].i || __('다른 날짜를 선택해 주세요.'));
		else if (ds === 'none') st.msg = noneMsg();
		if (ds !== 'past') st.ym = clampYm(D.date.slice(0, 7));
	}
	if (!st.ym) st.ym = clampYm((st.date || firstOpen() || D.today).slice(0, 7));
	// 코스부터 고르기(2026-10-11 대표 결정) — 코스가 정해지지 않은 입구(떠 있는 「티켓예약」 · 휴대폰 메뉴 「티켓예약」)는 처음에 코스 목록만(코스 전체도 안 고른 채),
	//   하나를 고르면 목록이 칩 한 줄로 줄고 아래로 달력이 펼쳐진다(창이 커짐). 코스상세·배시간표·검색 날짜로 온 길은 그대로
	st.pickCo = !D.fix && !D.pick && !!firstOpen();
	st.coPicked = !st.pickCo;   // 코스를 한 번이라도 고름(목록으로 돌아오면 그 코스를 진하게)

	function coName(c) {   // 코스 칩·요약 이름 = 상점명(배시간표와 같게) — 한 상점에 코스가 둘 이상이면 상품명
		var same = 0;
		D.courses.forEach(function (x) { if (x.shop === c.shop) same++; });
		return same > 1 ? c.name : c.shop;
	}
	function renderSteps() {   // 화면 단계 — 회차형 넷(① 코스 ② 날짜 는 첫 화면 하나 · ③ 시간 · ④ 인원) · 날짜형 셋(코스 · 날짜 · 인원) · 기간형 둘(코스 · 인원) — 2026-10-19 5단계
		var ty = curType(), names = ty === 'open' ? [__('코스'), __('인원')] : ty === 'date' ? [__('코스'), __('날짜'), __('인원')] : [__('코스'), __('날짜'), __('시간'), __('인원')], h = '';
		var cur = st.step === 1 ? (st.pickCo ? 1 : 2) : (ty === 'open' ? 2 : ty === 'date' ? 3 : st.step + 1);   // 코스를 고른 뒤(코스 전체 포함) ② 날짜 · 날짜형 ③ = 인원 · 기간형 ② = 인원
		names.forEach(function (t, i) {
			var n = i + 1, inner = '<b>' + (n < cur ? '<i class="ic ic-check" aria-hidden="true"></i>' : n) + '</b><span class="bk-steps__t">' + t + '</span>';   // 글 칸 — 언어 페이지 좁은 휴대폰은 지금 단계 글만(theme.css 「언어 페이지」)
			if (i) h += '<li class="bk-steps__ln" aria-hidden="true"></li>';
			h += '<li class="' + (n === cur ? 'is-on' : n < cur ? 'is-done' : '') + '"' + (n === cur ? ' aria-current="step"' : '') + '>'
				+ (n < cur ? '<button type="button" data-go="' + (n === 1 ? 'co' : n === 2 ? 1 : 2) + '">' + inner + '<span class="visually-hidden"> ' + __('다시 고르기') + '</span></button>' : '<span>' + inner + '</span>') + '</li>';
		});
		stepsEl.innerHTML = h;
	}
	function renderSum() {   // ③ 시간 · ④ 인원 화면 위 — 코스 · 날짜 · 시간(누르면 그 단계로)
		var h = '', c, f = st.gt && st.step > 2 ? findSlot(st.gt) : null;
		c = f ? CO[f.s[1]] : (st.step > 1 && st.co ? CO[st.co] : null);
		if (c) h += '<button type="button" class="bk-chip" data-go="co"><span class="visually-hidden">' + __('코스') + ' </span><i class="sch-dot" style="background:' + c.color + '" aria-hidden="true"></i>' + coName(c) + '<small>' + __('변경') + '</small></button>';
		else if (st.step > 1) h += '<button type="button" class="bk-chip" data-go="co">' + __('코스 전체') + '<small>' + __('변경') + '</small></button>';   // 코스 전체로 날짜를 고른 ③ 시간 화면 — 코스 칩과 같은 모양(2026-10-10 대표 지시, ④ 는 고른 회차의 코스)
		if (st.date && st.step > 1 && !isOpen()) h += '<button type="button" class="bk-chip" data-go="1"><span class="visually-hidden">' + __('이용일') + ' </span>' + label(st.date) + (isDay() ? ' · ' + __('종일') : '') + '<small>' + __('변경') + '</small></button>';   // 날짜형 = 날짜 · 종일(시간 칩 없음) · 기간형 = 날짜 없음(5단계)
		if (f && !isDay() && !isOpen()) h += '<button type="button" class="bk-chip" data-go="2"><span class="visually-hidden">' + __('{w} 시간', { w: W.time }) + ' </span>' + __('{t} {w}', { t: f.s[2], w: W.time }) + '<small>' + __('변경') + '</small></button>';
		sumEl.innerHTML = h;
		sumEl.hidden = !h;
	}
	function coChips() {   // ① 코스 — 한 줄, 넘치면 옆으로 밀기(대표 결정 — 검색 바 코스 분류와 같은 방식)
		var h = '<div class="bk-cos" role="group" aria-label="' + __('코스 선택') + '"><div class="bk-cos__row">'
			+ '<button type="button" class="bk-co' + (st.co ? '' : ' is-on') + '" data-co="0" aria-pressed="' + (st.co ? 'false' : 'true') + '">' + __('코스 전체') + '</button>';
		D.courses.forEach(function (c) {
			if (c.type === 'open') return;   // 기간형은 달력이 없다 — 코스 목록(첫 화면)에서만 고른다(5단계)
			if (c.none) { h += '<button type="button" class="bk-co is-none" disabled title="' + __('현재 상품은 예정된 이용시간이 없습니다') + '"><i class="sch-dot" style="background:' + c.color + '" aria-hidden="true"></i>' + coName(c) + '</button>'; return; }   // 회차가 없는 코스 — 흐린 칩(누르지 않음)
			h += '<button type="button" class="bk-co' + (st.co === c.id ? ' is-on' : '') + '" data-co="' + c.id + '" aria-pressed="' + (st.co === c.id ? 'true' : 'false') + '">'
				+ '<i class="sch-dot" style="background:' + c.color + '" aria-hidden="true"></i>' + coName(c) + '</button>';
		});
		return h + '</div></div>';
	}
	function coRowFit(keepLeft) {   // 코스 줄 — 고른 칩이 보이게 · 가려진 쪽 끝 흐림(.is-more-l · .is-more-r)
		var box = body.querySelector('.bk-cos'), row = box && box.querySelector('.bk-cos__row');
		if (!row) return;
		if (!row.clientWidth) { setTimeout(function () { coRowFit(keepLeft); }, 120); return; }   // 창이 아직 안 보일 때(배경이 깔리는 0.15초 — 자료가 그보다 먼저 오면) 폭이 0 — 보이면 다시
		if (keepLeft) row.scrollLeft = keepLeft;
		var on = row.querySelector('.is-on');
		if (on) {
			var l = on.getBoundingClientRect().left - row.getBoundingClientRect().left + row.scrollLeft, r = l + on.offsetWidth;   // 줄 안 자리(밀어 둔 거리 더함)
			if (l < row.scrollLeft) row.scrollLeft = Math.max(0, l - 24);
			else if (r > row.scrollLeft + row.clientWidth) row.scrollLeft = r - row.clientWidth + 24;
		}
		var edge = function () {
			box.classList.toggle('is-more-l', row.scrollLeft > 2);
			box.classList.toggle('is-more-r', row.scrollLeft + row.clientWidth < row.scrollWidth - 2);
		};
		edge();
		if (!row.bkEdge) { row.bkEdge = 1; row.addEventListener('scroll', edge, { passive: true }); }
	}
	function pickCourse(id) {
		if (id === st.co) return;
		var row = body.querySelector('.bk-cos__row'), left = row ? row.scrollLeft : 0;
		st.co = id;
		st.msg = '';
		if (st.date && state(st.date) !== 'open') st.date = '';   // 새 코스가 그 날 운항하지 않으면 날짜를 비운다
		var f = st.gt ? findSlot(st.gt) : null;
		if (f && st.co && f.s[1] !== st.co) { st.gt = 0; st.fare = null; st.qty = []; }
		var a = st.ym.split('-'), n = new Date(+a[0], +a[1], 0).getDate(), has = false, i, fo;
		for (i = 1; i <= n && !has; i++) has = state(st.ym + '-' + pad(i)) === 'open';
		if (!has && (fo = firstOpen())) st.ym = clampYm(fo.slice(0, 7));   // 보던 달에 그 코스 운항일이 없으면 첫 운항 달로
		render(false, '.bk-co[data-co="' + id + '"]', left);
	}

	function month(ym) {
		var a = ym.split('-'), y = +a[0], m = +a[1], f = new Date(y, m - 1, 1).getDay(), n = new Date(y, m, 0).getDate(), i;
		var h = '<div class="bk-cal__m"><div class="bk-cal__h">'
			+ '<button type="button" class="bk-cal__nav is-prev" data-ym="-1" aria-label="' + __('이전 달') + '"' + (ym <= minYm ? ' disabled' : '') + '><i class="ic ic-chevron-left" aria-hidden="true"></i></button>'
			+ '<strong aria-live="polite">' + L10N.ym(y, m) + '</strong>'
			+ '<button type="button" class="bk-cal__nav is-next" data-ym="1" aria-label="' + __('다음 달') + '"' + (ym >= maxYm ? ' disabled' : '') + '><i class="ic ic-chevron-right" aria-hidden="true"></i></button>'
			+ '</div><div class="bk-cal__wk" aria-hidden="true">';
		for (i = 0; i < 7; i++) h += '<span class="bk-cal__w' + (i === 0 ? ' is-sun' : i === 6 ? ' is-sat' : '') + '">' + L10N.calDows[i] + '</span>';
		h += '</div><div class="bk-cal__g">';   // 날짜 칸만 손가락을 따라 옆으로 움직인다(달 이름·요일 줄은 제자리)
		for (i = 0; i < f; i++) h += '<span></span>';
		for (i = 1; i <= n; i++) {
			var date = ym + '-' + pad(i), w = (f + i - 1) % 7, s = state(date), cls = 'bk-day', aria = label(date), dd = D.days[date] || {};
			if (w === 0) cls += ' is-sun';
			if (w === 6) cls += ' is-sat';
			if (s === 'open') cls += ' is-' + (dd.s ? 'season' : dd.w ? 'end' : 'week');
			else if (s === 'closed') { cls += ' is-closed'; aria += ' ' + __('예약 마감'); }
			else if (s === 'soon') { cls += ' is-soon'; aria += ' ' + __('예약 오픈 전'); }
			else { cls += ' is-muted'; aria += ' ' + (s === 'past' ? __('지난 날') : __('{w} 계획 없음', { w: W.op })); }
			if (date === D.today) cls += ' is-today';
			if (date === st.date) cls += ' is-pick';
			h += '<button type="button" class="' + cls + '"' + (s === 'open' || s === 'closed' || s === 'none' ? ' data-date="' + date + '"' : ' disabled') + (date === st.date ? ' aria-pressed="true"' : '') + ' aria-label="' + aria + '"><span>' + i + '</span>'
				+ (s === 'closed' ? '<small>' + __('마감') + '</small>' : (date === D.today ? '<small>' + __('오늘') + '</small>' : '')) + '</button>';   // 칸 = 배시간표 날짜 칸 모양(2026-10-09) — 숫자 원 + 아래 한 줄 글(마감 · 오늘) + 맨 아래 색 줄
		}
		return h + '</div></div>';
	}
	function soonNote() {   // 보는 달에 오픈 전 날짜가 있으면 그 달의 오픈 안내(이용월의 전달 10일 — 배시간표·검색 달력과 같은 문장)
		var a = st.ym.split('-'), n = new Date(+a[0], +a[1], 0).getDate(), c = 0;
		for (var i = 1; i <= n; i++) if (state(st.ym + '-' + pad(i)) === 'soon') c++;
		if (!c) return '';
		var y = +a[0], m = +a[1];   // 글 = extend/_i18n.php i18n_soon_note() 와 같은 틀
		return __('{m}은 아직 예약이 오픈되지 않았습니다. {d} 이후 확인해 주세요.', { m: L10N.mon(m), d: L10N.md(new Date(y, m - 2, 10)) });
	}
	function coList() {   // 처음 화면 — 코스 세로 목록(코스 전체 + 코스마다 색 점 · 상품명 · 소요시간) + 안내
		var h = '<div class="bk-colist__head"><h3 class="bk-h" tabindex="-1">' + __('코스 선택') + '</h3>' + (D.courseUrl ? '<a class="bk-colist__all" href="' + D.courseUrl + '">' + __('전체코스안내') + '<i class="ic ic-chevron-right" aria-hidden="true"></i></a>' : '') + '</div><ul class="bk-colist' + (D.courses.length >= 6 ? ' is-many' : '') + '">'   // 코스 6개 이상 = 촘촘하게(PC 두 칸 · 휴대폰 낮은 줄 — 2026-10-11)
			+ '<li><button type="button" class="bk-coitem' + (st.coPicked && !st.co ? ' is-on' : '') + '" data-pick-co="0"' + (st.coPicked && !st.co ? ' aria-current="true"' : '') + '><span class="bk-coitem__txt"><b>' + __('코스 전체') + '</b><small>' + __('모든 코스의 {w}일을 함께 봅니다', { w: W.time }) + '</small></span><i class="ic ic-chevron-right" aria-hidden="true"></i></button></li>';
		D.courses.forEach(function (c) {
			var on = st.coPicked && st.co === c.id;   // 카드 = 고르기 단추(색 점 + 상품명 — 카드 가로 전체 · 오른쪽 아래 소요시간, 2026-10-11 대표 지시 — 카드마다 「코스 자세히」는 빼고 제목 줄 「전체코스안내 ›」 하나)
			h += '<li><button type="button" class="bk-coitem bk-coitem--co' + (on ? ' is-on' : '') + (c.none ? ' is-none' : '') + '"' + (c.none ? ' data-none-co="' + c.id + '" aria-expanded="false"' : ' data-pick-co="' + c.id + '"') + (on ? ' aria-current="true"' : '') + '>'
				+ '<span class="bk-coitem__name"><i class="sch-dot" style="background:' + c.color + '" aria-hidden="true"></i>' + c.name + '</span>'
				+ (c.badge || c.sep ? '<span class="bk-coitem__tags">' + badgeOf(c) + (c.sep ? '<span class="goods-sep">' + c.sep + '</span>' : '') + '</span>' : '')   // 상품명 아래 줄 왼쪽 형태 배지(날짜 지정 · 기간 내 자유 이용 — 5단계) + 「외도입장권 별도」(2026-10-12 대표 지시 — 별도 요금안내 제목, 오른쪽 = 소요시간)
				+ (c.dur > 0 ? '<span class="bk-coitem__dur"><i class="ic ic-clock" aria-hidden="true"></i><span class="visually-hidden">' + __('소요시간') + ' </span>' + dur(c.dur) + '</span>' : '')
				+ (c.none ? '<span class="bk-coitem__none" role="status" hidden>' + (c.why || __('현재 상품은 예정된 이용시간이 없습니다')) + '</span>' : '') + '</button></li>';   // 회차 없는 코스 안내 — 누르면 카드 아래 한 줄(포인트 색, 2026-10-11 대표 지시 — 처음엔 숨김) · 기간형은 매진·판매 종료 글
		});
		return h + '</ul><p class="bk-guide bk-colist__guide">' + __('이용을 원하시는 코스를 선택해 주세요.') + '</p>' + (st.msg ? '<div class="bk-msg" role="status">' + st.msg + '</div>' : '');
	}
	function growTo(fn) {   // 창 높이를 부드럽게 — 바꾸기 전 높이에서 바꾼 뒤 높이로(0.25초, 움직임 줄이기면 바로)
		var mc = root.querySelector('.modal-content'), h0 = mc ? mc.offsetHeight : 0;
		fn();
		if (!mc || reduce.matches) return;
		var h1 = mc.offsetHeight;
		if (Math.abs(h1 - h0) < 2) return;
		mc.style.overflow = 'hidden';
		mc.style.height = h0 + 'px';
		mc.offsetHeight;
		mc.style.transition = 'height .25s ease';
		mc.style.height = h1 + 'px';
		setTimeout(function () { mc.style.height = ''; mc.style.transition = ''; mc.style.overflow = ''; }, 280);
	}
	function step1() {
		if (st.pickCo) return coList();
		var h = '<h3 class="bk-h visually-hidden" tabindex="-1">' + __('코스 · 이용일 선택') + '</h3>' + coChips() + '<div class="bk-cal">' + month(st.ym) + '</div>';
		var note = soonNote();
		h += '<div class="bk-legend"><span><i class="is-week"></i>' + __('평일') + '</span><span><i class="is-end"></i>' + __('주말·공휴일') + '</span><span><i class="is-season"></i>' + __('성수기') + '</span><span><i class="is-closed"></i>' + __('마감') + '</span>'
			+ '<span class="bk-legend__open" role="status"' + (note ? '' : ' hidden') + '>' + note + '</span></div>';
		if (!firstOpen()) h += '<div class="bk-msg" role="status"><strong>' + __('지금 예약할 수 있는 날짜가 없습니다.') + '</strong>' + __('{w}가 정해지면 이곳에서 예약하실 수 있습니다.', { w: W.sched }) + '</div>';
		else if (st.msg) h += '<div class="bk-msg" role="status">' + st.msg + '</div>';
		return h;
	}
	function step2() {
		var sl = slotsOf(st.date), h = '<h3 class="bk-h" tabindex="-1">' + __('{d} {w} 시간', { d: label(st.date), w: W.time }) + '</h3>';
		var at = st.msg && st.at && sl.some(function (s) { return s[0] === st.at; }) ? st.at : 0;   // 안내가 붙을 회차 — 목록에 없으면 제목 아래
		if (st.msg && !at) h += '<div class="bk-msg" role="status">' + st.msg + '</div>';
		D.courses.forEach(function (c) {
			var cs = sl.filter(function (s) { return s[1] === c.id; }), auto = 0;
			if (!cs.length) return;
			cs.forEach(function (s) { if (s[4] > auto) auto = s[4]; });
			h += '<div class="sch-co"><div class="sch-co__head"><div><div class="sch-co__title"><h4 class="sch-co__name"><i class="sch-dot" style="background:' + c.color + '" aria-hidden="true"></i>' + c.name + '</h4>'   // 코스 머리 = 1행 상품명 · 2행 왼쪽 「외도입장권 별도」 · 오른쪽 소요시간(2026-10-12 대표 지시 — 상점명·아래 상품명 줄은 뺌)
				+ (c.sep || c.dur > 0 ? '<div class="sch-co__meta">' + (c.sep ? '<span class="goods-sep">' + c.sep + '</span>' : '')
					+ (c.dur > 0 ? '<span class="sch-co__dur"><i class="ic ic-clock" aria-hidden="true"></i><span class="visually-hidden">' + __('소요시간') + ' </span>' + dur(c.dur) + '</span>' : '') + '</div>' : '')
				+ '</div></div></div><div class="sch-times">';
			cs.forEach(function (s) {
				var tl = s[6] ? __('종일') : s[2];   // 날짜형 그날 줄 = 「종일」(5단계 — 코스 전체로 날짜를 골랐을 때 회차형과 섞여 보인다)
				h += '<button type="button" class="sch-time' + (s[3] ? ' is-off' : '') + (s[5] && !s[3] ? ' is-sale' : '') + (s[0] === st.gt ? ' is-pick' : '') + '" data-gt="' + s[0] + '"' + (s[3] ? ' aria-disabled="true"' : '')
					+ ' aria-label="' + tl + ' ' + c.name + (s[3] ? ' ' + __('온라인 예약 종료') : '') + '">' + tl + (s[5] && !s[3] ? '<em>' + esc(s[7] || __('특가')) + '</em>' : '') + '</button>';   // 특가 = 빨간 테 + 표지 「이름특가」(s[7] — tpl600)
			});
			h += '</div>' + (at && cs.some(function (s) { return s[0] === at; }) ? '<div class="bk-msg" role="status">' + st.msg + '</div>' : '')
				+ (auto ? '<p class="sch-co__notice">' + __('{w}시간 {n}분 전에 온라인 예약은 마감됩니다.', { w: W.time, n: auto }) + '</p>' : '') + '</div>';
		});
		return h;
	}
	function step3() {
		var f = st.gt ? findSlot(st.gt) : null, c = f ? CO[f.s[1]] : CO[st.co], h = '<h3 class="bk-h" tabindex="-1">' + __('인원 선택') + '</h3>';   // 기간형은 회차 없이 고른 코스(5단계)
		if (isOpen() && c.open) {   // 기간형 — 유효기간 안내(남은 기간 7일 미만이면 경고 색) · 총 수량이 있으면 남은 수
			h += '<div class="bk-open' + (c.open.warn ? ' is-warn' : '') + '" role="note"><i class="ic ic-ticket" aria-hidden="true"></i><div><strong>' + __('유효기간') + '</strong> ' + (c.open.text || '') + (c.open.rest >= 0 ? ' · ' + __('남은 수량 {n}', { n: c.open.rest }) : '')
				+ (c.open.warn && c.open.left >= 0 ? '<small>' + __('남은 기간 {n}일 — 기간이 지나면 소멸됩니다.', { n: c.open.left }) + '</small>' : '') + '</div></div>';
		}
		if (c.notice) h += '<div class="bk-note bn-html box-' + (c.box || 'basic') + '">' + c.notice + '</div>';   // 담는 상자 = 상품 수정 「달력 코스선택 공지 · 상자」(2026-10-10)
		if (D.warn && !isOpen() && (st.date === D.today || st.date === addDays(D.today, 1))) {
			h += '<div class="bk-warn box-' + (D.warnBox || 'warn') + '"><i class="ic ic-exclamation-circle" aria-hidden="true"></i><div class="bk-warn__in"><strong>' + __('중요 알림사항') + '</strong><div class="bk-warn__txt">' + D.warn + '</div></div></div>';   // 내용 = 파트너센터 홈페이지 설정 「전날·당일 예매 경고」(2026-10-09 — 서버가 거른 HTML, 모든 상품 같은 글) · 담는 상자 = 같은 줄 「상자」(2026-10-10)
		}
		if (!st.fare) return h + '<div class="bk-loading" role="status">' + __('요금을 불러오는 중…') + '</div>';
		h += '<p class="bk-guide">' + __('이용하는 모든 인원을 선택해 주세요. (유아 포함)') + '</p><ul class="bk-fares">';
		st.fare.fare.forEach(function (r, i) {
			h += '<li class="bk-fare"><div class="bk-fare__info"><div class="bk-fare__t">' + r.t + (r.i ? '<small>' + r.i + '</small>' : '') + '</div>'
				+ '<div class="bk-fare__p">' + won(r.p) + (r.c > r.p ? '<s>' + won(r.c) + '</s><em' + (st.fare.sale && r.s ? ' class="is-sale"' : '') + '>' + (st.fare.sale && r.s ? esc(st.fare.sale) : __('온라인 할인')) + '</em>' : '') + '</div></div>'   // r.s = 이 구분은 특가로 더 싸짐 — 아니면 「온라인 할인」 그대로(tpl602)
				+ '<div class="bk-cnt" data-row="' + i + '"><button type="button" data-qty="' + i + '" data-d="-1" aria-label="' + __('{t} 빼기', { t: r.t }) + '"><i class="ic ic-dash" aria-hidden="true"></i></button>'
				+ '<span aria-live="polite">0</span><button type="button" data-qty="' + i + '" data-d="1" aria-label="' + __('{t} 더하기', { t: r.t }) + '"><i class="ic ic-plus" aria-hidden="true"></i></button></div></li>';
		});
		return h + '</ul>';
	}

	function faresMsg(t) {   // ④ 인원 안내 — 요금 목록 바로 아래 상자(인원 한도 · 예약하기 실패 — 2026-10-09 토스트 대신). 빈 글이면 지운다, 다시 그리면(요금 받음·단계 바꿈) 없어진다
		var box = body.querySelector('.bk-fares + .bk-msg'), ul = body.querySelector('.bk-fares');
		if (!t) { if (box) box.remove(); return; }
		if (!ul) return;
		if (!box) {
			box = document.createElement('div');
			box.className = 'bk-msg';
			box.setAttribute('role', 'status');
			ul.insertAdjacentElement('afterend', box);
		}
		box.innerHTML = '<strong>' + esc(t) + '</strong>';
		box.style.animation = 'none';   // 같은 안내가 다시 나와도 눈에 띄게 — 나타나는 움직임을 처음부터(theme.css msg-in)
		box.offsetHeight;
		box.style.animation = '';
		showMsg();
	}
	function isqSum() { var n = 0; st.fare.fare.forEach(function (r, i) { if (r.q) n += st.qty[i] || 0; }); return n; }
	function limit(i) {   // 이 줄에 한 명 더 넣을 수 없는 까닭(없으면 '') — 옛 규칙: 줄마다 최대 인원 · 인원 셈 줄(co_is_qty) 합이 남은 좌석·최대 인원을 넘지 않게
		var F = st.fare, max = F.max > 0 ? F.max : 0, q = st.qty[i] || 0, n;
		if (max && q + 1 > max) return __('한 번에 {n}명까지 예약할 수 있습니다.', { n: max });
		if (F.fare[i].q) {
			n = isqSum();
			if (n + 1 > F.rest) return __('남은 좌석이 {n}석이라 더 선택할 수 없습니다.', { n: F.rest });
			if (max && n + 1 > max) return __('한 번에 {n}명까지 예약할 수 있습니다.', { n: max });
		}
		return '';
	}
	function syncQty() {   // 숫자·단추만 고친다(다시 그리면 누르던 단추의 초점이 사라진다)
		if (!st.fare) return;
		body.querySelectorAll('.bk-cnt').forEach(function (box) {
			var i = +box.getAttribute('data-row'), q = st.qty[i] || 0, b = box.querySelectorAll('button');
			box.querySelector('span').textContent = q;
			b[0].disabled = q < 1;
			if (limit(i)) b[1].setAttribute('aria-disabled', 'true'); else b[1].removeAttribute('aria-disabled');
		});
	}
	function renderFoot() {
		var t = '', ok = false;
		if (st.step === 1) t = st.pickCo ? __('코스를 선택해 주세요') : __('날짜를 선택해 주세요');
		else if (st.step === 2) t = __('시간을 선택해 주세요');
		else if (st.fare) {
			var n = 0, sum = 0, org = 0, saleOn = false;   // org = 할인 전 금액(정가가 판매가보다 큰 줄은 정가 — 요금 줄의 취소선 값과 같은 규칙) · saleOn = 고른 인원 가운데 특가로 더 싸진 구분이 있음(tpl602)
			st.fare.fare.forEach(function (r, i) { var q = st.qty[i] || 0; n += q; sum += q * r.p; org += q * Math.max(r.c, r.p); if (q && r.s) saleOn = true; });
			var saleT = (st.fare.sale && saleOn) ? st.fare.sale : '';
			ok = sum > 0;
			t = n ? __('총 {n}명', { n: n })
				+ (org > sum ? '<span class="bk-total__disc"><em' + (saleT ? ' class="is-sale"' : '') + '>' + (saleT ? esc(saleT) + ' −' + won(org - sum) : __('할인가')) + '</em><s><span class="visually-hidden">' + __('할인 전') + ' </span>' + won(org) + '</s></span>' : '')   // 금액 윗줄 — 할인가(포인트 색) + 할인 전 금액(회색 취소선, 2026-10-09 대표 지시)
				+ '<strong>' + won(sum) + '</strong>' : __('인원을 선택해 주세요');
		}
		totalEl.innerHTML = t;
		go.disabled = !ok || st.busy;
	}
	function render(focus, keep, coLeft) {   // focus = 새 단계 — 본문 맨 위·제목에 초점 / keep = 다시 그린 뒤 초점을 돌려줄 단추 선택자 / coLeft = 코스 줄 밀어 둔 자리
		renderSteps();
		renderSum();
		body.innerHTML = st.step === 1 ? step1() : st.step === 2 ? step2() : step3();
		if (st.step === 1) coRowFit(coLeft);
		syncQty();
		renderFoot();
		if (focus) {
			body.scrollTop = 0;
			var hd = body.querySelector('.bk-h');
			if (hd) hd.focus({ preventScroll: true });
		} else if (keep) {
			var k = body.querySelector(keep);
			if (k && k.disabled && k.classList.contains('bk-cal__nav')) k = body.querySelector('.bk-cal__nav:not(:disabled)');   // 끝 달에 닿아 잠긴 ‹ › — 반대쪽 단추로
			if (k && !k.disabled) k.focus({ preventScroll: true });
		}
	}

	function backToTimes(msg) {   // 요금을 못 받으면(그사이 마감·매진·연결 실패) ③ 시간으로 — 안내는 그 시간의 코스 묶음 아래 상자
		st.msg = '<strong>' + esc(msg || __('다시 시도해 주세요.')) + '</strong>'; st.at = st.gt;
		st.gt = 0; st.fare = null; st.qty = []; st.step = 2;
		render(true);
		showMsg();
	}
	function backToCourses(msg) {   // 기간형 요금을 못 받으면(판매 종료·매진·연결 실패) 코스 목록으로 — 안내는 목록 아래 상자(5단계)
		st.msg = '<strong>' + esc(msg || __('다시 시도해 주세요.')) + '</strong>';
		st.gt = 0; st.fare = null; st.qty = []; st.step = 1; st.pickCo = true;
		render(true);
		showMsg();
	}
	function loadFare() {
		var gt = st.gt, open = isOpen(), oco = st.co;
		$.post('/page/ajax_cart.php', langPost(open ? { w: 's4', coid: oco } : { w: 's3', id: gt }), null, 'json').done(function (r) {   // 기간형 = 상품 요금(w=s4 — 5단계)
			if (st.step !== 3 || (open ? st.co !== oco : st.gt !== gt)) return;
			if (!r || !r.ok) {
				if (open) { backToCourses(r && r.msg); return; }
				var f = findSlot(gt);
				if (f && r && r.msg) f.s[3] = 1;   // 그사이 마감 — ② 에서 흐리게
				backToTimes(r && r.msg);
				return;
			}
			var lost = !root.contains(document.activeElement) || document.activeElement === document.body;
			st.fare = r;
			if (D.pick && D.pick.qty && D.pick.gt === gt) { st.qty = D.pick.qty.slice(0, r.fare.length); D.pick.qty = null; }   // 주문서 [변경]에서 옴 — 고른 인원 그대로(2026-10-10, 처음 한 번)
			render(lost);
		}).fail(function () {
			if (st.step === 3 && (open ? st.co === oco : st.gt === gt)) { if (open) backToCourses(); else backToTimes(); }
		});
	}
	function startOpen(id) {   // 기간형 코스를 고름 — 바로 인원 단계(5단계)
		st.co = id; st.coPicked = true; st.pickCo = false; st.date = ''; st.gt = 0; st.fare = null; st.qty = []; st.msg = ''; st.step = 3;
		render(true);
		loadFare();
	}
	function pickDay(date) {   // 날짜형 — 그날 한 줄(gt)을 바로 골라 인원 단계로(시간 단계 없음, 5단계). 마감이면 안내(오늘은 당일 판매 마감 시각)
		var ds = slotsOf(date).filter(function (s) { return s[6] && s[1] === st.co; }), c = CO[st.co];
		if (!ds.length) return false;
		if (ds[0][3]) {
			st.msg = '<strong>' + (date === D.today && c && c.close ? __('오늘 판매는 {t}에 마감되었습니다.', { t: c.close }) : __('선택하신 날은 예약이 마감되었습니다.')) + '</strong>' + __('다른 날짜를 선택해 주세요.');
			render(false, '[data-date="' + date + '"]');
			showMsg();
			return true;
		}
		if (ds[0][0] !== st.gt) { st.gt = ds[0][0]; st.fare = null; st.qty = []; }
		st.date = date; st.msg = ''; st.step = 3;
		if (window.yzTrack) window.yzTrack('bk_date', st.co, date);   // 방문 기록 — 날짜형 날짜 고름(2026-10-30)
		render(true);
		if (!st.fare) loadFare();
		return true;
	}
	// ① 달 넘기기 — ‹ › 단추와 손가락 좌우 밀기(휴대폰 — 2026-10-09 대표 지시)·마우스 끌기(PC — 2026-10-31)가 같은 움직임: 날짜 칸이 옆으로 빠지고 다음 달이 반대쪽에서 들어온다
	var sliding = false, swipedAt = 0;
	var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
	function slideMonth(dir, byFinger) {   // dir +1 다음 달 · -1 이전 달
		var next = clampYm(addMonth(st.ym, dir)), g = body.querySelector('.bk-cal__g');
		if (sliding || !g) return;
		if (next === st.ym) { g.style.transition = 'transform .2s ease-out'; g.style.transform = ''; return; }
		sliding = true;
		var w = g.offsetWidth || 300;
		function swap() {
			st.ym = next;
			st.msg = '';
			render(false, byFinger ? '' : '[data-ym="' + dir + '"]');
			var ng = body.querySelector('.bk-cal__g');
			if (!ng || reduce.matches) { sliding = false; return; }
			ng.style.transition = 'none';
			ng.style.transform = 'translateX(' + (dir * w * 0.6) + 'px)';
			ng.getBoundingClientRect();   // 시작 자리를 그린 뒤 움직인다
			ng.style.transition = 'transform .24s cubic-bezier(.2,.7,.3,1)';
			ng.style.transform = '';
			setTimeout(function () { ng.style.transition = ''; sliding = false; }, 260);
		}
		if (reduce.matches) { swap(); return; }
		g.style.transition = 'transform .14s ease-in, opacity .14s ease-in';
		g.style.transform = 'translateX(' + (-dir * w * 0.6) + 'px)';
		g.style.opacity = '0';
		setTimeout(swap, 140);
	}
	(function calSwipe() {   // 손가락·마우스로 좌우 밀기 — 달력 날짜 칸에서, 세로로 밀면 창 본문 스크롤(theme.css .bk-cal touch-action: pan-y) · 마우스 끌기는 2026-10-31 대표 지시
		var id = null, x0, y0, t0, dx, axis, g;
		body.addEventListener('pointerdown', function (e) {
			if ((e.pointerType === 'mouse' && e.button !== 0) || sliding || !e.target.closest('.bk-cal__g')) return;   // 마우스는 왼쪽 단추만
			id = e.pointerId; x0 = e.clientX; y0 = e.clientY; t0 = Date.now(); dx = 0; axis = '';
			g = body.querySelector('.bk-cal__g');
		});
		body.addEventListener('pointermove', function (e) {
			if (e.pointerId !== id) return;
			var mx = e.clientX - x0, my = e.clientY - y0;
			if (!axis) {
				if (Math.abs(mx) < 8 && Math.abs(my) < 8) return;
				axis = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
				if (axis === 'x') {
					g.classList.add('is-drag');
					try { body.setPointerCapture(id); } catch (er) {}   // 마우스가 창 밖으로 나가도 끝까지 따라가고, 뗄 때 날짜가 눌리지 않게
				}
			}
			if (axis !== 'x') return;
			var can = clampYm(addMonth(st.ym, mx < 0 ? 1 : -1)) !== st.ym;
			dx = can ? mx : mx * 0.25;   // 더 갈 달이 없으면 조금만 따라오고 돌아간다
			g.style.transition = 'none';
			g.style.transform = 'translateX(' + dx + 'px)';
		});
		function end(e) {
			if (e.pointerId !== id) return;
			id = null;
			if (axis !== 'x') return;
			g.classList.remove('is-drag');
			swipedAt = Date.now();   // 민 손가락을 뗄 때 날짜가 눌리지 않게(onClick)
			var dir = dx < 0 ? 1 : -1, v = Math.abs(dx) / Math.max(1, Date.now() - t0);
			if (Math.abs(dx) > 60 || (Math.abs(dx) > 24 && v > 0.35)) slideMonth(dir, true);   // 60px 넘게 · 빠르게 휙
			else { g.style.transition = 'transform .2s ease-out'; g.style.transform = ''; }
		}
		body.addEventListener('pointerup', end);
		body.addEventListener('pointercancel', end);
	})();

	function goStep(n) {
		if (n >= st.step) return;
		st.step = n;
		st.msg = '';
		if (n === 1 && st.date) st.ym = clampYm(st.date.slice(0, 7));
		render(true);
	}

	function onClick(e) {
		var b, f, date, i, d, why;
		if ((b = e.target.closest('[data-go]'))) {
			if (b.getAttribute('data-go') === 'co') { growTo(function () { st.step = 1; st.pickCo = true; st.msg = ''; render(true); }); return; }   // ① 코스 · [코스 변경] = 코스 목록 화면(2026-10-11 대표 지시 — ② 날짜는 칩 줄 + 달력)
			goStep(+b.getAttribute('data-go'));
			return;
		}
		if ((b = e.target.closest('.bk-co[data-co]'))) { pickCourse(+b.getAttribute('data-co')); return; }
		if ((b = e.target.closest('[data-none-co]'))) {   // 회차 없는 코스 카드 — 고르지 않고 아래 안내 줄만 보임(다시 누르면 다시 나타나는 움직임)
			var nt = b.querySelector('.bk-coitem__none');
			nt.hidden = false;
			nt.style.animation = 'none'; nt.offsetHeight; nt.style.animation = '';
			b.setAttribute('aria-expanded', 'true');
			return;
		}
		if ((b = e.target.closest('[data-pick-co]'))) {   // 처음 코스 목록에서 고름 — 칩 줄 + 달력으로 펼침 · 기간형은 바로 인원(5단계)
			i = +b.getAttribute('data-pick-co');
			if (coType(i) === 'open') { growTo(function () { startOpen(i); }); return; }
			growTo(function () { st.pickCo = false; st.coPicked = true; st.co = -1; pickCourse(i); });
			return;
		}
		if ((b = e.target.closest('[data-ym]'))) {
			if (!b.disabled) slideMonth(+b.getAttribute('data-ym'));
			return;
		}
		if ((b = e.target.closest('.bk-day[data-date]'))) {
			if (Date.now() - swipedAt < 400) return;   // 달을 밀던 손가락
			date = b.getAttribute('data-date');
			if (state(date) === 'closed') {
				if (window.yzTrack) window.yzTrack('bk_sold', st.co, date);   // 방문 기록 — 마감 날을 누름(수요 초과 신호, 2026-10-30 track.js)
				st.msg = '<strong>' + __('선택하신 날은 예약이 마감되었습니다.') + '</strong>' + (D.days[date].i || __('다른 날짜를 선택해 주세요.'));
				render(false, '[data-date="' + date + '"]');
				showMsg();
				return;
			}
			if (state(date) === 'none') {   // 예약기간 안인데 그 코스(코스 전체면 모든 코스) 회차가 없는 날 — 안내만
				st.msg = noneMsg();
				render(false, '[data-date="' + date + '"]');
				showMsg();
				return;
			}
			if (st.co > 0 && isDay() && pickDay(date)) return;   // 날짜형 — 시간 단계 없이 인원으로(5단계)
			if (date !== st.date) { st.gt = 0; st.fare = null; st.qty = []; }
			st.date = date; st.msg = ''; st.step = 2;
			if (window.yzTrack) window.yzTrack('bk_date', st.co, date);   // 방문 기록 — 날짜 고름(찾는 이용일, 2026-10-30 track.js)
			render(true);
			return;
		}
		if ((b = e.target.closest('.sch-time[data-gt]'))) {
			f = findSlot(+b.getAttribute('data-gt'));
			if (!f) return;
			if (f.s[3]) {   // 마감 시간 — 그 코스 묶음 아래 안내 상자(옛 토스트, 2026-10-09 대표 지시)
				if (window.yzTrack) window.yzTrack('bk_sold', f.s[1], f.date + ' ' + f.s[2]);   // 방문 기록 — 마감 시간을 누름(2026-10-30)
				st.msg = OFF_MSG; st.at = f.s[0];
				render(false, '.sch-time[data-gt="' + f.s[0] + '"]');
				showMsg();
				return;
			}
			st.msg = ''; st.step = 3;
			if (f.s[0] === st.gt && st.fare) { render(true); return; }   // 같은 시간 — 고른 인원 그대로
			st.gt = f.s[0]; st.fare = null; st.qty = [];
			render(true);
			loadFare();
			return;
		}
		if ((b = e.target.closest('[data-qty]'))) {
			if (!st.fare || b.disabled) return;
			i = +b.getAttribute('data-qty');
			d = +b.getAttribute('data-d');
			if (d > 0 && (why = limit(i))) { faresMsg(why); return; }
			faresMsg('');
			st.qty[i] = Math.max(0, (st.qty[i] || 0) + d);
			syncQty();
			renderFoot();
			return;
		}
		if (e.target.closest('.bk-go')) submit();
	}
	// 창 틀(#mo-cart)은 페이지에 남으므로 열 때마다 처리기가 쌓이지 않게 — 지난번 것을 떼고 붙인다(쌓이면 한 번 누름에 두 번 돌았다 — 예약하기 두 번 · 안내 두 번)
	if (root.bkClick) root.removeEventListener('click', root.bkClick);
	root.bkClick = onClick;
	root.addEventListener('click', onClick);
	// 뒤로가기로 돌아온 페이지(bfcache)는 떠날 때 모양 그대로다 — 예약하기를 누르고 주문서로 떠났으면 두 번 누름 막기(st.busy)가 남아 무엇을 눌러도 예약하기가 잠긴 채였다(2026-10-11 대표님 발견)
	function onShow(e) {
		if (!e.persisted || !st.busy) return;
		st.busy = false;
		renderFoot();
	}
	if (root.bkShow) window.removeEventListener('pageshow', root.bkShow);
	root.bkShow = onShow;
	window.addEventListener('pageshow', onShow);

	function submit() {
		if (go.disabled || !st.fare) return;
		var qty = [], total = 0, sum = 0;
		st.fare.fare.forEach(function (r, i) { var q = st.qty[i] || 0; qty.push(q); total += q * r.p; if (r.q) sum += q; });
		st.busy = true;
		renderFoot();
		$.post('/page/ajax_cart.php', langPost({ w: 'up', id: st.gt, coid: isOpen() ? st.co : 0, total: total, sum: sum, qty: qty }), null, 'json').done(function (r) {   // 기간형 = 회차 없이 coid(5단계)
			if (r && r.code == 100) { location.href = r.url || ('/page/order.php?oid=' + encodeURIComponent(r.result)); return; }   // url = 그 언어의 주문서(ajax_cart.php up — 언어 페이지는 /en/order.php 등, 2026-10-17 다국어 3단계)
			if (r && r.code == 98) {   // 그사이 마감(③ 시간으로 돌아가 그 시간을 흐리게) · 좌석 모자람(이 자리 안내) — 2026-10-14 대표 지시
				st.busy = false;
				if (r.late && !isOpen()) { var lf = findSlot(st.gt); if (lf) lf.s[3] = 1; backToTimes(r.result); } else { faresMsg(r.result); renderFoot(); }
				return;
			}
			faresMsg(r && r.result ? r.result : __('다시 시도해 주세요.'));   // 서버 안내(그 언어 — 2026-10-17 부터 저장 실패에 SQL 대신 안내 글)
			st.busy = false;
			renderFoot();
		}).fail(function () {
			faresMsg(__('다시 시도해 주세요.'));
			st.busy = false;
			renderFoot();
		});
	}

	$(root).one('hidden.bs.modal', function () {
		root.removeEventListener('click', onClick);
		if (root.bkClick === onClick) root.bkClick = null;
		window.removeEventListener('pageshow', onShow);
		if (root.bkShow === onShow) root.bkShow = null;
	});

	if (st.co > 0 && isOpen()) { st.pickCo = false; st.step = 3; st.date = ''; st.gt = 0; }   // 기간형 코스상세 「예약하기」 — 바로 인원(5단계)
	else if (st.co > 0 && isDay() && st.step === 2 && st.date) {   // 날짜형 + 검색 날짜 — 그날 줄로 바로 인원
		var dsl = slotsOf(st.date).filter(function (s) { return s[6]; });
		if (dsl.length && !dsl[0][3]) { st.gt = dsl[0][0]; st.step = 3; } else { st.step = 1; st.msg = '<strong>' + __('선택하신 날은 예약이 마감되었습니다.') + '</strong>' + __('다른 날짜를 선택해 주세요.'); }
	}
	render();
	if (st.step === 3) loadFare();
	if (st.msg) showMsg();   // 들어오며 생긴 안내(예약할 날 없는 코스 · 검색 날짜가 마감일·출항 없는 날 · 고른 시간이 그사이 마감)도 보이게
}

// ── 휴대폰 아래 시트(767 이하 — theme.css 「모달 공통 틀」) — 창 머리를 아래로 끌면 닫힌다(2026-10-09, 모든 창). 본문 스크롤과 부딪히지 않게 머리에서만
function sheetDrag() {
	var mq = window.matchMedia('(max-width: 767px)');
	document.addEventListener('pointerdown', function (e) {
		if (!mq.matches || (e.pointerType === 'mouse' && e.button !== 0)) return;
		var head = e.target.closest('.modal .modal-header');
		if (!head || e.target.closest('button, a, input, select, textarea, label')) return;
		var modal = head.closest('.modal'), box = head.closest('.modal-content');
		if (!modal || !box || !modal.classList.contains('show')) return;
		var y0 = e.clientY, t0 = Date.now(), dy = 0;
		function move(ev) {
			dy = Math.max(0, ev.clientY - y0);
			box.style.transition = 'none';
			box.style.transform = dy ? 'translateY(' + dy + 'px)' : '';
		}
		function up() {
			document.removeEventListener('pointermove', move);
			document.removeEventListener('pointerup', up);
			document.removeEventListener('pointercancel', up);
			box.style.transition = 'transform 0.2s ease-out';
			if (dy > 100 || (dy > 40 && dy / Math.max(1, Date.now() - t0) > 0.6)) {   // 100px 넘게 · 빠르게 휙
				box.style.transform = 'translateY(100%)';
				$(modal).one('hidden.bs.modal', function () { box.style.transition = ''; box.style.transform = ''; });
				window.bootstrap.Modal.getOrCreateInstance(modal).hide();
			} else {
				box.style.transform = '';
			}
		}
		document.addEventListener('pointermove', move);
		document.addEventListener('pointerup', up);
		document.addEventListener('pointercancel', up);
	});
}

$(document).on('focus', '.next, .prev', function () {
	$(this).blur();
});
$(document).on('click', '.ready', function (e) {
	e.preventDefault();
	Swal.fire('서비스 준비중 입니다.');
});
$(document).on('click', '.scroll-top', function (e) {
	e.preventDefault();
	$('html, body').animate({ scrollTop: 0 }, 500);
});
$(document)
	.ajaxStart(function () { $('#preloader').show(); })
	.ajaxStop(function () { $('#preloader').hide(); });

// ── 다국어 목록 (extend/_menu.php dis_langMenu) — 여닫기는 부트스트랩 dropdown, 여기서는 준비 중인 언어 안내만 (2026-09-26)
function langMenu() {
	document.addEventListener('click', function (e) {
		var b = e.target.closest('[data-lang-soon]');
		if (!b) return;
		var msg = b.getAttribute('data-lang-soon');
		if (msg && window.toast) window.toast(msg, 'dark');
	});
}

// ── 떠 있는 단추(page/_bottom.php .scroll-util — 2026-10-08 대표 지시) ──────────────────────────
//   80px 넘게 내리면 「티켓예약」(.btn-reserve-open — 2026-10-11 옛 할인상품검색)·「네이버 예약」(.btn-naver-open — 2026-10-19 A-1, 주소가 있을 때만)·맨 위로(.scroll-top)가 함께 나타난다(옛 맨 위로 700px).
//   티켓예약 = 나타날 때 알약(.is-wide — 표 아이콘 + 글)으로 왼쪽으로 펼쳐졌다가 3초 뒤 원(대표색 · 흰 표 아이콘)으로 줄어든다(나타날 때마다). 네이버 예약 = 나타날 때 원 그대로.
//   둘 다 마우스를 올리거나 키보드 초점이 오면 펼치고, 벗어나면 줄인다. 티켓예약을 누르면 티켓예약 창(#mo-cart s0 — 휴대폰 메뉴 「티켓예약」과 같음) · 네이버 예약은 새 창 링크. 모양은 header.css
function floatBtns() {
	var top = document.querySelector('.scroll-top');
	var mqHover = window.matchMedia('(hover: hover) and (pointer: fine)');   // 마우스 기기만 펼친다 — 손가락 기기(휴대폰)는 원 그대로, 누르면 바로 창(2026-10-11 대표 지시)
	var on = null, items = [];
	function mk(btn, auto) {   // auto = 나타날 때 3초 펼침(티켓예약) · 아니면 원 그대로(네이버 예약)
		var txt = btn.querySelector('.btn-reserve-open__text, .btn-naver-open__text'), timer = 0, hold = false;
		function fit() {   // 펼친 폭 = 글 폭에 맞춤(2026-10-17 대표 지시 — 언어 페이지 번역 「Ticket Booking」 등이 120px 고정 폭을 넘쳤다) · header.css --rb-tw
			if (!txt) return;
			var w = txt.getBoundingClientRect().width;
			if (w > 0) btn.style.setProperty('--rb-tw', w.toFixed(1) + 'px');
		}
		function wide(w) { if (w) fit(); btn.classList.toggle('is-wide', w && mqHover.matches); }
		btn.addEventListener('mouseenter', function () { hold = true; wide(true); });
		btn.addEventListener('mouseleave', function () { hold = false; if (!timer) wide(false); });
		btn.addEventListener('focus', function () { try { if (btn.matches(':focus-visible')) { hold = true; wide(true); } } catch (e) {} });
		btn.addEventListener('blur', function () { hold = false; if (!timer) wide(false); });
		return {
			fit: fit,
			show: function (v) {
				clearTimeout(timer); timer = 0;
				btn.classList.toggle('show', v);
				if (v && auto) {
					wide(true);
					timer = setTimeout(function () { if (!hold) wide(false); timer = 0; }, 3000);
				} else if (!v) {
					wide(false);
				}
			}
		};
	}
	var b1 = document.querySelector('.scroll-util .btn-reserve-open'); if (b1) items.push(mk(b1, true));
	var b2 = document.querySelector('.scroll-util .btn-naver-open'); if (b2) items.push(mk(b2, false));
	function fitAll() { items.forEach(function (it) { it.fit(); }); }
	function sync() {
		var v = window.pageYOffset > 80;
		if (v === on) return;
		on = v;
		if (top) { top.style.opacity = v ? 1 : 0; top.style.visibility = v ? 'visible' : 'hidden'; }
		items.forEach(function (it) { it.show(v); });
	}
	window.addEventListener('scroll', sync, { passive: true });
	window.addEventListener('resize', fitAll);   // 휴대폰·PC 글 크기가 바뀌는 폭
	if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);   // 글꼴이 늦게 오면 다시 잼
	sync();   // 내린 채로 열린 페이지(뒤로 가기 등)도 바로 맞게
}

// ── 헤더 (page/_top.php · header.css) — 신라 허브 헤더 동작 ───────────────
//   · 대메뉴 → 검색 바 서브메뉴 (2026-09-29 대표 지시, 옛 메가메뉴 대체 — PC·태블릿, 마우스 기기):
//     대메뉴에 마우스를 올리면 검색 바 왼쪽(코스 분류 자리)이 그 대메뉴의 서브메뉴 칸(.reserve-menu[data-bar-menu])으로 바뀐다.
//     서브메뉴 칸이 없는 대메뉴(코스안내)는 코스 분류. 스크롤로 검색 바가 숨어 있었으면 위에서 내려온다.
//     헤더·검색 바 아래로 나가면 그 페이지의 기본 모양(data-rest)으로 돌아가고, 숨는 페이지면 다시 올라간다.
//   · 대메뉴 페이지(data-pin — 배시간표·공지사항 등)와 그 상세(코스상세·추천상세)의 기본 모양은 그 대메뉴의 서브메뉴(지금 페이지 칠함), 코스안내·코스상세는 코스 분류.
//   · 달력이 열리면(이용일·돋보기 버튼, 다른 코스 분류 누름, 푸터 「할인상품검색」 — 어느 길로든) 코스 분류로 바꾼다(고정 그대로). 달력을 닫으면 기본 모양으로. 휴대폰의 페이지 이름표도 같다.
//   · 검색 바는 스크롤 방향으로 — 내리면 헤더 뒤로 올라가 숨고(.is-hidden), 올리면 다시 내려온다(휴대폰 2026-10-11 · PC 첫 화면 2026-10-12 대표 지시).
//     맨 위 80px 안 · 달력이 열림 · 휴대폰 서브메뉴를 펼침 · PC 대메뉴를 올려 봄이면 늘 보임.
//     단 PC(마우스) 서브 페이지(data-tuck — 첫 화면이 아닌 페이지)는 처음부터 숨어 있고 대메뉴를 올려 볼 때·달력이 열릴 때만 내려온다(.is-shown), 스크롤로는 안 바뀐다(2026-10-12 대표 지시).
//     터치 태블릿·휴대폰은 올려 보기가 없어 스크롤 방향 그대로.
//     떠 있는 단추(floatBtns — 맨 위로 위)는 2026-10-11 부터 「티켓예약」.
//   · 휴대폰: 메뉴 버튼 → 부트스트랩 오프캔버스 #mobileMenu (아래 휴대폰 메뉴). 검색 바는 대메뉴 페이지면 페이지 이름표(누르면 서브메뉴), 아니면 코스 분류.
function header() {
	var hd = document.getElementById('siteHeader');
	if (!hd) return;
	var bar = document.getElementById('reserveBar');
	var menu = hd.querySelector('.main-menu');
	var items = hd.querySelectorAll('.main-menu > li');
	var mqPC = window.matchMedia('(min-width: 768px)');                       // 대메뉴·서브메뉴 칸이 있는 폭
	var mqMouse = window.matchMedia('(hover: hover) and (pointer: fine)');    // 올려 보기는 마우스 기기만 — 손가락은 누르면 그 대메뉴 첫 페이지로 간다
	var rest = bar ? (bar.getAttribute('data-rest') || 'search') : 'search';   // 이 페이지의 기본 모양 (extend/_menu.php bar_rest)
	var tuck = !!(bar && bar.hasAttribute('data-tuck'));   // PC(마우스) 서브 페이지 — 처음부터 숨어 있다가 올려 볼 때만(2026-10-12)
	var peek = null;          // 올려 보고 있는 대메뉴 li
	var peekTimer = null;
	var searching = false;    // 달력이 열려 있는 동안 — 검색 바는 코스 분류, 올려 보기는 쉰다

	var lastY = window.pageYOffset;
	function onScroll() {   // 내리면 숨고 올리면 나온다. 6px 넘게 움직였을 때만(손가락·휠 떨림) · 아래 끝 튕김은 무시
		if (!bar) return;
		var y = window.pageYOffset, dy = y - lastY, end = document.documentElement.scrollHeight - window.innerHeight;
		if (tuck && mqPC.matches && mqMouse.matches) {   // PC(마우스) 서브 페이지 — 올려 볼 때·달력이 열릴 때만 내려온다, 스크롤로는 안 바뀜
			var show = !!(peek || searching);
			bar.classList.toggle('is-shown', show);
			bar.classList.toggle('is-hidden', !show);
			lastY = y;
			return;
		}
		bar.classList.remove('is-shown');
		if (y <= 80 || searching || peek || bar.classList.contains('is-page-open')) { bar.classList.remove('is-hidden'); lastY = y; return; }
		if (y > end) return;
		if (dy > 6) bar.classList.add('is-hidden');
		else if (dy < -6) bar.classList.remove('is-hidden');
		if (Math.abs(dy) > 6) lastY = y;
	}
	window.addEventListener('scroll', onScroll, { passive: true });
	mqPC.addEventListener('change', function () { peekEnd(); onScroll(); });
	mqMouse.addEventListener('change', onScroll);
	onScroll();

	// 검색 바 왼쪽 — 'search' = 코스 분류, 그 밖 = 대메뉴 키(서브메뉴 칸이 없으면 코스 분류). 바뀌는 모양은 header.css
	function setMode(m) {
		if (!bar) return;
		if (m !== 'search' && !bar.querySelector('.reserve-menu[data-bar-menu="' + m + '"]')) m = 'search';
		bar.classList.toggle('is-menu', m !== 'search');
		if (m === 'search') bar.classList.remove('is-page-open');   // 휴대폰 펼친 서브메뉴는 코스 분류로 바뀌면 닫는다(barPage)
		bar.querySelectorAll('.reserve-menu').forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-bar-menu') === m); });
	}

	// 올려 보기 시작·끝
	function peekStart(li) {
		clearTimeout(peekTimer);
		peekTimer = null;
		var a = li.querySelector(':scope > a');
		if (!a || searching) return;
		peek = li;
		items.forEach(function (x) { x.classList.toggle('is-open', x === li); });
		if (menu) menu.classList.add('is-peek');
		setMode(a.getAttribute('data-menu'));
		onScroll();   // 숨어 있었으면 위에서 내려온다 (header.css .reserve-bar top 0.3초)
	}
	function peekEnd() {
		clearTimeout(peekTimer);
		peekTimer = null;
		if (!peek) return;
		peek = null;
		items.forEach(function (x) { x.classList.remove('is-open'); });
		if (menu) menu.classList.remove('is-peek');
		setMode(rest);
		lastY = window.pageYOffset;   // 올려 보던 동안 내려와 있던 검색 바는 그대로 — 다음에 내리면 숨는다
		onScroll();   // PC(마우스) 서브 페이지는 다시 올라간다
	}

	items.forEach(function (li) {
		var a = li.querySelector(':scope > a');
		if (!a) return;
		a.addEventListener('mouseenter', function () {
			if (!mqMouse.matches || !mqPC.matches) return;
			clearTimeout(peekTimer);
			// 처음 올릴 땐 60ms, 이미 보고 있으면 120ms 머물러야 바꾼다 — 대메뉴 줄을 스쳐 지나가거나 비스듬히 내려갈 때 옆 대메뉴로 바뀌지 않게
			peekTimer = setTimeout(function () { peekStart(li); }, peek ? 120 : 60);
		});
		a.addEventListener('mouseleave', function () {
			clearTimeout(peekTimer);
			peekTimer = null;
		});
		a.addEventListener('focus', function () {   // 키보드 — Tab 으로 대메뉴에 오면 바로 보인다
			if (mqPC.matches) peekStart(li);
		});
	});
	// 헤더 + 검색 바(내려온 자리) 아래로 나가면 끝 — 검색 바 바깥 여백은 클릭이 통과하는 투명 영역이라 요소가 아닌 높이로 잰다
	document.addEventListener('mousemove', function (e) {
		if (!peek) return;
		if (e.clientY > hd.getBoundingClientRect().bottom + (bar ? bar.offsetHeight : 0)) peekEnd();
	}, { passive: true });
	document.documentElement.addEventListener('mouseleave', peekEnd);   // 창 밖으로(주소창 쪽)
	document.addEventListener('focusin', function (e) {
		if (peek && !hd.contains(e.target) && !(bar && bar.contains(e.target))) peekEnd();
	});
	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape' && peek) peekEnd();
	});
	window.addEventListener('pageshow', function (e) {   // 뒤로가기로 돌아온 페이지(bfcache)는 떠날 때 모양 그대로다 — 서브메뉴를 누르고 떠났으면 올려 보던 대메뉴가 남아 있다
		if (e.persisted) peekEnd();
	});

	// 달력이 열리면 검색 — 서브메뉴·이름표였으면 코스 분류로 바꾸고, 올려 보던 대메뉴는 끝낸다(검색 바는 그 자리에 고정).
	//   달력을 여는 길(이용일·돋보기 버튼, 다른 코스 분류 누름, 푸터 「할인상품검색」)이 여럿이라 달력 창이 열리는 순간(show.bs.offcanvas) 한 곳에서 한다 (2026-09-29)
	function openSearch() {
		clearTimeout(peekTimer);
		peekTimer = null;
		if (peek) {
			peek = null;
			items.forEach(function (x) { x.classList.remove('is-open'); });
			if (menu) menu.classList.remove('is-peek');
		}
		searching = true;
		setMode('search');
		onScroll();
	}
	if (bar) {
		document.querySelectorAll('[data-reserve-cal]').forEach(function (a) {   // 푸터 「할인상품검색」(2026-10-02) — 검색 바를 내리고 이용일 달력도 함께(떠 있는 단추는 2026-10-11 「티켓예약」으로 바뀜)
			a.addEventListener('click', function (e) {
				e.preventDefault();
				document.dispatchEvent(new CustomEvent('yz:reserve-cal-open'));
			});
		});
		var calPanel = document.getElementById('reserveCal');
		if (calPanel) {
			calPanel.addEventListener('show.bs.offcanvas', openSearch);
			calPanel.addEventListener('hidden.bs.offcanvas', function () {   // 달력을 닫으면 기본 모양으로 — 검색 바는 다음 스크롤 때 숨는다(PC 서브 페이지는 바로 올라간다)
				if (!searching) return;
				searching = false;
				setMode(rest);
				onScroll();
			});
		}
	}

	// 휴대폰 메뉴 — 부트스트랩 오프캔버스(오른쪽, _top.php data-bs-toggle). 여닫기·스크롤 잠금·Esc·초점은 부트스트랩이 한다 (2026-09-27)
	//   2026-10-14 대표 지시로 새로: 대메뉴 접고 펴기(하나씩 — 앞의 것은 닫힘) · 「오늘 출항」은 메뉴를 열 때 불러옴(page/ajax_today.php — 1분 안에 다시 열면 그대로)
	//   오늘 출항 시간을 누르면 메뉴를 닫고 예약 창(배시간표와 같음 — 날짜·회차를 고른 채 ④ 인원) · 마감 시간은 그 코스 아래 안내 상자 · 「코스 자세히」는 메뉴를 닫고 코스상세 창(coursePanel)
	var mm = document.getElementById('mobileMenu');
	if (mm) {
		var mmHide = function () { window.bootstrap.Offcanvas.getOrCreateInstance(mm).hide(); };
		var today = mm.querySelector('.mm-today'), tdAt = 0, tdReq = 0;
		var tdLoad = function () {
			if (!today || Date.now() - tdAt < 60000) return;
			var n = ++tdReq;
			fetch(today.getAttribute('data-src'), { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
				.then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
				.then(function (h) { if (n !== tdReq) return; today.innerHTML = h; tdAt = Date.now(); })
				.catch(function () {
					if (n !== tdReq) return;
					var w = today.querySelector('.mm-today__wait');
					if (w) w.textContent = '오늘 ' + josa(W.sched, '를') + ' 불러오지 못했습니다. 이용안내 › ' + W.sched + '에서 확인해 주세요.';
				});
		};
		var tdMsg = function (t) {   // 마감 시간 안내 — 배시간표와 같은 상자(.bk-msg). t 없으면 지움
			mm.querySelectorAll('.sch-co > .bk-msg').forEach(function (m) { m.remove(); });
			if (!t) return;
			var times = t.closest('.sch-times'), m = document.createElement('div');
			m.className = 'bk-msg';
			m.setAttribute('role', 'status');
			m.innerHTML = '<strong>선택하신 시간은 온라인 예약이 종료되었습니다.</strong>';
			times.parentNode.insertBefore(m, times.nextSibling);
			var end = m.nextElementSibling && m.nextElementSibling.classList.contains('sch-co__notice') ? m.nextElementSibling : m;
			end.scrollIntoView({ block: 'nearest', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
		};
		mm.addEventListener('show.bs.offcanvas', tdLoad);
		mm.addEventListener('hidden.bs.offcanvas', function () { tdMsg(null); });
		mm.addEventListener('click', function (e) {
			if (e.target.closest('a[data-bs-toggle="modal"]')) { mmHide(); return; }   // 모달을 열면 메뉴는 닫는다 — 둘 다 초점을 가둬 부딪힌다
			var top = e.target.closest('button.mobile-menu__top');
			if (top) {   // 대메뉴 접고 펴기 — 하나씩
				var g = top.closest('.mobile-menu__group'), open = !g.classList.contains('is-open');
				mm.querySelectorAll('.mobile-menu__group.is-open').forEach(function (x) {
					if (x === g) return;
					x.classList.remove('is-open');
					x.querySelector('.mobile-menu__top').setAttribute('aria-expanded', 'false');
				});
				g.classList.toggle('is-open', open);
				top.setAttribute('aria-expanded', open ? 'true' : 'false');
				if (open) setTimeout(function () { g.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, 260);   // 펼친 페이지들이 화면 아래로 넘치면 보이게
				return;
			}
			var t = e.target.closest('.mm-today .sch-time');
			if (t) {
				tdMsg(null);
				if (t.classList.contains('is-off')) { tdMsg(t); return; }
				mmHide();
				var $c = $('.do-cart');   // 예약 창(page/_modal.php — 배시간표와 같은 길)
				$c.data('id', t.getAttribute('data-id')).data('gt', t.getAttribute('data-gt'));
				$c[0].click();
				return;
			}
			if (e.target.closest('.mm-today .sch-co__more a')) mmHide();   // 코스상세 창은 coursePanel 이 연다(문서 처리기 — 이 처리기 다음)
		});
		window.addEventListener('resize', function () { if (window.innerWidth > 767 && mm.classList.contains('show')) mmHide(); });
	}
}

// ── 텍스트 로고 맞춤 — 가장 긴 줄이 로고 폭 상한(헤더의 40% / 휴대폰은 화면 폭 − 버튼)보다 길면 --logo-fit 으로 줄인다. 높이는 안 줄인다(겹침 허용, 행에서 잘림). 서체 로드 뒤·창 크기 바뀔 때 다시 ───
function logoFit() {
	var logos = document.querySelectorAll('[data-logo-fit]');
	if (!logos.length) return;
	function fit() {
		logos.forEach(function (lg) {
			var box = lg.closest('.site-logo') || lg.parentElement;
			var lines = lg.querySelectorAll('.site-logo__l0, .site-logo__l1, .site-logo__l2');
			if (!box || !lines.length) return;
			lg.style.setProperty('--logo-fit', '1');
			// 폭 상한 = .site-logo 의 실제 폭. 글자가 넘치면 상자는 max-width(40% / 휴대폰 calc)에 걸려 그 값이 되고, 안 넘치면 글자 폭 그대로라 줄일 일이 없다
			var max = box.clientWidth;
			if (!(max > 0)) return;
			var w = 0;
			lines.forEach(function (el) { w = Math.max(w, el.scrollWidth); });
			// 0.97 = 반올림 여유 — header.css 가 글자 크기를 정수 px 로 반올림해 조금 커질 수 있어, 그만큼 덜 채운다 (2026-09-26, 320px 에서 양끝 3px 잘림)
			if (w > max) lg.style.setProperty('--logo-fit', String(Math.max(0.5, max / w * 0.97)));
		});
	}
	fit();
	if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
	window.addEventListener('resize', fit);
}

// ── 예매 바 (page/_reserve_bar.php) — 서비스분류 + 날짜 → 코스안내 검색 (2026-09-26) ───
//   폼(GET course.php)이라 검색 자체는 스크립트 없이 된다. 여기서 하는 일:
//   · 고른 분류 칸에 .is-active (:has 를 모르는 브라우저용)
//   · 분류가 넘치면 원형 화살표 표시(PC). 누르면 보이는 폭의 80%만큼 부드럽게 넘긴다. 휴대폰은 손가락으로 넘긴다(CSS 가 화살표를 감춤)
//   · 처음 열 때 고른 분류가 가려져 있으면 보이는 곳으로 옮긴다
//   · 「전체」(값 없음)면 주소에 빈 cat= 이 붙지 않게 보내기 직전에 뺀다
// 휴대폰 검색 바 — 대메뉴 페이지(배시간표 등)의 이름표 [지금 페이지 ›]를 누르면 그 대메뉴 서브메뉴가 오른쪽으로 펼쳐진다(코스안내 접힌 칸과 같은 모양·닫힘) — 2026-10-07 대표 지시
function barPage() {
	var bar = document.getElementById('reserveBar');
	var btn = bar && bar.querySelector('.reserve-page');
	var list = bar && bar.querySelector('.reserve-menu.is-on .reserve-menu__list');
	if (!btn || !list) return;
	var pill = btn.querySelector('.reserve-page__name') || btn;   // 보이는 검은 알약 — 단추는 남는 폭까지 늘어나 있다(빈 곳을 눌러도 펼침)
	var mqPhone = window.matchMedia('(max-width: 767px)');
	function set(open) {
		if (open) {
			bar.style.setProperty('--rp-left', (pill.offsetLeft + pill.offsetWidth + 8) + 'px');   // 알약과 8px 띄운다 — 코스안내 「코스 전체」 칸 자리(2026-10-07 대표 지적: 단추 폭으로 재서 사이가 비었다)
			var c = list.querySelector('.is-current');
			list.scrollLeft = 0;
			if (c && c.offsetLeft + c.offsetWidth > list.clientWidth - 24) list.scrollLeft = c.offsetLeft + c.offsetWidth - list.clientWidth + 24;   // 지금 페이지가 가려질 때만 민다(앞 칸은 그대로 보이게)
		}
		bar.classList.toggle('is-page-open', open);
		btn.setAttribute('aria-expanded', open ? 'true' : 'false');
		if (open) fade();
	}
	function fade() {   // 가려진 쪽 끝만 흐리게(코스 분류 목록과 같음 — 「더 있다」)
		var max = list.scrollWidth - list.clientWidth;
		list.classList.toggle('is-fade-l', list.scrollLeft > 1);
		list.classList.toggle('is-fade-r', list.scrollLeft < max - 1);
	}
	list.addEventListener('scroll', fade, { passive: true });
	btn.addEventListener('click', function () { set(!bar.classList.contains('is-page-open')); });
	document.addEventListener('click', function (e) {
		if (bar.classList.contains('is-page-open') && !btn.contains(e.target) && !list.contains(e.target)) set(false);
	});
	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape' && bar.classList.contains('is-page-open')) { set(false); btn.focus(); }
	});
	mqPhone.addEventListener('change', function () { set(false); });
}

function reserveBar() {
	var bar = document.getElementById('reserveBar');
	if (!bar) return;
	var form = bar.querySelector('form');
	var toggle = bar.querySelector('.reserve-toggle');
	var track = bar.querySelector('.reserve-toggle__track');
	var prev = bar.querySelector('.reserve-toggle__arrow--prev');
	var next = bar.querySelector('.reserve-toggle__arrow--next');
	if (!form || !toggle || !track) return;
	var cur = toggle.querySelector('.reserve-toggle__current');   // 휴대폰 접힌 칸 [지금 분류 ›]
	var curText = cur && cur.querySelector('.reserve-toggle__current-text');
	var list = toggle.querySelector('.reserve-toggle__list');
	var mqPhone = window.matchMedia('(max-width: 767px)');
	// 옆으로 밀리는 틀 — PC 는 분류 줄(track, 「코스 전체」는 왼쪽에 고정), 휴대폰은 펼친 목록 전체(「코스 전체」도 함께 밀린다, 2026-09-27 대표 지시)
	function scroller() { return (cur && list && mqPhone.matches) ? list : track; }

	function sync() {
		var name = '';
		toggle.querySelectorAll('.reserve-toggle__btn').forEach(function (lb) {
			var on = lb.querySelector('input').checked;
			lb.classList.toggle('is-active', on);
			if (on) name = lb.textContent.trim();
		});
		if (curText && name) curText.textContent = name;
		var all = toggle.querySelector('.reserve-toggle__all input');
		toggle.classList.toggle('is-all', !!(all && all.checked));   // 휴대폰 접힌 칸 — 코스 전체면 진한 바탕
		if (prev) prev.style.left = track.offsetLeft + 'px';   // PC 앞 화살표 = 목록 시작(「코스 전체」 + 간격 바로 오른쪽)
	}
	toggle.addEventListener('yz:cat-sync', sync);   // 코스안내 목록 분류 글이 고른 분류를 맞춤 — 모양만(달력·검색 안 함, 2026-10-12)
	// 휴대폰 — 접힌 칸을 누르면 목록이 그 오른쪽에서 펼쳐진다(알약 기준, 날짜 칸을 덮음). 고르거나 밖을 누르면 닫힌다 (2026-09-27)
	function setList(open) {
		if (!cur) return;
		if (open) toggle.style.setProperty('--rt-left', (cur.offsetLeft + cur.offsetWidth + 8) + 'px');   // 접힌 칸과 8px 띄운다
		toggle.classList.toggle('is-open', open);
		cur.setAttribute('aria-expanded', open ? 'true' : 'false');
		if (open) { reveal(toggle.querySelector('.reserve-toggle__btn.is-active'), false); arrows(); }
	}
	if (cur) {
		cur.addEventListener('click', function () { setList(!toggle.classList.contains('is-open')); });
		toggle.addEventListener('click', function (e) {   // 휴대폰 — 분류 영역의 빈 곳을 눌러도 연다(접힌 칸·목록 안은 각자 처리)
			if (!mqPhone.matches || e.target.closest('.reserve-toggle__current') || e.target.closest('.reserve-toggle__list')) return;
			setList(!toggle.classList.contains('is-open'));
		});
		document.addEventListener('click', function (e) {
			if (toggle.classList.contains('is-open') && !toggle.contains(e.target)) setList(false);
		});
		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape' && toggle.classList.contains('is-open')) { setList(false); cur.focus(); }
		});
		mqPhone.addEventListener('change', function () { setList(false); });
		if (list) list.addEventListener('click', function (e) {   // 이미 고른 칸을 다시 눌러도 닫는다 — 라디오는 같은 값이면 change 가 오지 않는다 (2026-09-27)
			if (e.target.closest('.reserve-toggle__btn') && toggle.classList.contains('is-open')) setTimeout(function () { setList(false); }, 0);
		});
	}
	function arrows() {
		var sc = scroller();
		var max = sc.scrollWidth - sc.clientWidth;
		var atStart = sc.scrollLeft <= 1, atEnd = sc.scrollLeft >= max - 1;
		if (prev) prev.hidden = atStart;
		if (next) next.hidden = atEnd;
		// 휴대폰 양 끝 흐림은 가려진 쪽에만 — 처음부터 왼쪽을 흐리면 첫 칸이 하얗게 덮여 보였다 (2026-09-26)
		[track, list].forEach(function (el) {
			if (!el) return;
			el.classList.toggle('is-fade-l', el === sc && !atStart);
			el.classList.toggle('is-fade-r', el === sc && !atEnd);
		});
	}
	function reveal(lb, smooth) {   // 칸이 밀리는 틀 밖이나 화살표 밑에 있으면 보이는 곳으로 (페이지는 움직이지 않게 틀만)
		var sc = scroller();
		if (!lb || !sc.contains(lb)) return;
		var pad = mqPhone.matches ? 0 : 40;   // 화살표가 겹치는 폭(header.css .reserve-toggle__arrow), 휴대폰은 화살표 없음
		var s = sc.scrollLeft, w = sc.clientWidth, to = s;
		var l = lb.getBoundingClientRect().left - sc.getBoundingClientRect().left + s, r = l + lb.offsetWidth;
		if (l < s + (s > 1 ? pad : 0)) to = Math.max(0, l - pad);
		else if (r > s + w - pad) to = r - w + pad;
		if (to !== s) sc.scrollTo({ left: to, behavior: smooth ? 'smooth' : 'auto' });
	}
	function step(dir) {
		var sc = scroller();
		sc.scrollBy({ left: dir * Math.max(84, sc.clientWidth * 0.8), behavior: 'smooth' });
	}

	// 마우스·손가락으로 고른 것인지 — 키보드 방향키는 칸을 옮길 때마다 change 가 와서, 바로 검색하면 다음 칸으로 갈 수 없다
	var byPointer = false;
	toggle.addEventListener('pointerdown', function () { byPointer = true; });
	toggle.addEventListener('change', function (e) {
		var pointer = byPointer;
		byPointer = false;
		sync();
		reveal(e.target.closest('.reserve-toggle__btn'), true);
		if (toggle.classList.contains('is-open')) setList(false);   // 휴대폰 — 고르면 목록을 닫고 접힌 칸에 이름을 보인다
		// 이 페이지에서 손님이 날짜를 고른 적이 있으면(달력에서 고름·앞 화면에서 검색한 날 — #reserveDate data-chosen) 달력 없이 그 날로 바로 검색 (2026-09-30 대표 지시).
		//   고른 적이 없으면(처음 들어와 오늘이 자동으로 골라진 채) 다른 코스를 고를 때 달력을 연다 — 날짜를 고르고 달력 안 「검색」 (2026-09-29). 같은 칸을 다시 누르면 change 가 오지 않아 그대로.
		//   달력이 이미 열려 있으면(달력을 연 채 코스를 바꿈) reserveCal 이 그냥 둔다. 키보드로 바꾸면 전처럼 달력만 연다
		var date = document.getElementById('reserveDate');
		if (pointer && date && date.value && date.hasAttribute('data-chosen')) {
			if (form.requestSubmit) form.requestSubmit();
			else { beforeSubmit(); form.submit(); }
			return;
		}
		document.dispatchEvent(new CustomEvent('yz:reserve-cal-open'));
	});
	if (prev) prev.addEventListener('click', function () { step(-1); });
	if (next) next.addEventListener('click', function () { step(1); });
	track.addEventListener('scroll', arrows, { passive: true });
	if (list) list.addEventListener('scroll', arrows, { passive: true });
	window.addEventListener('resize', arrows);
	if (document.fonts && document.fonts.ready) document.fonts.ready.then(arrows);

	function beforeSubmit() {   // 「코스 전체」면 빈 cat 을 보내지 않는다
		var all = form.querySelector('input[name="cat"][value=""]');
		if (all && all.checked) all.disabled = true;
		setTimeout(function () { if (all) all.disabled = false; }, 0);   // 뒤로가기로 돌아왔을 때 다시 쓸 수 있게
	}
	form.addEventListener('submit', beforeSubmit);

	sync();
	reveal(toggle.querySelector('.reserve-toggle__btn.is-active'), false);
	arrows();
	mqPhone.addEventListener('change', arrows);
}

// ── 검색 바 달력 (page/_reserve_bar.php · css/calendar.css · page/ajax_calendar.php) — 2026-09-26 ───
//   라이브러리: Vanilla Calendar Pro (assets/js/calendar.js → window.VCal) — 모든 페이지가 받지 않도록 날짜 상자를 처음 누를 때 불러온다.
//   고르기는 라이브러리에 맡기지 않고(selectionDatesMode:false) 여기서 규칙대로 한다.
//   · 예약기간이 설정된 날(wt_config_date 행) → 숫자 위 점(평일·주말공휴일·성수기 색), 누르면 고르고 검색 바에 넣는다(창은 열린 채 — 창 안 「검색」으로 검색. 고르기 전엔 「검색」이 흐리고 누르면 안내만, 2026-09-29)
//   · 마감일(예약현황 「해당일마감」) → 회색 바탕, 누르면 마감 메세지 안내 + 골라 둔 날짜를 비운다 (2026-09-29)
//   · 예약기간이 없는 날 → 숫자에 줄, 누르면 「아직 오픈되지 않았습니다. (그 달의 전달) 10일 이후」 안내 + 골라 둔 날짜를 비운다 (2026-09-29) — 예약은 늘 한 달 전 10일에 연다(대표 설명)
//   · 지난 날 → 누를 수 없음. 회차가 모두 마감된 날은 따로 표시하지 않고 고를 수 있다(검색 결과에서 상태를 본다)
//   창 (2026-09-27): 모든 기기에서 부트스트랩 오프캔버스 — 뒤 스크롤 잠금·배경/Esc/X 로 닫기·초점 가두기는 부트스트랩이 한다.
//     마우스 PC 는 검색 바 8px 아래 오른쪽 카드가 위에서 내려오고(.reserve-cal--drop, 헤더·검색 바 아래만 어둡게),
//     손가락 기기(pointer: coarse)·휴대폰(≤767)은 아래에서 올라온다(.offcanvas-bottom). 폭 768 이상이면 두 달, 아래는 한 달.
//     데이터는 달 단위로 받아 두고 다시 받지 않는다.
function reserveCal() {
	var wrap = document.querySelector('.reserve-item--date');
	var panel = document.getElementById('reserveCal');
	if (!wrap || !panel || !window.bootstrap) return;
	var pill = document.querySelector('.reserve-pill');
	var libPromise = null;
	function lib() {   // 달력 라이브러리를 한 번만 불러온다
		if (window.VCal) return Promise.resolve();
		if (!libPromise) libPromise = new Promise(function (ok, fail) {
			var s = document.createElement('script');
			s.src = panel.getAttribute('data-lib');
			s.onload = ok;
			s.onerror = function () { libPromise = null; fail(); };
			document.head.appendChild(s);
		});
		return libPromise;
	}
	var btn = document.getElementById('reserveDateBtn');
	var input = document.getElementById('reserveDate');
	var text = wrap.querySelector('.reserve-item__date');
	var mount = panel.querySelector('[data-cal]');
	var note = panel.querySelector('.reserve-cal__note');
	var API = panel.getAttribute('data-api');
	var TODAY = panel.getAttribute('data-today');
	var mqSheet = window.matchMedia('(max-width: 767px), (pointer: coarse)');   // 아래에서 올라올 기기 (아니면 위에서 내려오는 카드)
	var mqOne = window.matchMedia('(max-width: 767px)');                         // 한 달만 보일 폭
	var data = { open: {}, season: {}, close: {}, holi: {} }, loaded = {};
	var cal = null, opened = false;
	var sheet = window.bootstrap.Offcanvas.getOrCreateInstance(panel);
	var picked = input.hasAttribute('data-picked') ? input.value : '';   // 달력에 칠할 고른 날 — 검색 결과에서 온 날, 처음 들어오면 오늘(고를 수 있는 첫날, 2026-09-29 대표 지시). 비었으면 ''
	// 창 안 「검색」 — 검색하는 곳은 여기 하나다(검색 바 돋보기는 달력을 여는 버튼, 2026-09-29 대표 지시: 날짜를 고르고 검색).
	//   날짜를 고르기 전에는 흐리게 두고, 누르면 보내지 않고 안내만. 검색 결과에서 온 날(data-picked)이 있으면 처음부터 된다
	var go = panel.querySelector('.reserve-cal__search');
	function syncGo() {
		if (!go) return;
		go.classList.toggle('is-off', !picked);
		go.setAttribute('aria-disabled', picked ? 'false' : 'true');
	}
	if (go) go.addEventListener('click', function (e) {
		if (picked) return;
		e.preventDefault();
		say('날짜를 선택하세요.');   // 대표 지시 문구 (2026-09-29)
	});
	syncGo();

	function pad(n) { return (n < 10 ? '0' : '') + n; }
	function ymOf(y, m0) { var d = new Date(y, m0, 1); return d.getFullYear() + '-' + pad(d.getMonth() + 1); }   // m0 = 0~11, 넘쳐도 된다
	function load(y, m0, n) {
		var need = [];
		for (var i = 0; i < n; i++) { var k = ymOf(y, m0 + i); if (!loaded[k]) need.push(k); }
		if (!need.length) return Promise.resolve();
		return fetch(API + '?ym=' + need[0] + '&n=' + need.length, { credentials: 'same-origin' })
			.then(function (r) { return r.json(); })
			.then(function (j) {
				if (!j || !j.ok) return;
				need.forEach(function (k) { loaded[k] = 1; });
				j.open.forEach(function (d) { data.open[d] = 1; });
				j.season.forEach(function (d) { data.season[d] = 1; });
				Object.keys(j.close).forEach(function (d) { data.close[d] = j.close[d]; });
				Object.keys(j.holi).forEach(function (d) { data.holi[d] = j.holi[d]; });
			})
			.catch(function () {});
	}
	function stateOf(d) {
		if (!loaded[d.slice(0, 7)]) return '';
		if (d in data.close) return 'close';
		return data.open[d] ? 'open' : 'notopen';
	}
	// 날짜 비우기 — 마감일·오픈 전 날짜를 누르면(2026-09-29 대표 지시). 검색 바는 「날짜 선택」(흐린 글자), 달력의 고른 원도 지우고 창 안 「검색」은 다시 흐리게
	//   → 날짜를 새로 고르기 전에 「검색」을 누르면 「날짜를 선택하세요.」
	function unpick() {
		picked = '';
		input.value = '';
		input.removeAttribute('data-chosen');   // 날짜가 비었으니 다음에 코스를 고르면 다시 달력을 연다 (reserveBar)
		text.textContent = '날짜 선택';
		text.classList.add('is-empty');
		btn.setAttribute('aria-label', '이용일 선택 전, 달력 열어 검색');
		syncGo();
		redraw();
	}
	function say(msg) {
		note.textContent = msg;
		note.hidden = !msg;
		// 아래에서 올라오는 창은 안내만큼 위로 자란다. 화면이 너무 낮아 그래도 넘치면 창 안을 끝까지 내려 안내·검색 버튼이 보이게 (2026-09-27)
		if (msg && panel.classList.contains('offcanvas-bottom') && panel.scrollHeight > panel.clientHeight) {
			panel.scrollTo({ top: panel.scrollHeight, behavior: 'smooth' });
		}
	}
	function label(d) { var p = d.split('-'); return Number(p[1]) + '월 ' + Number(p[2]) + '일'; }

	// 날짜 칸 꾸미기 — 라이브러리가 칸을 그릴 때마다 부른다
	function deco(self, el) {
		var d = el.getAttribute('data-vc-date'), b = el.querySelector('[data-vc-date-btn]');
		if (!d || !b) return;
		var dt = new Date(d + 'T00:00:00'), w = dt.getDay(), hol = data.holi[d];
		var st = stateOf(d);
		if (!loaded[d.slice(0, 7)]) want(d.slice(0, 7));   // 아직 안 받은 달 — 화살표든 밀기든 새 달이 그려지면 받아 온다
		if (!monthTimer) monthTimer = setTimeout(checkMonth, 0);
		el.setAttribute('data-yz-day', hol ? 'hol' : (w === 0 ? 'sun' : (w === 6 ? 'sat' : '')));
		if (st) el.setAttribute('data-yz', st); else el.removeAttribute('data-yz');
		if (st === 'open') el.setAttribute('data-yz-line', data.season[d] ? 'season' : ((hol || w === 0 || w === 6) ? 'end' : 'week'));   // 마감일은 색 줄 없이 회색 칸(배시간표와 같게)
		else el.removeAttribute('data-yz-line');
		if (d === picked) el.setAttribute('data-yz-picked', ''); else el.removeAttribute('data-yz-picked');
		// 칸 = 배시간표 날짜 칸 모양(2026-10-09) — 숫자 원 + 아래 한 줄 글(마감 > 오늘 > 공휴일 이름)
		var sm = st === 'close' && d >= TODAY ? '마감' : (d === TODAY ? '오늘' : (hol ? hol.replace(/\(.*\)/, '').replace('대체공휴일', '대체휴일') : ''));   // 마감 > 오늘 > 공휴일(배시간표처럼 오늘이 먼저 — 공휴일인 것은 빨간 숫자) · 공휴일은 칸이 좁아 짧게 — 「대체공휴일(개천절)」 → 「대체휴일」. 전체 이름은 aria-label·title 에
		b.innerHTML = '<span class="vc-n">' + dt.getDate() + '</span>' + (sm ? '<small' + (sm !== '마감' && sm !== '오늘' ? ' class="is-hol"' : '') + '>' + sm + '</small>' : '');
		if (hol) b.title = hol; else b.removeAttribute('title');
		b.setAttribute('aria-label', label(d) + (hol ? ' ' + hol : '') + (st === 'close' ? ', 마감' : (st === 'notopen' ? ', 예약 오픈 전' : '')));
	}
	function onDate(e) {   // 날짜 누르기 — 라이브러리는 고르기를 끄면(selectionDatesMode:false) 클릭을 알려 주지 않아 우리가 직접 받는다
		var b = e.target.closest("[data-vc-date-btn]"), el = b && b.closest("[data-vc-date]");
		if (!el || el.hasAttribute('data-vc-date-disabled')) return;
		var d = el.getAttribute('data-vc-date'), st = stateOf(d);
		if (st === 'close') {   // 마감일 — 안내하고, 골라 두었거나 들어 있던 날짜는 비운다(아무 날도 안 고른 것처럼, 2026-09-29 대표 지시)
			unpick();
			say(data.close[d] || label(d) + '은 마감되었습니다.');
			return;
		}
		if (st === 'notopen') {   // 오픈 전 — 마감일처럼 안내하고 날짜를 비운다 (2026-09-29 대표 지시)
			unpick();
			var m = Number(d.slice(5, 7)) - 1; if (m === 0) m = 12;
			say('해당 일은 아직 예약이 오픈되지 않았습니다. ' + m + '월 10일 이후 확인해주세요.');
			return;
		}
		if (!st) return;   // 아직 데이터를 못 받은 달
		input.value = picked = d;
		input.setAttribute('data-chosen', '');   // 손님이 고른 날 — 이제 코스를 바꾸면 달력 없이 이 날로 바로 검색 (reserveBar, 2026-09-30 대표 지시)
		text.textContent = d.replace(/-/g, '.');   // 화면에는 2026.09.26 (보내는 값은 Y-m-d)
		text.classList.remove('is-empty');
		btn.setAttribute('aria-label', '이용일 ' + label(d) + ', 달력 열어 검색');
		syncGo();   // 날짜를 골랐으니 창 안 「검색」을 켠다
		say('');
		redraw();   // 창은 닫지 않는다 — 고른 원만 옮긴다. 검색은 창 안 「검색」으로 (2026-09-27 · 09-29 대표 지시 — 검색 바 돋보기는 달력을 여는 버튼)
	}
	// 넘긴 달의 데이터 받기 — 화살표(onClickArrow)만 알림이 오고 밀어서 넘기기(swipe)는 알림이 없어, 칸을 그릴 때(deco) 모자란 달을 모아 받는다.
	//   받은 뒤 칸만 다시 꾸민다 — update() 는 처음 달로 되돌려 놓아 쓰지 않는다
	var wanted = {}, wantTimer = null;
	// 다른 달로 넘어가면 안내(마감 메세지·오픈 전 안내)를 지운다 — 칸을 다 그린 뒤 보이는 첫 달이 바뀌었는지 본다 (2026-09-27 대표 지시)
	//   날짜를 골라 칸만 다시 꾸밀 때(redraw)는 달이 그대로라 안내가 남는다
	var shownYm = '', monthTimer = null;
	function checkMonth() {
		monthTimer = null;
		var el = mount.querySelector('[data-vc-date][data-vc-date-month="current"]');
		var ym = el ? el.getAttribute('data-vc-date').slice(0, 7) : '';
		if (!ym || ym === shownYm) return;
		if (shownYm) say('');
		shownYm = ym;
	}
	function want(ym) {
		wanted[ym] = 1;
		if (wantTimer) return;
		wantTimer = setTimeout(function () {
			var list = Object.keys(wanted).sort();
			wanted = {}; wantTimer = null;
			var p = list[0].split('-'), last = list[list.length - 1].split('-');
			var n = (Number(last[0]) - Number(p[0])) * 12 + (Number(last[1]) - Number(p[1])) + 1;
			load(Number(p[0]), Number(p[1]) - 1, n).then(redraw);
		}, 0);
	}
	function redraw() { mount.querySelectorAll('[data-vc-date]').forEach(function (el) { deco(null, el); }); }
	function make(mobile) {
		var base = TODAY.split('-');   // 늘 오늘이 든 달부터 — 고른 날의 달부터 열면 이번 달로 돌아오기 번거롭다 (2026-09-26 대표 지시)
		var o = {
			type: mobile ? 'default' : 'multiple',
			displayMonthsCount: mobile ? 1 : 2,   // 한 달 보기(default)는 1 이어야 한다
			monthsToSwitch: 1,
			firstWeekday: 0,
			locale: 'ko-KR',
			dateToday: TODAY,
			dateMin: TODAY,
			disableDatesPast: true,
			displayDatesOutside: false,
			displayDateMin: TODAY.slice(0, 8) + '01',
			selectionDatesMode: false,
			selectionMonthsMode: 'only-arrows',   // false 로 두면 화살표까지 숨는다 — 제목 누르기만 막고 화살표로 넘긴다
			selectionYearsMode: 'only-arrows',
			labels: { application: '이용일 달력', navigation: '달 넘기기', arrowPrev: { month: '이전 달' }, arrowNext: { month: '다음 달' }, month: '월', year: '연도', dates: '날짜' },
			selectedMonth: Number(base[1]) - 1,
			selectedYear: Number(base[0]),
			selectedTheme: 'yz',
			onCreateDateEls: deco,
			enableSwipe: true,   // 손가락·마우스로 밀어서 달 넘기기 (motion 확장, 2026-09-27 대표 요청)
			extensions: mobile ? [window.VCal.motion] : [window.VCal.months, window.VCal.motion],
		};
		var c = new window.VCal.Calendar(mount, o);
		c.init();
		return c;
	}
	// 방향 — 아래에서 올라옴(손가락 기기·휴대폰) / 검색 바 아래 카드가 위에서 내려옴(마우스 PC)
	function setMode() {
		if (opened) sheet.hide();
		var bottom = mqSheet.matches;
		panel.classList.toggle('offcanvas-bottom', bottom);
		panel.classList.toggle('reserve-cal--drop', !bottom);
		place();
	}
	// 카드 자리 — 검색 알약 오른쪽 끝에 맞추고 폭은 알약을 넘지 않게. 열 때(스크롤바가 빠지기 전) 잰다:
	//   헤더·검색 바에 .is-fixed 가 있어 부트스트랩이 스크롤바 폭만큼 오른쪽 여백을 채우므로 알약은 제자리, 창의 오른쪽 거리는 innerWidth 기준이면 맞는다
	function place() {
		if (!panel.classList.contains('reserve-cal--drop') || !pill) { panel.style.right = ''; panel.style.maxWidth = ''; return; }
		var r = pill.getBoundingClientRect();
		panel.style.right = (window.innerWidth - r.right) + 'px';
		panel.style.maxWidth = r.width + 'px';
	}
	function draw() {
		var one = mqOne.matches, base = TODAY.split('-');   // 늘 오늘이 든 달부터 (make() 와 같다)
		return Promise.all([lib(), load(Number(base[0]), Number(base[1]) - 1, one ? 1 : 2)]).then(function () {
			if (!opened) return;   // 받는 사이 닫았으면 그리지 않는다
			var want = one ? 'm' : 'p';
			if (cal && cal._yzMode !== want) { cal.destroy(); cal = null; mount.innerHTML = ''; }
			if (!cal) { cal = make(one); cal._yzMode = want; }
			else cal.set({ selectedMonth: Number(base[1]) - 1, selectedYear: Number(base[0]) }, { month: true, year: true, dates: true });
		});
	}
	function open() {
		if (opened) return;
		opened = true;
		say('');
		btn.setAttribute('aria-expanded', 'true');
		place();
		sheet.show();
		draw();
	}
	function close() {
		if (opened) sheet.hide();   // 정리는 hidden.bs.offcanvas 에서
	}
	panel.addEventListener('show.bs.offcanvas', function () {   // 배경은 검색 바 아래부터 — 달력을 연 채 검색 바에서 코스를 바꿀 수 있게 (calendar.css body.is-cal-open)
		document.body.classList.add('is-cal-open');
	});
	panel.addEventListener('hidden.bs.offcanvas', function () {   // 배경 누름·Esc·닫기 버튼·날짜 고름 모두 여기로
		opened = false;
		document.body.classList.remove('is-cal-open');
		btn.setAttribute('aria-expanded', 'false');
		btn.focus({ preventScroll: true });
	});
	btn.addEventListener('click', function () { if (opened) close(); else open(); });
	mount.addEventListener('click', onDate);
	panel.querySelector('.reserve-cal__close').addEventListener('click', close);
	window.addEventListener('resize', function () { if (opened) place(); });
	document.addEventListener('yz:reserve-cal-open', open);   // 「할인상품검색」 버튼 (header())
	mqSheet.addEventListener('change', setMode);
	mqOne.addEventListener('change', function () { if (opened) draw(); });   // 폭이 바뀌면 한 달·두 달 다시
	setMode();
}

// ── 슬라이더 (메인·추천 섹션) ─────────────────────────────
//   상단팝업 슬라이더(.swiper-gnbpopup)는 2026-09-25 헤더 리뉴얼 때 마크업을 뺐다 — 초기화도 지웠다 (2026-09-28)
function swiper() {
	new Swiper('.swiper-course', {
		slidesPerView: 'auto',
		spaceBetween: 10,
		navigation: { nextEl: '.arrow.next.course', prevEl: '.arrow.prev.course' },
		breakpoints: { 1200: { spaceBetween: 20 } },
	});
	new Swiper('.swiper-course2', {
		slidesPerView: 'auto',
		spaceBetween: 10,
		navigation: { nextEl: '.arrow.next.course2', prevEl: '.arrow.prev.course2' },
		breakpoints: { 1200: { spaceBetween: 20 } },
	});
	new Swiper('.swiper-brand', {
		slidesPerView: 'auto',
		spaceBetween: 10,
		breakpoints: { 1200: { spaceBetween: 20 } },
	});
}

// ── 승선명부 생년월일 — 숫자 6자리만(YYMMDD, 2026-10-10 · 주문서·예약조회 명부 수정 창) ──────────
$(document).on('input', 'input[name^="ru_birth"]', function () {
	var v = this.value.replace(/\D/g, '').slice(0, 6);
	if (v !== this.value) this.value = v;
});

// ── 전화번호 자동 하이픈 ───────────────────────────────────────────
$(document).on('keyup', '.auto-phone', function () {
	var b = $(this).val().replace(/-/gi, '');
	var parts = [];
	if (b.length < 3) return;
	if (b.substring(0, 2) == '02') {
		parts.push(b.substring(0, 2));
		var c = b.length >= 10 ? 6 : 5;
		parts.push(b.substring(2, c));
		if (b.length >= 6) {
			if (b.length >= 10) b = b.substring(0, 10);
			parts.push(b.substring(c, b.length));
		}
	} else {
		parts.push(b.substring(0, 3));
		if (b.length >= 4) {
			var d = b.length >= 11 ? 7 : 6;
			parts.push(b.substring(3, d));
			if (b.length >= 7) {
				if (b.length >= 11) b = b.substring(0, 11);
				parts.push(b.substring(d, b.length));
			}
		}
	}
	$(this).val(parts.filter(function (p) { return p !== ''; }).join('-'));
});

function autoComma(num) {
	return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// ── 쿠키 (메인 팝업 「오늘 하루 그만보기」) ──────────────────────────
function set_cookie(name, value, expirehours, domain) {
	var today = new Date();
	today.setTime(today.getTime() + 60 * 60 * 1000 * expirehours);
	document.cookie = name + '=' + escape(value) + '; path=/; expires=' + today.toGMTString() + ';' + (domain ? 'domain=' + domain + ';' : '');
}
function get_cookie(name) {
	var m = document.cookie.match(new RegExp('(^|;\\s*)' + name + '=([^;]*)'));
	return m ? unescape(m[2]) : '';
}
function delete_cookie(name) {
	var value = get_cookie(name);
	if (value != '') document.cookie = name + '=' + value + '; path=/; expires=' + new Date(0).toGMTString();
}

// ── 동영상 블록·메인팝업 재생 (2026-10-01 대표 지시) ──────────────────────
//   썸네일 위 재생 단추(.bn-play · .np-play — lib/channel.lib.php block_play_btn)를 누르면 그 칸에서 재생하고, 칸을 빈 곳 없이 꽉 채운다.
//   클라우드 .mp4 는 object-fit: cover(theme.css .v-fill), 유튜브는 16:9 화면을 칸보다 크게 키워 가운데(넘친 곳은 칸이 자른다 — fitYt)
(function () {
	function fitYt(box, el) {
		var w = box.clientWidth, h = box.clientHeight, r = 16 / 9;
		if (!w || !h) return;
		if (w / h > r) { el.style.width = w + 'px'; el.style.height = Math.ceil(w / r) + 'px'; }
		else { el.style.height = h + 'px'; el.style.width = Math.ceil(h * r) + 'px'; }
	}
	document.addEventListener('click', function (e) {
		var btn = e.target.closest ? e.target.closest('.bn-play, .np-play') : null;
		if (!btn) return;
		var box = btn.closest('.bn-vbox, .np-media');
		if (!box) return;
		e.preventDefault();
		var yt = btn.getAttribute('data-yt'), mp4 = btn.getAttribute('data-mp4'), el;
		if (mp4) {
			el = document.createElement('video');
			el.className = 'v-fill';
			el.controls = true;
			el.autoplay = true;
			el.playsInline = true;
			el.setAttribute('playsinline', '');
			el.src = mp4;
		} else if (yt) {
			el = document.createElement('iframe');
			el.className = 'v-yt';
			el.title = btn.getAttribute('data-title') || '동영상';
			el.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
			el.setAttribute('allowfullscreen', '');
			el.src = 'https://www.youtube-nocookie.com/embed/' + yt + '?autoplay=1&rel=0&playsinline=1';
		} else {
			return;
		}
		box.classList.add('is-playing');
		box.appendChild(el);
		btn.parentNode.removeChild(btn);
		if (yt) fitYt(box, el);
	});
	window.addEventListener('resize', function () {
		var list = document.querySelectorAll('.is-playing > .v-yt');
		for (var i = 0; i < list.length; i++) fitYt(list[i].parentNode, list[i]);
	});
})();
